import type { AspidaClient, BasicHeaders } from 'aspida';
import { dataToURLString } from 'aspida';
import type { Methods as Methods_1eh1a04 } from './v1/addresses';
import type { Methods as Methods_1ohtqbq } from './v1/advertisements';
import type { Methods as Methods_1kgccx9 } from './v1/aggregation-units-and-stores-for-purchase';
import type { Methods as Methods_1xn76h8 } from './v1/announcements';
import type { Methods as Methods_tbuhit } from './v1/announcements/_announcementId@number';
import type { Methods as Methods_1m0knhi } from './v1/announcements/_announcementId@number/read';
import type { Methods as Methods_3994zd } from './v1/announcements/read';
import type { Methods as Methods_u0fui8 } from './v1/auth/token';
import type { Methods as Methods_zq1es4 } from './v1/available-delivery-period';
import type { Methods as Methods_1m5zwn8 } from './v1/billed-amounts';
import type { Methods as Methods_16oi9wd } from './v1/billed-amounts/download';
import type { Methods as Methods_b4x3qi } from './v1/brands';
import type { Methods as Methods_ha7p8h } from './v1/buyable-lineups';
import type { Methods as Methods_d52hfy } from './v1/cart';
import type { Methods as Methods_7c5vea } from './v1/cart/count';
import type { Methods as Methods_rvg606 } from './v1/cart/delivery-date';
import type { Methods as Methods_1liyk6u } from './v1/cart/items/_itemCode@string';
import type { Methods as Methods_me969h } from './v1/cart/order';
import type { Methods as Methods_mweb26 } from './v1/cart/shipping-information';
import type { Methods as Methods_1d01kek } from './v1/categories';
import type { Methods as Methods_136mcql } from './v1/change-email';
import type { Methods as Methods_udp926 } from './v1/change-email-auth';
import type { Methods as Methods_1x7lru3 } from './v1/change-invoice-email';
import type { Methods as Methods_t9pnmg } from './v1/change-invoice-email-auth';
import type { Methods as Methods_1lgf7ie } from './v1/change-password';
import type { Methods as Methods_1gsuyod } from './v1/change-temp-password';
import type { Methods as Methods_1vqdu5a } from './v1/color-charts/_groupId@number';
import type { Methods as Methods_y82zcs } from './v1/contact';
import type { Methods as Methods_keyd9a } from './v1/ec-site-orders';
import type { Methods as Methods_1b7x3tc } from './v1/ec-site-orders/_fileId@string';
import type { Methods as Methods_1i5kvhd } from './v1/ec-site-orders/_fileId@string/download';
import type { Methods as Methods_7fy7h7 } from './v1/ec-site-orders/systemTypes';
import type { Methods as Methods_1lp91e3 } from './v1/employee/addresses';
import type { Methods as Methods_10m9hj1 } from './v1/employee/auth/token';
import type { Methods as Methods_1nepvbu } from './v1/employee/login';
import type { Methods as Methods_fuwusz } from './v1/employee/logout';
import type { Methods as Methods_9kiydr } from './v1/employee/me';
import type { Methods as Methods_152s4mw } from './v1/employee/proxy-stores';
import type { Methods as Methods_1wusb49 } from './v1/employee/proxy-stores/_storeCode@string/aggregation-units-and-stores-for-purchase';
import type { Methods as Methods_9i69og } from './v1/employee/proxy-stores/_storeCode@string/available-delivery-period';
import type { Methods as Methods_c8iaw } from './v1/employee/proxy-stores/_storeCode@string/billed-amounts';
import type { Methods as Methods_1dfta61 } from './v1/employee/proxy-stores/_storeCode@string/billed-amounts/download';
import type { Methods as Methods_973lym } from './v1/employee/proxy-stores/_storeCode@string/brands';
import type { Methods as Methods_1n26z0a } from './v1/employee/proxy-stores/_storeCode@string/cart';
import type { Methods as Methods_1nvx5yu } from './v1/employee/proxy-stores/_storeCode@string/cart/count';
import type { Methods as Methods_14ekawi } from './v1/employee/proxy-stores/_storeCode@string/cart/delivery-date';
import type { Methods as Methods_mnqxhe } from './v1/employee/proxy-stores/_storeCode@string/cart/items/_itemCode@string';
import type { Methods as Methods_99ram9 } from './v1/employee/proxy-stores/_storeCode@string/cart/order';
import type { Methods as Methods_l3vj6y } from './v1/employee/proxy-stores/_storeCode@string/cart/shipping-information';
import type { Methods as Methods_1wpbfo8 } from './v1/employee/proxy-stores/_storeCode@string/categories';
import type { Methods as Methods_1n1hi9 } from './v1/employee/proxy-stores/_storeCode@string/favorites';
import type { Methods as Methods_kkxvgg } from './v1/employee/proxy-stores/_storeCode@string/favorites/_setNo@number/_favoriteStoreCode@string';
import type { Methods as Methods_ts07ag } from './v1/employee/proxy-stores/_storeCode@string/items';
import type { Methods as Methods_l2naf9 } from './v1/employee/proxy-stores/_storeCode@string/items/_itemCode@string';
import type { Methods as Methods_19qzqs } from './v1/employee/proxy-stores/_storeCode@string/items/count';
import type { Methods as Methods_mfoyxt } from './v1/employee/proxy-stores/_storeCode@string/order-histories';
import type { Methods as Methods_1y9xd05 } from './v1/employee/proxy-stores/_storeCode@string/order-histories/_salesOrderNo@string';
import type { Methods as Methods_1byau1c } from './v1/employee/proxy-stores/_storeCode@string/order-histories/unshipped';
import type { Methods as Methods_95u1jd } from './v1/employee/proxy-stores/_storeCode@string/purchases/_downloadId@string/download';
import type { Methods as Methods_w5h37s } from './v1/employee/proxy-stores/_storeCode@string/purchases/makers';
import type { Methods as Methods_1b0j5zt } from './v1/employee/proxy-stores/_storeCode@string/purchases/makers/download';
import type { Methods as Methods_149yu87 } from './v1/employee/proxy-stores/_storeCode@string/purchases/makers/stores';
import type { Methods as Methods_91ivc8 } from './v1/employee/proxy-stores/_storeCode@string/purchases/makers/stores/download';
import type { Methods as Methods_1eg1rsb } from './v1/employee/proxy-stores/_storeCode@string/purchases/stores';
import type { Methods as Methods_ek0dck } from './v1/employee/proxy-stores/_storeCode@string/purchases/stores/download';
import type { Methods as Methods_vlzpzm } from './v1/employee/proxy-stores/_storeCode@string/purchases/stores/makers/sales-types';
import type { Methods as Methods_glrecz } from './v1/employee/proxy-stores/_storeCode@string/purchases/stores/makers/sales-types/download';
import type { Methods as Methods_7wgm9k } from './v1/employee/proxy-stores/_storeCode@string/purchases/stores/sales-types';
import type { Methods as Methods_hn88jt } from './v1/employee/proxy-stores/_storeCode@string/purchases/stores/sales-types/download';
import type { Methods as Methods_fjnb2j } from './v1/employee/proxy-stores/_storeCode@string/sales-details';
import type { Methods as Methods_107izuc } from './v1/employee/proxy-stores/_storeCode@string/sales-details/download';
import type { Methods as Methods_9xkihr } from './v1/employee/sales-types';
import type { Methods as Methods_1h48aln } from './v1/employee/unallocated-order-items';
import type { Methods as Methods_6bhzgt } from './v1/favorites';
import type { Methods as Methods_i33vyc } from './v1/favorites/_setNo@number/_storeCode@string';
import type { Methods as Methods_1yj2142 } from './v1/favorites/_setNo@number/_storeCode@string/duplicate';
import type { Methods as Methods_qgmcd7 } from './v1/favorites/_setNo@number/_storeCode@string/items';
import type { Methods as Methods_1fwrbc2 } from './v1/favorites/items';
import type { Methods as Methods_2gd440 } from './v1/invoices';
import type { Methods as Methods_1edvdju } from './v1/invoices/_invoiceId@string/download';
import type { Methods as Methods_127gk1y } from './v1/invoices/_invoiceId@string/preview';
import type { Methods as Methods_7vtnl5 } from './v1/invoices/comments/_commentId@string/read';
import type { Methods as Methods_yrhm8x } from './v1/invoices/download';
import type { Methods as Methods_1bygs33 } from './v1/invoices/histories';
import type { Methods as Methods_t48ma8 } from './v1/invoices/histories/download';
import type { Methods as Methods_19aunck } from './v1/items';
import type { Methods as Methods_1ncm5e9 } from './v1/items/_itemCode@string';
import type { Methods as Methods_lxoro8 } from './v1/items/_itemCode@string/prices';
import type { Methods as Methods_137r4s8 } from './v1/items/count';
import type { Methods as Methods_uasdn1 } from './v1/login';
import type { Methods as Methods_ca0h2u } from './v1/logout';
import type { Methods as Methods_cupold } from './v1/makers';
import type { Methods as Methods_1l15ybx } from './v1/order-histories';
import type { Methods as Methods_1k2r77n } from './v1/order-histories/_downloadId/download';
import type { Methods as Methods_1j7lyoz } from './v1/order-histories/_orderNo@string/delivery-date';
import type { Methods as Methods_1wplcw5 } from './v1/order-histories/_orderNo@string/shipping-infomation';
import type { Methods as Methods_1d6h7x5 } from './v1/order-histories/_salesOrderNo@string';
import type { Methods as Methods_zx5yb2 } from './v1/order-histories/download';
import type { Methods as Methods_kkochw } from './v1/order-histories/unshipped';
import type { Methods as Methods_1p1uf81 } from './v1/orders';
import type { Methods as Methods_k8gs2z } from './v1/orders/_orderNo@string';
import type { Methods as Methods_1su3kz1 } from './v1/orders/_orderNo@string/items/_itemCode@string';
import type { Methods as Methods_pf7t8j } from './v1/orders/approve';
import type { Methods as Methods_36jp5a } from './v1/orders/unapproved';
import type { Methods as Methods_1xtjw35 } from './v1/price-changes';
import type { Methods as Methods_1grucdw } from './v1/price-changes/_downloadId@string/download';
import type { Methods as Methods_1j88vwq } from './v1/price-changes/download';
import type { Methods as Methods_qr3kfp } from './v1/purchases/_downloadId@string/download';
import type { Methods as Methods_bu33lb } from './v1/purchases/ec-site-orders';
import type { Methods as Methods_5odokl } from './v1/purchases/ec-site-orders/_systemType@string';
import type { Methods as Methods_1hbvq4w } from './v1/purchases/ec-site-orders/download';
import type { Methods as Methods_h25ix8 } from './v1/purchases/makers';
import type { Methods as Methods_66sjad } from './v1/purchases/makers/download';
import type { Methods as Methods_1nq89o3 } from './v1/purchases/makers/stores';
import type { Methods as Methods_xctigs } from './v1/purchases/makers/stores/download';
import type { Methods as Methods_1xfuhbr } from './v1/purchases/stores';
import type { Methods as Methods_a4c4pk } from './v1/purchases/stores/download';
import type { Methods as Methods_xe55em } from './v1/purchases/stores/makers/sales-types';
import type { Methods as Methods_1lstq9j } from './v1/purchases/stores/makers/sales-types/download';
import type { Methods as Methods_j5lgc4 } from './v1/purchases/stores/sales-types';
import type { Methods as Methods_199u3kd } from './v1/purchases/stores/sales-types/download';
import type { Methods as Methods_1tr9p2q } from './v1/receipts/_receiptId@string/download';
import type { Methods as Methods_1uncd14 } from './v1/receive-email';
import type { Methods as Methods_1425bc7 } from './v1/sales-details';
import type { Methods as Methods_2ztxoo } from './v1/sales-details/download';
import type { Methods as Methods_1w4idik } from './v1/sales-types';
import type { Methods as Methods_11il3rq } from './v1/stores';
import type { Methods as Methods_4ippvp } from './v1/stores/me';
import type { Methods as Methods_u24rgi } from './v1/stores-for-invoice';
import type { Methods as Methods_1rsisys } from './v1/tests/cart/delivery-date/one-day-ago';
import type { Methods as Methods_2zofny } from './v1/user/language';
import type { Methods as Methods_z5ns5m } from './v1/user/me';

const api = <T>({ baseURL, fetch }: AspidaClient<T>) => {
  const prefix = (baseURL === undefined ? 'http://localhost:18081' : baseURL).replace(/\/$/, '');
  const PATH0 = '/v1/addresses';
  const PATH1 = '/v1/advertisements';
  const PATH2 = '/v1/aggregation-units-and-stores-for-purchase';
  const PATH3 = '/v1/announcements';
  const PATH4 = '/read';
  const PATH5 = '/v1/announcements/read';
  const PATH6 = '/v1/auth/token';
  const PATH7 = '/v1/available-delivery-period';
  const PATH8 = '/v1/billed-amounts';
  const PATH9 = '/v1/billed-amounts/download';
  const PATH10 = '/v1/brands';
  const PATH11 = '/v1/buyable-lineups';
  const PATH12 = '/v1/cart';
  const PATH13 = '/v1/cart/count';
  const PATH14 = '/v1/cart/delivery-date';
  const PATH15 = '/v1/cart/items';
  const PATH16 = '/v1/cart/order';
  const PATH17 = '/v1/cart/shipping-information';
  const PATH18 = '/v1/categories';
  const PATH19 = '/v1/change-email';
  const PATH20 = '/v1/change-email-auth';
  const PATH21 = '/v1/change-invoice-email';
  const PATH22 = '/v1/change-invoice-email-auth';
  const PATH23 = '/v1/change-password';
  const PATH24 = '/v1/change-temp-password';
  const PATH25 = '/v1/color-charts';
  const PATH26 = '/v1/contact';
  const PATH27 = '/v1/ec-site-orders';
  const PATH28 = '/download';
  const PATH29 = '/v1/ec-site-orders/systemTypes';
  const PATH30 = '/v1/employee/addresses';
  const PATH31 = '/v1/employee/auth/token';
  const PATH32 = '/v1/employee/login';
  const PATH33 = '/v1/employee/logout';
  const PATH34 = '/v1/employee/me';
  const PATH35 = '/v1/employee/proxy-stores';
  const PATH36 = '/aggregation-units-and-stores-for-purchase';
  const PATH37 = '/available-delivery-period';
  const PATH38 = '/billed-amounts';
  const PATH39 = '/billed-amounts/download';
  const PATH40 = '/brands';
  const PATH41 = '/cart';
  const PATH42 = '/cart/count';
  const PATH43 = '/cart/delivery-date';
  const PATH44 = '/cart/items';
  const PATH45 = '/cart/order';
  const PATH46 = '/cart/shipping-information';
  const PATH47 = '/categories';
  const PATH48 = '/favorites';
  const PATH49 = '/items';
  const PATH50 = '/items/count';
  const PATH51 = '/order-histories';
  const PATH52 = '/order-histories/unshipped';
  const PATH53 = '/purchases';
  const PATH54 = '/purchases/makers';
  const PATH55 = '/purchases/makers/download';
  const PATH56 = '/purchases/makers/stores';
  const PATH57 = '/purchases/makers/stores/download';
  const PATH58 = '/purchases/stores';
  const PATH59 = '/purchases/stores/download';
  const PATH60 = '/purchases/stores/makers/sales-types';
  const PATH61 = '/purchases/stores/makers/sales-types/download';
  const PATH62 = '/purchases/stores/sales-types';
  const PATH63 = '/purchases/stores/sales-types/download';
  const PATH64 = '/sales-details';
  const PATH65 = '/sales-details/download';
  const PATH66 = '/v1/employee/sales-types';
  const PATH67 = '/v1/employee/unallocated-order-items';
  const PATH68 = '/v1/favorites';
  const PATH69 = '/duplicate';
  const PATH70 = '/v1/favorites/items';
  const PATH71 = '/v1/invoices';
  const PATH72 = '/preview';
  const PATH73 = '/v1/invoices/comments';
  const PATH74 = '/v1/invoices/download';
  const PATH75 = '/v1/invoices/histories';
  const PATH76 = '/v1/invoices/histories/download';
  const PATH77 = '/v1/items';
  const PATH78 = '/prices';
  const PATH79 = '/v1/items/count';
  const PATH80 = '/v1/login';
  const PATH81 = '/v1/logout';
  const PATH82 = '/v1/makers';
  const PATH83 = '/v1/order-histories';
  const PATH84 = '/delivery-date';
  const PATH85 = '/shipping-infomation';
  const PATH86 = '/v1/order-histories/download';
  const PATH87 = '/v1/order-histories/unshipped';
  const PATH88 = '/v1/orders';
  const PATH89 = '/v1/orders/approve';
  const PATH90 = '/v1/orders/unapproved';
  const PATH91 = '/v1/price-changes';
  const PATH92 = '/v1/price-changes/download';
  const PATH93 = '/v1/purchases';
  const PATH94 = '/v1/purchases/ec-site-orders';
  const PATH95 = '/v1/purchases/ec-site-orders/download';
  const PATH96 = '/v1/purchases/makers';
  const PATH97 = '/v1/purchases/makers/download';
  const PATH98 = '/v1/purchases/makers/stores';
  const PATH99 = '/v1/purchases/makers/stores/download';
  const PATH100 = '/v1/purchases/stores';
  const PATH101 = '/v1/purchases/stores/download';
  const PATH102 = '/v1/purchases/stores/makers/sales-types';
  const PATH103 = '/v1/purchases/stores/makers/sales-types/download';
  const PATH104 = '/v1/purchases/stores/sales-types';
  const PATH105 = '/v1/purchases/stores/sales-types/download';
  const PATH106 = '/v1/receipts';
  const PATH107 = '/v1/receive-email';
  const PATH108 = '/v1/sales-details';
  const PATH109 = '/v1/sales-details/download';
  const PATH110 = '/v1/sales-types';
  const PATH111 = '/v1/stores';
  const PATH112 = '/v1/stores/me';
  const PATH113 = '/v1/stores-for-invoice';
  const PATH114 = '/v1/tests/cart/delivery-date/one-day-ago';
  const PATH115 = '/v1/user/language';
  const PATH116 = '/v1/user/me';
  const GET = 'GET';
  const POST = 'POST';
  const PUT = 'PUT';
  const DELETE = 'DELETE';
  const PATCH = 'PATCH';

  return {
    v1: {
      addresses: {
        /**
         * 郵便番号から住所情報を検索します。
         * @returns 正常処理
         */
        get: (option: { query: Methods_1eh1a04['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1eh1a04['get']['resBody'], BasicHeaders, Methods_1eh1a04['get']['status']>(prefix, PATH0, GET, option).json(),
        /**
         * 郵便番号から住所情報を検索します。
         * @returns 正常処理
         */
        $get: (option: { query: Methods_1eh1a04['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1eh1a04['get']['resBody'], BasicHeaders, Methods_1eh1a04['get']['status']>(prefix, PATH0, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_1eh1a04['get']['query'] } | undefined) =>
          `${prefix}${PATH0}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      advertisements: {
        /**
         * ### 概要
         * ログイン店舗に表示可能な広告一覧を取得する。
         *
         * ### 仕様
         * - 有効、掲載期間内、かつ店舗別非表示設定がない広告のみ返却する。
         * - `displayPosition` 未指定時は `top` として扱い、指定した表示区分の広告のみ返却する。
         * - `displayPosition` は `top` または `invoice` のみ許可する。それ以外は 400 を返却する。
         * - レスポンスには顧客アプリの表示に必要な情報のみ返却し、表示開始日時、表示終了日時、管理ステータスは返却しない。
         * - 並び順は表示優先順位の昇順、表示開始日時の昇順、広告IDの昇順。
         * @returns 正常処理
         */
        get: (option?: { query?: Methods_1ohtqbq['get']['query'] | undefined, config?: T | undefined } | undefined) =>
          fetch<Methods_1ohtqbq['get']['resBody'], BasicHeaders, Methods_1ohtqbq['get']['status']>(prefix, PATH1, GET, option).json(),
        /**
         * ### 概要
         * ログイン店舗に表示可能な広告一覧を取得する。
         *
         * ### 仕様
         * - 有効、掲載期間内、かつ店舗別非表示設定がない広告のみ返却する。
         * - `displayPosition` 未指定時は `top` として扱い、指定した表示区分の広告のみ返却する。
         * - `displayPosition` は `top` または `invoice` のみ許可する。それ以外は 400 を返却する。
         * - レスポンスには顧客アプリの表示に必要な情報のみ返却し、表示開始日時、表示終了日時、管理ステータスは返却しない。
         * - 並び順は表示優先順位の昇順、表示開始日時の昇順、広告IDの昇順。
         * @returns 正常処理
         */
        $get: (option?: { query?: Methods_1ohtqbq['get']['query'] | undefined, config?: T | undefined } | undefined) =>
          fetch<Methods_1ohtqbq['get']['resBody'], BasicHeaders, Methods_1ohtqbq['get']['status']>(prefix, PATH1, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_1ohtqbq['get']['query'] } | undefined) =>
          `${prefix}${PATH1}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      aggregation_units_and_stores_for_purchase: {
        /**
         * ### 概要
         * 仕入情報を検索するときに、ログインユーザーが選択可能な集計単位と店舗を取得する。
         *
         * ### 処理仕様
         *
         * - ログインユーザに設定されている仕入情報の集計範囲を確認する。
         * - 集計範囲が得意先の場合、選択可能な集計単位は得意先とし、選択可能な店舗は自店舗とする。
         * - 集計範囲が請求先の場合、選択可能な集計単位は得意先、請求先とし、選択可能な店舗は自店舗と自店舗の請求先に紐づく店舗とする。
         * - 集計範囲が入金親の場合、選択可能な集計単位は得意先、請求先、入金親とし、選択可能な店舗は自店舗と自店舗の請求先に紐づく店舗、自店舗と自店舗の入金親に紐づく店舗とする。
         * - 結果を返す。
         *
         * ### 並び順
         * - 店舗名の昇順
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 401 未ログイン
         * @returns 正常処理
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_1kgccx9['get']['resBody'], BasicHeaders, Methods_1kgccx9['get']['status']>(prefix, PATH2, GET, option).json(),
        /**
         * ### 概要
         * 仕入情報を検索するときに、ログインユーザーが選択可能な集計単位と店舗を取得する。
         *
         * ### 処理仕様
         *
         * - ログインユーザに設定されている仕入情報の集計範囲を確認する。
         * - 集計範囲が得意先の場合、選択可能な集計単位は得意先とし、選択可能な店舗は自店舗とする。
         * - 集計範囲が請求先の場合、選択可能な集計単位は得意先、請求先とし、選択可能な店舗は自店舗と自店舗の請求先に紐づく店舗とする。
         * - 集計範囲が入金親の場合、選択可能な集計単位は得意先、請求先、入金親とし、選択可能な店舗は自店舗と自店舗の請求先に紐づく店舗、自店舗と自店舗の入金親に紐づく店舗とする。
         * - 結果を返す。
         *
         * ### 並び順
         * - 店舗名の昇順
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 401 未ログイン
         * @returns 正常処理
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_1kgccx9['get']['resBody'], BasicHeaders, Methods_1kgccx9['get']['status']>(prefix, PATH2, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH2}`,
      },
      announcements: {
        _announcementId: (val2: number) => {
          const prefix2 = `${PATH3}/${val2}`;

          return {
            read: {
              /**
               * ### 概要
               * 指定したお知らせをログインユーザーの既読として登録する。
               *
               * ### 仕様
               * - 既に既読登録済みの場合も正常終了する。
               * - `status = active`、公開期間内、かつ店舗別非表示設定がないお知らせのみ既読登録できる。
               */
              patch: (option?: { config?: T | undefined } | undefined) =>
                fetch<void, BasicHeaders, Methods_1m0knhi['patch']['status']>(prefix, `${prefix2}${PATH4}`, PATCH, option).send(),
              /**
               * ### 概要
               * 指定したお知らせをログインユーザーの既読として登録する。
               *
               * ### 仕様
               * - 既に既読登録済みの場合も正常終了する。
               * - `status = active`、公開期間内、かつ店舗別非表示設定がないお知らせのみ既読登録できる。
               */
              $patch: (option?: { config?: T | undefined } | undefined) =>
                fetch<void, BasicHeaders, Methods_1m0knhi['patch']['status']>(prefix, `${prefix2}${PATH4}`, PATCH, option).send().then(r => r.body),
              $path: () => `${prefix}${prefix2}${PATH4}`,
            },
            /**
             * ### 概要
             * ログイン店舗に表示可能な指定お知らせの詳細を取得する。
             *
             * ### 仕様
             * - `status = active`、公開期間内、かつ店舗別非表示設定がないお知らせのみ取得できる。
             * - `body` はJSON形式で返却する。
             * - 価格改定・商品コード変更のお知らせの場合、`priceChange` に価格・商品コード変更詳細検索用の条件を返却する。
             * - 価格改定・商品コード変更のお知らせは、ログイン店舗で購入可能な対象商品が1件以上ある場合のみ取得できる。
             * - 価格改定・商品コード変更のお知らせのタイトル内件数は、ログイン店舗で実際に詳細表示できる対象商品件数で返却する。
             * - 一般お知らせの場合、`priceChange` は返却しない。
             * @returns 正常処理
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_tbuhit['get']['resBody'], BasicHeaders, Methods_tbuhit['get']['status']>(prefix, prefix2, GET, option).json(),
            /**
             * ### 概要
             * ログイン店舗に表示可能な指定お知らせの詳細を取得する。
             *
             * ### 仕様
             * - `status = active`、公開期間内、かつ店舗別非表示設定がないお知らせのみ取得できる。
             * - `body` はJSON形式で返却する。
             * - 価格改定・商品コード変更のお知らせの場合、`priceChange` に価格・商品コード変更詳細検索用の条件を返却する。
             * - 価格改定・商品コード変更のお知らせは、ログイン店舗で購入可能な対象商品が1件以上ある場合のみ取得できる。
             * - 価格改定・商品コード変更のお知らせのタイトル内件数は、ログイン店舗で実際に詳細表示できる対象商品件数で返却する。
             * - 一般お知らせの場合、`priceChange` は返却しない。
             * @returns 正常処理
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_tbuhit['get']['resBody'], BasicHeaders, Methods_tbuhit['get']['status']>(prefix, prefix2, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          };
        },
        read: {
          /**
           * ### 概要
           * 指定した複数のお知らせをログインユーザーの既読として登録する。
           *
           * ### 仕様
           * - 既に既読登録済みの場合も正常終了する。
           * - `status = active`、公開期間内、かつ店舗別非表示設定がないお知らせのみ既読登録できる。
           * - 1件でも表示不可・存在しないIDが含まれる場合は404とする。
           * - `announcementIds` は1〜8件（一覧1ページ分）。超過は400。重複IDは1件として扱う。
           */
          patch: (option: { body: Methods_3994zd['patch']['reqBody'], config?: T | undefined }) =>
            fetch<void, BasicHeaders, Methods_3994zd['patch']['status']>(prefix, PATH5, PATCH, option).send(),
          /**
           * ### 概要
           * 指定した複数のお知らせをログインユーザーの既読として登録する。
           *
           * ### 仕様
           * - 既に既読登録済みの場合も正常終了する。
           * - `status = active`、公開期間内、かつ店舗別非表示設定がないお知らせのみ既読登録できる。
           * - 1件でも表示不可・存在しないIDが含まれる場合は404とする。
           * - `announcementIds` は1〜8件（一覧1ページ分）。超過は400。重複IDは1件として扱う。
           */
          $patch: (option: { body: Methods_3994zd['patch']['reqBody'], config?: T | undefined }) =>
            fetch<void, BasicHeaders, Methods_3994zd['patch']['status']>(prefix, PATH5, PATCH, option).send().then(r => r.body),
          $path: () => `${prefix}${PATH5}`,
        },
        /**
         * ### 概要
         * ログイン店舗に表示可能なお知らせ一覧を取得する。
         *
         * ### 仕様
         * - トップページ表示時に必ず `GET /v1/announcements` を呼び出す。
         * - 価格改定・商品コード変更のお知らせは、このAPI呼び出し時に最新状態へ同期してから返却する。
         * - `status = active`、公開期間内、かつ店舗別非表示設定がないお知らせのみ返却する。
         * - 価格改定・商品コード変更のお知らせは、ログイン店舗で購入可能な対象商品が1件以上ある場合のみ返却する。
         * - 価格改定・商品コード変更のお知らせのタイトル内件数は、ログイン店舗で実際に詳細表示できる対象商品件数で返却する。
         * - `readStatus` 未指定時は `unread`。
         * - `tag` 未指定時は `all`（すべて。絞り込みなし）。
         * - 価格改定・商品コード変更のお知らせの `tag` は常に `productInfo`。
         * - `announcementType` 未指定または `all` の場合はすべてのお知らせ種別を返却する。
         * - `readStatus = read` の場合、一般お知らせを表示優先順位、公開開始日時、お知らせIDの降順で先頭に並べ、その後に価格改定・商品コード変更のお知らせを並べる。
         * - それ以外の場合、価格改定・商品コード変更のお知らせを先頭に並べる。
         * - 価格改定・商品コード変更のお知らせは、改定日が今日以降のものは近い改定日順、過去日のものはその後に改定日の降順で並べる。同一改定日はお知らせIDの降順。
         * - 1ページあたりの件数は最大8件、ページ番号は最大10まで。
         * @returns 正常処理
         */
        get: (option?: { query?: Methods_1xn76h8['get']['query'] | undefined, config?: T | undefined } | undefined) =>
          fetch<Methods_1xn76h8['get']['resBody'], BasicHeaders, Methods_1xn76h8['get']['status']>(prefix, PATH3, GET, option).json(),
        /**
         * ### 概要
         * ログイン店舗に表示可能なお知らせ一覧を取得する。
         *
         * ### 仕様
         * - トップページ表示時に必ず `GET /v1/announcements` を呼び出す。
         * - 価格改定・商品コード変更のお知らせは、このAPI呼び出し時に最新状態へ同期してから返却する。
         * - `status = active`、公開期間内、かつ店舗別非表示設定がないお知らせのみ返却する。
         * - 価格改定・商品コード変更のお知らせは、ログイン店舗で購入可能な対象商品が1件以上ある場合のみ返却する。
         * - 価格改定・商品コード変更のお知らせのタイトル内件数は、ログイン店舗で実際に詳細表示できる対象商品件数で返却する。
         * - `readStatus` 未指定時は `unread`。
         * - `tag` 未指定時は `all`（すべて。絞り込みなし）。
         * - 価格改定・商品コード変更のお知らせの `tag` は常に `productInfo`。
         * - `announcementType` 未指定または `all` の場合はすべてのお知らせ種別を返却する。
         * - `readStatus = read` の場合、一般お知らせを表示優先順位、公開開始日時、お知らせIDの降順で先頭に並べ、その後に価格改定・商品コード変更のお知らせを並べる。
         * - それ以外の場合、価格改定・商品コード変更のお知らせを先頭に並べる。
         * - 価格改定・商品コード変更のお知らせは、改定日が今日以降のものは近い改定日順、過去日のものはその後に改定日の降順で並べる。同一改定日はお知らせIDの降順。
         * - 1ページあたりの件数は最大8件、ページ番号は最大10まで。
         * @returns 正常処理
         */
        $get: (option?: { query?: Methods_1xn76h8['get']['query'] | undefined, config?: T | undefined } | undefined) =>
          fetch<Methods_1xn76h8['get']['resBody'], BasicHeaders, Methods_1xn76h8['get']['status']>(prefix, PATH3, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_1xn76h8['get']['query'] } | undefined) =>
          `${prefix}${PATH3}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      auth: {
        token: {
          /**
           * リフレッシュトークンを渡して、アクセストークンを取得します。<br/>
           * <br/>
           * 以下のレスポンスはHTTPステータスのみの返却となります。<br/>
           *
           * <ul>
           * <li>400：必須項目が無いなどのリクエスト不正。</li>
           * <li>401：対象のリフレッシュトークンが未登録の場合。</li>
           * </ul>
           * @returns 処理成功
           */
          post: (option: { body: Methods_u0fui8['post']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_u0fui8['post']['resBody'], BasicHeaders, Methods_u0fui8['post']['status']>(prefix, PATH6, POST, option).json(),
          /**
           * リフレッシュトークンを渡して、アクセストークンを取得します。<br/>
           * <br/>
           * 以下のレスポンスはHTTPステータスのみの返却となります。<br/>
           *
           * <ul>
           * <li>400：必須項目が無いなどのリクエスト不正。</li>
           * <li>401：対象のリフレッシュトークンが未登録の場合。</li>
           * </ul>
           * @returns 処理成功
           */
          $post: (option: { body: Methods_u0fui8['post']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_u0fui8['post']['resBody'], BasicHeaders, Methods_u0fui8['post']['status']>(prefix, PATH6, POST, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH6}`,
        },
      },
      available_delivery_period: {
        /**
         * ### 概要
         * 店舗コードと郵便番号の組み合わせにおいて、指定可能な納品日の期間を取得する。
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 400 パラメータ不正
         * - 401 未ログイン
         * - 403 権限のない店舗コード
         * @returns 正常処理
         */
        get: (option: { query: Methods_zq1es4['get']['query'], config?: T | undefined }) =>
          fetch<Methods_zq1es4['get']['resBody'], BasicHeaders, Methods_zq1es4['get']['status']>(prefix, PATH7, GET, option).json(),
        /**
         * ### 概要
         * 店舗コードと郵便番号の組み合わせにおいて、指定可能な納品日の期間を取得する。
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 400 パラメータ不正
         * - 401 未ログイン
         * - 403 権限のない店舗コード
         * @returns 正常処理
         */
        $get: (option: { query: Methods_zq1es4['get']['query'], config?: T | undefined }) =>
          fetch<Methods_zq1es4['get']['resBody'], BasicHeaders, Methods_zq1es4['get']['status']>(prefix, PATH7, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_zq1es4['get']['query'] } | undefined) =>
          `${prefix}${PATH7}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      billed_amounts: {
        download: {
          /**
           * ### 概要
           * - 請求金額一覧を取得し、CSVをダウンロード処理受付する。
           * - 検索結果がなかった場合、ヘッダのみ返る。
           * - ダウンロードのための、ダウンロードIDが返却される。
           *
           * ### 処理仕様
           *
           * - 検索条件に合致する請求金額結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
           * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
           *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
           *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
           *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
           * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
           * - ダウンロードする場合のファイル名は「仕入情報_請求金額_yyyyMMddHHmmssfff.csv」とする。
           *
           * - パラメータから検索条件を作成する。
           * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
           * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。請求月の指定がない場合当月とする。
           * - DBから結果を取得する。
           * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
           * - 上記の内容で処理を開始する。
           *
           * ### 並び順
           * - 請求No
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * - 403 権限のない集計単位の指定
           *
           * ### CSVカラム
           *
           * 1. 請求日
           * 2. お支払日
           * 3. 請求No
           * 4. 請求先コード
           * 5. 請求先名
           * 6. 繰越額
           * 7. 当月売上合計
           * 8. 伝票調整
           * 9. 消費税
           * 10. 今回請求金額
           * @returns 正常処理
           */
          post: (option: { body: Methods_16oi9wd['post']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_16oi9wd['post']['resBody'], BasicHeaders, Methods_16oi9wd['post']['status']>(prefix, PATH9, POST, option).json(),
          /**
           * ### 概要
           * - 請求金額一覧を取得し、CSVをダウンロード処理受付する。
           * - 検索結果がなかった場合、ヘッダのみ返る。
           * - ダウンロードのための、ダウンロードIDが返却される。
           *
           * ### 処理仕様
           *
           * - 検索条件に合致する請求金額結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
           * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
           *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
           *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
           *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
           * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
           * - ダウンロードする場合のファイル名は「仕入情報_請求金額_yyyyMMddHHmmssfff.csv」とする。
           *
           * - パラメータから検索条件を作成する。
           * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
           * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。請求月の指定がない場合当月とする。
           * - DBから結果を取得する。
           * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
           * - 上記の内容で処理を開始する。
           *
           * ### 並び順
           * - 請求No
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * - 403 権限のない集計単位の指定
           *
           * ### CSVカラム
           *
           * 1. 請求日
           * 2. お支払日
           * 3. 請求No
           * 4. 請求先コード
           * 5. 請求先名
           * 6. 繰越額
           * 7. 当月売上合計
           * 8. 伝票調整
           * 9. 消費税
           * 10. 今回請求金額
           * @returns 正常処理
           */
          $post: (option: { body: Methods_16oi9wd['post']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_16oi9wd['post']['resBody'], BasicHeaders, Methods_16oi9wd['post']['status']>(prefix, PATH9, POST, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH9}`,
        },
        /**
         * ### 概要
         * 請求金額の一覧を取得する
         *
         * ### 処理仕様
         *
         * - パラメータから一覧取得条件を作成する。
         * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
         * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。請求月の指定がない場合当月とする。
         * - DBから結果を取得する。
         * - 結果を返す。
         *
         * ### 並び順
         * - 請求No
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 400 パラメータ不正
         * - 401 未ログイン
         * - 403 権限のない集計単位の指定
         *
         * ### カラム
         * | No. | dataField | headerName | type |
         * |-----|-----------|------------|------|
         * | 1 | billDate | 請求日 | string |
         * | 2 | paymentDate | お支払日 | string |
         * | 3 | billNo | 請求No | string |
         * | 4 | billCode | 請求先コード | string |
         * | 5 | billName | 請求先名 | string |
         * | 6 | carryOverAmount | 繰越額 | integer |
         * | 7 | total | 当月売上合計 | integer |
         * | 8 | adjustment | 伝票調整 | integer |
         * | 9 | tax | 消費税 | integer |
         * | 10 | billedAmount | 今回請求金額 | integer |
         * @returns 正常処理
         */
        get: (option: { query: Methods_1m5zwn8['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1m5zwn8['get']['resBody'], BasicHeaders, Methods_1m5zwn8['get']['status']>(prefix, PATH8, GET, option).json(),
        /**
         * ### 概要
         * 請求金額の一覧を取得する
         *
         * ### 処理仕様
         *
         * - パラメータから一覧取得条件を作成する。
         * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
         * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。請求月の指定がない場合当月とする。
         * - DBから結果を取得する。
         * - 結果を返す。
         *
         * ### 並び順
         * - 請求No
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 400 パラメータ不正
         * - 401 未ログイン
         * - 403 権限のない集計単位の指定
         *
         * ### カラム
         * | No. | dataField | headerName | type |
         * |-----|-----------|------------|------|
         * | 1 | billDate | 請求日 | string |
         * | 2 | paymentDate | お支払日 | string |
         * | 3 | billNo | 請求No | string |
         * | 4 | billCode | 請求先コード | string |
         * | 5 | billName | 請求先名 | string |
         * | 6 | carryOverAmount | 繰越額 | integer |
         * | 7 | total | 当月売上合計 | integer |
         * | 8 | adjustment | 伝票調整 | integer |
         * | 9 | tax | 消費税 | integer |
         * | 10 | billedAmount | 今回請求金額 | integer |
         * @returns 正常処理
         */
        $get: (option: { query: Methods_1m5zwn8['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1m5zwn8['get']['resBody'], BasicHeaders, Methods_1m5zwn8['get']['status']>(prefix, PATH8, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_1m5zwn8['get']['query'] } | undefined) =>
          `${prefix}${PATH8}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      brands: {
        /**
         * ブランドの一覧を取得する。
         * 並び順はgroupName順（アカサタナ）および、brandNameKana順（カナ昇順）とする。
         * @returns 正常処理
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_b4x3qi['get']['resBody'], BasicHeaders, Methods_b4x3qi['get']['status']>(prefix, PATH10, GET, option).json(),
        /**
         * ブランドの一覧を取得する。
         * 並び順はgroupName順（アカサタナ）および、brandNameKana順（カナ昇順）とする。
         * @returns 正常処理
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_b4x3qi['get']['resBody'], BasicHeaders, Methods_b4x3qi['get']['status']>(prefix, PATH10, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH10}`,
      },
      buyable_lineups: {
        /**
         * ラインナップの購入可否情報を返します。検索可能なラインナップを取得したら、
         * それらのラインナップをリストとしてこのAPIに渡して情報を取得してください。
         * @returns 正常処理
         */
        post: (option: { body: Methods_ha7p8h['post']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_ha7p8h['post']['resBody'], BasicHeaders, Methods_ha7p8h['post']['status']>(prefix, PATH11, POST, option).json(),
        /**
         * ラインナップの購入可否情報を返します。検索可能なラインナップを取得したら、
         * それらのラインナップをリストとしてこのAPIに渡して情報を取得してください。
         * @returns 正常処理
         */
        $post: (option: { body: Methods_ha7p8h['post']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_ha7p8h['post']['resBody'], BasicHeaders, Methods_ha7p8h['post']['status']>(prefix, PATH11, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH11}`,
      },
      cart: {
        count: {
          /**
           * カート内の商品数を取得します。<br/>
           * 販売中の商品のみをカウントし返却します。
           * @returns 正常処理
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_7c5vea['get']['resBody'], BasicHeaders, Methods_7c5vea['get']['status']>(prefix, PATH13, GET, option).json(),
          /**
           * カート内の商品数を取得します。<br/>
           * 販売中の商品のみをカウントし返却します。
           * @returns 正常処理
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_7c5vea['get']['resBody'], BasicHeaders, Methods_7c5vea['get']['status']>(prefix, PATH13, GET, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH13}`,
        },
        delivery_date: {
          /**
           * ログインユーザーのご希望納品日を更新します。<br/>
           * カート用にご希望納品日の設定が出来ます。<br/>
           * ご希望納品日が最短納品日より過去の場合、<br/>
           * ご希望納品日が最終納品日より未来の場合は400を返します。<br/>
           * 社員モードでは使用できません。社員モードでは `/v1/employee/proxy-stores/{storeCode}/cart/delivery-date` を使用してください。
           * @returns 正常処理
           */
          put: (option: { body: Methods_rvg606['put']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_rvg606['put']['resBody'], BasicHeaders, Methods_rvg606['put']['status']>(prefix, PATH14, PUT, option).json(),
          /**
           * ログインユーザーのご希望納品日を更新します。<br/>
           * カート用にご希望納品日の設定が出来ます。<br/>
           * ご希望納品日が最短納品日より過去の場合、<br/>
           * ご希望納品日が最終納品日より未来の場合は400を返します。<br/>
           * 社員モードでは使用できません。社員モードでは `/v1/employee/proxy-stores/{storeCode}/cart/delivery-date` を使用してください。
           * @returns 正常処理
           */
          $put: (option: { body: Methods_rvg606['put']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_rvg606['put']['resBody'], BasicHeaders, Methods_rvg606['put']['status']>(prefix, PATH14, PUT, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH14}`,
        },
        items: {
          _itemCode: (val3: string) => {
            const prefix3 = `${PATH15}/${val3}`;

            return {
              /**
               * ### 概要
               * - カート情報の指定した商品を削除する。
               *
               * ### 処理仕様
               *
               * - パラメータで指定した商品を、カートからすべての売上種別で削除する。
               * - カートに無い商品の場合、404が返る。
               * - 更新された内容で、カート情報の取得と同じ結果を返却する。
               *
               * ### HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * - 404 商品なし
               * @returns OK
               */
              delete: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1liyk6u['delete']['resBody'], BasicHeaders, Methods_1liyk6u['delete']['status']>(prefix, prefix3, DELETE, option).json(),
              /**
               * ### 概要
               * - カート情報の指定した商品を削除する。
               *
               * ### 処理仕様
               *
               * - パラメータで指定した商品を、カートからすべての売上種別で削除する。
               * - カートに無い商品の場合、404が返る。
               * - 更新された内容で、カート情報の取得と同じ結果を返却する。
               *
               * ### HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * - 404 商品なし
               * @returns OK
               */
              $delete: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1liyk6u['delete']['resBody'], BasicHeaders, Methods_1liyk6u['delete']['status']>(prefix, prefix3, DELETE, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix3}`,
            };
          },
        },
        order: {
          /**
           * カートに対して、発注を確定します。<br/>
           * 料金計算、発注データの登録を行い、最後にカートから全商品の削除を実行します。<br/>
           * 販売不可商品は、料金計算、発注データの登録に含まれずカートから削除されます。<br/>
           * ご希望納品日が最短納品日より過去の場合はエラーになります。<br/>
           * <br/>
           * 販売不可商品のステータスは下記になります。<br/>
           * <ul>
           * <li>unavailable：販売終了商品</li>
           * <li>expired：販売期間外商品</li>
           * <li>forbidden：扱えない商品</li>
           * <li>noItemCode：存在しない商品コード</li>
           * </ul>
           * @returns 正常処理
           */
          patch: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_me969h['patch']['resBody'], BasicHeaders, Methods_me969h['patch']['status']>(prefix, PATH16, PATCH, option).json(),
          /**
           * カートに対して、発注を確定します。<br/>
           * 料金計算、発注データの登録を行い、最後にカートから全商品の削除を実行します。<br/>
           * 販売不可商品は、料金計算、発注データの登録に含まれずカートから削除されます。<br/>
           * ご希望納品日が最短納品日より過去の場合はエラーになります。<br/>
           * <br/>
           * 販売不可商品のステータスは下記になります。<br/>
           * <ul>
           * <li>unavailable：販売終了商品</li>
           * <li>expired：販売期間外商品</li>
           * <li>forbidden：扱えない商品</li>
           * <li>noItemCode：存在しない商品コード</li>
           * </ul>
           * @returns 正常処理
           */
          $patch: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_me969h['patch']['resBody'], BasicHeaders, Methods_me969h['patch']['status']>(prefix, PATH16, PATCH, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH16}`,
        },
        shipping_information: {
          /**
           * ログインユーザーのカート発送情報を更新します。<br/>
           * カート用に発送予定住所の変更が出来ます。<br/>
           * 社員モードでは使用できません。社員モードでは `/v1/employee/proxy-stores/{storeCode}/cart/shipping-information` を使用してください。
           * @returns 正常処理
           */
          put: (option: { body: Methods_mweb26['put']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_mweb26['put']['resBody'], BasicHeaders, Methods_mweb26['put']['status']>(prefix, PATH17, PUT, option).json(),
          /**
           * ログインユーザーのカート発送情報を更新します。<br/>
           * カート用に発送予定住所の変更が出来ます。<br/>
           * 社員モードでは使用できません。社員モードでは `/v1/employee/proxy-stores/{storeCode}/cart/shipping-information` を使用してください。
           * @returns 正常処理
           */
          $put: (option: { body: Methods_mweb26['put']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_mweb26['put']['resBody'], BasicHeaders, Methods_mweb26['put']['status']>(prefix, PATH17, PUT, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH17}`,
        },
        /**
         * ログインユーザーのカート情報を取得します。<br/>
         * 画面上には、販売中の商品のみが表示されます。<br/>
         * 商品一覧の並び順はカートに追加した順番になります。<br/>
         * 売上種別数量の並び順は商品に追加した順番になります。<br/>
         * <br/>
         * 購入価格表示が無効の場合は値引き費用は通常の費用と同じ値になります。<br/>
         * <br/>
         * レギュラー納品予定日、最短納品予定日、最終納品日はアクセス時に常に再計算されます。<br/>
         * 最終納品日は最短納品日から2週間（13日）後となります。<br/>
         * 保存していた希望納品日が最短の納品日より前になってしまった場合<br/>
         * ご希望納品日エラーとなります。
         * @returns 正常処理
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_d52hfy['get']['resBody'], BasicHeaders, Methods_d52hfy['get']['status']>(prefix, PATH12, GET, option).json(),
        /**
         * ログインユーザーのカート情報を取得します。<br/>
         * 画面上には、販売中の商品のみが表示されます。<br/>
         * 商品一覧の並び順はカートに追加した順番になります。<br/>
         * 売上種別数量の並び順は商品に追加した順番になります。<br/>
         * <br/>
         * 購入価格表示が無効の場合は値引き費用は通常の費用と同じ値になります。<br/>
         * <br/>
         * レギュラー納品予定日、最短納品予定日、最終納品日はアクセス時に常に再計算されます。<br/>
         * 最終納品日は最短納品日から2週間（13日）後となります。<br/>
         * 保存していた希望納品日が最短の納品日より前になってしまった場合<br/>
         * ご希望納品日エラーとなります。
         * @returns 正常処理
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_d52hfy['get']['resBody'], BasicHeaders, Methods_d52hfy['get']['status']>(prefix, PATH12, GET, option).json().then(r => r.body),
        /**
         * ログインユーザーのカート情報を削除します。
         * @returns OK
         */
        delete: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_d52hfy['delete']['resBody'], BasicHeaders, Methods_d52hfy['delete']['status']>(prefix, PATH12, DELETE, option).json(),
        /**
         * ログインユーザーのカート情報を削除します。
         * @returns OK
         */
        $delete: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_d52hfy['delete']['resBody'], BasicHeaders, Methods_d52hfy['delete']['status']>(prefix, PATH12, DELETE, option).json().then(r => r.body),
        /**
         * ログインユーザーのカート情報を更新します。<br/>
         * 更新は販売中の商品のみ実行されます。<br/>
         * 対象商品に設定する売上種別数量をすべてリクエストしてください。<br/>
         * 更新に成功した場合は登録したカート情報を返却します。
         * @returns 正常処理
         */
        put: (option: { body: Methods_d52hfy['put']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_d52hfy['put']['resBody'], BasicHeaders, Methods_d52hfy['put']['status']>(prefix, PATH12, PUT, option).json(),
        /**
         * ログインユーザーのカート情報を更新します。<br/>
         * 更新は販売中の商品のみ実行されます。<br/>
         * 対象商品に設定する売上種別数量をすべてリクエストしてください。<br/>
         * 更新に成功した場合は登録したカート情報を返却します。
         * @returns 正常処理
         */
        $put: (option: { body: Methods_d52hfy['put']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_d52hfy['put']['resBody'], BasicHeaders, Methods_d52hfy['put']['status']>(prefix, PATH12, PUT, option).json().then(r => r.body),
        /**
         * ### 概要
         * カート情報の指定した商品の売上種別、数量を更新する。
         *
         * ### 処理仕様
         *
         * - パラメータに指定された商品の数量を更新する。
         * - 商品の数量が0の場合、指定した商品をカートから削除する。
         * - 登録のない商品が指定された場合、新たにカートへ追加する。
         * - 指定された商品に対して指定された売上種別、数量で置き換える。
         * - 更新された内容で、カート情報の取得と同じ結果を返却する。
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 400 パラメータ不正
         * - 401 未ログイン
         * @returns OK
         */
        patch: (option: { body: Methods_d52hfy['patch']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_d52hfy['patch']['resBody'], BasicHeaders, Methods_d52hfy['patch']['status']>(prefix, PATH12, PATCH, option).json(),
        /**
         * ### 概要
         * カート情報の指定した商品の売上種別、数量を更新する。
         *
         * ### 処理仕様
         *
         * - パラメータに指定された商品の数量を更新する。
         * - 商品の数量が0の場合、指定した商品をカートから削除する。
         * - 登録のない商品が指定された場合、新たにカートへ追加する。
         * - 指定された商品に対して指定された売上種別、数量で置き換える。
         * - 更新された内容で、カート情報の取得と同じ結果を返却する。
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 400 パラメータ不正
         * - 401 未ログイン
         * @returns OK
         */
        $patch: (option: { body: Methods_d52hfy['patch']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_d52hfy['patch']['resBody'], BasicHeaders, Methods_d52hfy['patch']['status']>(prefix, PATH12, PATCH, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH12}`,
      },
      categories: {
        /**
         * カテゴリー一覧を取得します。
         * 取得結果の並び順は、カテゴリーIDの昇順になります。
         * @returns 正常処理
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_1d01kek['get']['resBody'], BasicHeaders, Methods_1d01kek['get']['status']>(prefix, PATH18, GET, option).json(),
        /**
         * カテゴリー一覧を取得します。
         * 取得結果の並び順は、カテゴリーIDの昇順になります。
         * @returns 正常処理
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_1d01kek['get']['resBody'], BasicHeaders, Methods_1d01kek['get']['status']>(prefix, PATH18, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH18}`,
      },
      change_email: {
        /**
         * メールアドレスを変更します。<br/>
         * リクエストを受付け確認用のメールを送信します。<br/>
         * <br/>
         * 以下のレスポンスはHTTPステータスのみの返却となります。<br/>
         *
         * <ul>
         * <li>200：受付成功し確認用のメールを送信。</li>
         * <li>401：認証に失敗した場合。</li>
         * </ul>
         */
        put: (option: { body: Methods_136mcql['put']['reqBody'], config?: T | undefined }) =>
          fetch<void, BasicHeaders, Methods_136mcql['put']['status']>(prefix, PATH19, PUT, option).send(),
        /**
         * メールアドレスを変更します。<br/>
         * リクエストを受付け確認用のメールを送信します。<br/>
         * <br/>
         * 以下のレスポンスはHTTPステータスのみの返却となります。<br/>
         *
         * <ul>
         * <li>200：受付成功し確認用のメールを送信。</li>
         * <li>401：認証に失敗した場合。</li>
         * </ul>
         */
        $put: (option: { body: Methods_136mcql['put']['reqBody'], config?: T | undefined }) =>
          fetch<void, BasicHeaders, Methods_136mcql['put']['status']>(prefix, PATH19, PUT, option).send().then(r => r.body),
        $path: () => `${prefix}${PATH19}`,
      },
      change_email_auth: {
        /**
         * リクエストのトークンを用いて、変更したメールアドレスの認証を行います。<br/>
         * 認証成功しメールアドレス変更した場合、ログイン認証レスポンスを返却します。<br/>
         *
         * 以下のレスポンスはHTTPステータスのみの返却となります。<br/>
         *
         * <ul>
         * <li>401：トークン認証に失敗した場合。</li>
         * </ul>
         * @returns 正常処理
         */
        post: (option: { body: Methods_udp926['post']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_udp926['post']['resBody'], BasicHeaders, Methods_udp926['post']['status']>(prefix, PATH20, POST, option).json(),
        /**
         * リクエストのトークンを用いて、変更したメールアドレスの認証を行います。<br/>
         * 認証成功しメールアドレス変更した場合、ログイン認証レスポンスを返却します。<br/>
         *
         * 以下のレスポンスはHTTPステータスのみの返却となります。<br/>
         *
         * <ul>
         * <li>401：トークン認証に失敗した場合。</li>
         * </ul>
         * @returns 正常処理
         */
        $post: (option: { body: Methods_udp926['post']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_udp926['post']['resBody'], BasicHeaders, Methods_udp926['post']['status']>(prefix, PATH20, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH20}`,
      },
      change_invoice_email: {
        /**
         * ### 仕様
         * - 請求書ダウンロードリンクの送信先メールアドレスを更新する。
         * - リクエスト受信後にメールアドレス認証用のメールを送信する。
         * - 全体で重複がないこと。あった場合は400を返す。重複確認の対象は既に設定済みのメールアドレスだけでなく、認証待ちのメールアドレスも対象とする。
         *
         * ### HTTPレスポンス
         * - 200：正常
         * - 400：不正なリクエストを受信した場合
         * - 401：認証エラー
         * @returns 正常処理
         */
        put: (option: { body: Methods_1x7lru3['put']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_1x7lru3['put']['resBody'], BasicHeaders, Methods_1x7lru3['put']['status']>(prefix, PATH21, PUT, option).json(),
        /**
         * ### 仕様
         * - 請求書ダウンロードリンクの送信先メールアドレスを更新する。
         * - リクエスト受信後にメールアドレス認証用のメールを送信する。
         * - 全体で重複がないこと。あった場合は400を返す。重複確認の対象は既に設定済みのメールアドレスだけでなく、認証待ちのメールアドレスも対象とする。
         *
         * ### HTTPレスポンス
         * - 200：正常
         * - 400：不正なリクエストを受信した場合
         * - 401：認証エラー
         * @returns 正常処理
         */
        $put: (option: { body: Methods_1x7lru3['put']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_1x7lru3['put']['resBody'], BasicHeaders, Methods_1x7lru3['put']['status']>(prefix, PATH21, PUT, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH21}`,
      },
      change_invoice_email_auth: {
        /**
         * ## 仕様
         * - メールアドレス更新時に送信されるメールから認証を行う。
         * - パラメータで指定されたトークンを保存してあるトークンと比較し、同じ場合認証を行う。
         * - 認証する場合、新しい請求書メールを通常の請求書メールに設定し、新しい請求書メールはnullを設定する。
         *
         * ## レスポンス
         * - 200 正常
         * - 401 トークン不正
         * @returns 正常処理
         */
        post: (option: { body: Methods_t9pnmg['post']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_t9pnmg['post']['resBody'], BasicHeaders, Methods_t9pnmg['post']['status']>(prefix, PATH22, POST, option).json(),
        /**
         * ## 仕様
         * - メールアドレス更新時に送信されるメールから認証を行う。
         * - パラメータで指定されたトークンを保存してあるトークンと比較し、同じ場合認証を行う。
         * - 認証する場合、新しい請求書メールを通常の請求書メールに設定し、新しい請求書メールはnullを設定する。
         *
         * ## レスポンス
         * - 200 正常
         * - 401 トークン不正
         * @returns 正常処理
         */
        $post: (option: { body: Methods_t9pnmg['post']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_t9pnmg['post']['resBody'], BasicHeaders, Methods_t9pnmg['post']['status']>(prefix, PATH22, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH22}`,
      },
      change_password: {
        /**
         * パスワードを変更します。<br/>
         */
        put: (option: { body: Methods_1lgf7ie['put']['reqBody'], config?: T | undefined }) =>
          fetch<void, BasicHeaders, Methods_1lgf7ie['put']['status']>(prefix, PATH23, PUT, option).send(),
        /**
         * パスワードを変更します。<br/>
         */
        $put: (option: { body: Methods_1lgf7ie['put']['reqBody'], config?: T | undefined }) =>
          fetch<void, BasicHeaders, Methods_1lgf7ie['put']['status']>(prefix, PATH23, PUT, option).send().then(r => r.body),
        $path: () => `${prefix}${PATH23}`,
      },
      change_temp_password: {
        /**
         * 初回ログイン後、パスワードの変更します。<br/>
         */
        put: (option: { body: Methods_1gsuyod['put']['reqBody'], config?: T | undefined }) =>
          fetch<void, BasicHeaders, Methods_1gsuyod['put']['status']>(prefix, PATH24, PUT, option).send(),
        /**
         * 初回ログイン後、パスワードの変更します。<br/>
         */
        $put: (option: { body: Methods_1gsuyod['put']['reqBody'], config?: T | undefined }) =>
          fetch<void, BasicHeaders, Methods_1gsuyod['put']['status']>(prefix, PATH24, PUT, option).send().then(r => r.body),
        $path: () => `${prefix}${PATH24}`,
      },
      color_charts: {
        _groupId: (val2: number) => {
          const prefix2 = `${PATH25}/${val2}`;

          return {
            /**
             * カラーチャートを取得します。<br/>
             * カラーチャート取得は販売中の商品のみを返却します。<br/>
             * 該当するカラーチャートが1件も存在しない場合、空の配列を返します。<br/>
             * <br/>
             * 商品ステータスは以下になります。<br/>
             * <ul>
             * <li>available：販売中</li>
             * <li>expired：販売終了商品</li>
             * <li>unavailable：販売期間外商品</li>
             * <li>forbidden：扱えない商品</li>
             * </ul>
             *
             * <br/>
             * 並び順は以下になります。<br/>
             * <ul>
             * <li>color_charts.id の昇順</li>
             * <li>ColorChartProduct の brightness の降順</li>
             * <li>ColorChart の colorToneNumber の昇順</li>
             * </ul>
             * @returns 正常処理
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1vqdu5a['get']['resBody'], BasicHeaders, Methods_1vqdu5a['get']['status']>(prefix, prefix2, GET, option).json(),
            /**
             * カラーチャートを取得します。<br/>
             * カラーチャート取得は販売中の商品のみを返却します。<br/>
             * 該当するカラーチャートが1件も存在しない場合、空の配列を返します。<br/>
             * <br/>
             * 商品ステータスは以下になります。<br/>
             * <ul>
             * <li>available：販売中</li>
             * <li>expired：販売終了商品</li>
             * <li>unavailable：販売期間外商品</li>
             * <li>forbidden：扱えない商品</li>
             * </ul>
             *
             * <br/>
             * 並び順は以下になります。<br/>
             * <ul>
             * <li>color_charts.id の昇順</li>
             * <li>ColorChartProduct の brightness の降順</li>
             * <li>ColorChart の colorToneNumber の昇順</li>
             * </ul>
             * @returns 正常処理
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1vqdu5a['get']['resBody'], BasicHeaders, Methods_1vqdu5a['get']['status']>(prefix, prefix2, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          };
        },
      },
      contact: {
        /**
         * リクエストパラメータで、お問い合わせメールを送信する。
         */
        post: (option: { body: Methods_y82zcs['post']['reqBody'], config?: T | undefined }) =>
          fetch<void, BasicHeaders, Methods_y82zcs['post']['status']>(prefix, PATH26, POST, option).send(),
        /**
         * リクエストパラメータで、お問い合わせメールを送信する。
         */
        $post: (option: { body: Methods_y82zcs['post']['reqBody'], config?: T | undefined }) =>
          fetch<void, BasicHeaders, Methods_y82zcs['post']['status']>(prefix, PATH26, POST, option).send().then(r => r.body),
        $path: () => `${prefix}${PATH26}`,
      },
      ec_site_orders: {
        _fileId: (val2: string) => {
          const prefix2 = `${PATH27}/${val2}`;

          return {
            download: {
              /**
               * CSVデータのダウンロードを行う。
               * データはLibertasから取得する。
               * @returns 正常処理
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1i5kvhd['get']['resBody'], BasicHeaders, Methods_1i5kvhd['get']['status']>(prefix, `${prefix2}${PATH28}`, GET, option).json(),
              /**
               * CSVデータのダウンロードを行う。
               * データはLibertasから取得する。
               * @returns 正常処理
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1i5kvhd['get']['resBody'], BasicHeaders, Methods_1i5kvhd['get']['status']>(prefix, `${prefix2}${PATH28}`, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix2}${PATH28}`,
            },
            /**
             * 指定されたアップロードファイルの行詳細を取得する  
             * 詳細は行番号でソートされる
             * データはLibertasから取得する。
             * @returns 正常処理
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1b7x3tc['get']['resBody'], BasicHeaders, Methods_1b7x3tc['get']['status']>(prefix, prefix2, GET, option).json(),
            /**
             * 指定されたアップロードファイルの行詳細を取得する  
             * 詳細は行番号でソートされる
             * データはLibertasから取得する。
             * @returns 正常処理
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1b7x3tc['get']['resBody'], BasicHeaders, Methods_1b7x3tc['get']['status']>(prefix, prefix2, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          };
        },
        systemTypes: {
          /**
           * ### 仕様
           * - システム種別一覧を取得する。
           * - クエリパラメータでYahooの形式に ```merged``` を指定した場合、Yahooのシステム種別を ```Yahoo```  として返却する。
           * - クエリパラメータでYahooの形式に ```separated``` を指定した場合、Yahooのシステム種別を注文系と商品系を分けて返却する。
           * - ログインユーザの所属店舗にECAPIの表示権限がある場合、システム種別に ```ECAPI``` を含めて返却する。
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 不正なリクエストを受信した場合
           * - 401 未ログイン
           * @returns 正常処理
           */
          get: (option?: { query?: Methods_7fy7h7['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_7fy7h7['get']['resBody'], BasicHeaders, Methods_7fy7h7['get']['status']>(prefix, PATH29, GET, option).json(),
          /**
           * ### 仕様
           * - システム種別一覧を取得する。
           * - クエリパラメータでYahooの形式に ```merged``` を指定した場合、Yahooのシステム種別を ```Yahoo```  として返却する。
           * - クエリパラメータでYahooの形式に ```separated``` を指定した場合、Yahooのシステム種別を注文系と商品系を分けて返却する。
           * - ログインユーザの所属店舗にECAPIの表示権限がある場合、システム種別に ```ECAPI``` を含めて返却する。
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 不正なリクエストを受信した場合
           * - 401 未ログイン
           * @returns 正常処理
           */
          $get: (option?: { query?: Methods_7fy7h7['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_7fy7h7['get']['resBody'], BasicHeaders, Methods_7fy7h7['get']['status']>(prefix, PATH29, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_7fy7h7['get']['query'] } | undefined) =>
            `${prefix}${PATH29}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        /**
         * CSVファイルをアップロードする。 
         * 登録時のエラーなどの結果を返す。
         * 詳細は行番号でソートされる
         *
         * ## 処理仕様 
         * データはLibertasに設定する。
         * - CSVからファイルを解析し文字コードを判別する。
         * - CSVのヘッダ情報から解析しサイトを判定する。 
         * - CSVのサイトごとにデータを解析し取得する。 
         * - CSVからデータをDBに登録し、登録用Functionをコールする。新しいテーブルを作成し、ダウンロードファイルとアップロード結果を紐づけ登録する。 
         * - CSVをAWS上のS3に保存し、後にダウンロードできるようにする。
         * - ファイル内容のサイズがオーバーしていた場合は413でレスポンスが返る。
         *
         * ## 独自エラーコード
         * |エラーコード|内容|
         * |------|------|
         * | -10 | 商品コード桁数不正 |
         * |-11 | JANコード桁数不正 |
         * |-100 | ファイル形式不備 |
         * @returns 正常処理
         */
        post: (option: { body: Methods_keyd9a['post']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_keyd9a['post']['resBody'], BasicHeaders, Methods_keyd9a['post']['status']>(prefix, PATH27, POST, option).json(),
        /**
         * CSVファイルをアップロードする。 
         * 登録時のエラーなどの結果を返す。
         * 詳細は行番号でソートされる
         *
         * ## 処理仕様 
         * データはLibertasに設定する。
         * - CSVからファイルを解析し文字コードを判別する。
         * - CSVのヘッダ情報から解析しサイトを判定する。 
         * - CSVのサイトごとにデータを解析し取得する。 
         * - CSVからデータをDBに登録し、登録用Functionをコールする。新しいテーブルを作成し、ダウンロードファイルとアップロード結果を紐づけ登録する。 
         * - CSVをAWS上のS3に保存し、後にダウンロードできるようにする。
         * - ファイル内容のサイズがオーバーしていた場合は413でレスポンスが返る。
         *
         * ## 独自エラーコード
         * |エラーコード|内容|
         * |------|------|
         * | -10 | 商品コード桁数不正 |
         * |-11 | JANコード桁数不正 |
         * |-100 | ファイル形式不備 |
         * @returns 正常処理
         */
        $post: (option: { body: Methods_keyd9a['post']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_keyd9a['post']['resBody'], BasicHeaders, Methods_keyd9a['post']['status']>(prefix, PATH27, POST, option).json().then(r => r.body),
        /**
         * Ec注文アップロードされたCSVファイルを入力パラメータから検索し、一覧を返却する。
         * 一覧は取込日時の新しい順でソートされる。
         * データはLibertasから取得する。
         * @returns 正常処理
         */
        get: (option: { query: Methods_keyd9a['get']['query'], config?: T | undefined }) =>
          fetch<Methods_keyd9a['get']['resBody'], BasicHeaders, Methods_keyd9a['get']['status']>(prefix, PATH27, GET, option).json(),
        /**
         * Ec注文アップロードされたCSVファイルを入力パラメータから検索し、一覧を返却する。
         * 一覧は取込日時の新しい順でソートされる。
         * データはLibertasから取得する。
         * @returns 正常処理
         */
        $get: (option: { query: Methods_keyd9a['get']['query'], config?: T | undefined }) =>
          fetch<Methods_keyd9a['get']['resBody'], BasicHeaders, Methods_keyd9a['get']['status']>(prefix, PATH27, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_keyd9a['get']['query'] } | undefined) =>
          `${prefix}${PATH27}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      employee: {
        addresses: {
          /**
           * 社員モードの郵便番号から住所情報を検索します。
           * @returns 正常処理
           */
          get: (option: { query: Methods_1lp91e3['get']['query'], config?: T | undefined }) =>
            fetch<Methods_1lp91e3['get']['resBody'], BasicHeaders, Methods_1lp91e3['get']['status']>(prefix, PATH30, GET, option).json(),
          /**
           * 社員モードの郵便番号から住所情報を検索します。
           * @returns 正常処理
           */
          $get: (option: { query: Methods_1lp91e3['get']['query'], config?: T | undefined }) =>
            fetch<Methods_1lp91e3['get']['resBody'], BasicHeaders, Methods_1lp91e3['get']['status']>(prefix, PATH30, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_1lp91e3['get']['query'] } | undefined) =>
            `${prefix}${PATH30}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        auth: {
          token: {
            /**
             * 社員モード用リフレッシュトークンを渡して、社員モード用アクセストークンを取得します。<br/>
             * @returns 処理成功
             */
            post: (option: { body: Methods_10m9hj1['post']['reqBody'], config?: T | undefined }) =>
              fetch<Methods_10m9hj1['post']['resBody'], BasicHeaders, Methods_10m9hj1['post']['status']>(prefix, PATH31, POST, option).json(),
            /**
             * 社員モード用リフレッシュトークンを渡して、社員モード用アクセストークンを取得します。<br/>
             * @returns 処理成功
             */
            $post: (option: { body: Methods_10m9hj1['post']['reqBody'], config?: T | undefined }) =>
              fetch<Methods_10m9hj1['post']['resBody'], BasicHeaders, Methods_10m9hj1['post']['status']>(prefix, PATH31, POST, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH31}`,
          },
        },
        login: {
          /**
           * 社員ログイン処理を行い、社員モード用の認証結果を返します。<br/>
           * 正しく認証できた場合は、社員モード用JWTとアカウント情報を返します。<br/>
           * @returns 正常処理
           */
          post: (option: { body: Methods_1nepvbu['post']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_1nepvbu['post']['resBody'], BasicHeaders, Methods_1nepvbu['post']['status']>(prefix, PATH32, POST, option).json(),
          /**
           * 社員ログイン処理を行い、社員モード用の認証結果を返します。<br/>
           * 正しく認証できた場合は、社員モード用JWTとアカウント情報を返します。<br/>
           * @returns 正常処理
           */
          $post: (option: { body: Methods_1nepvbu['post']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_1nepvbu['post']['resBody'], BasicHeaders, Methods_1nepvbu['post']['status']>(prefix, PATH32, POST, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH32}`,
        },
        logout: {
          /**
           * 社員モードのログアウト処理を行います。<br/>
           * サーバ側で保持している社員モード用リフレッシュトークンを削除します。<br/>
           */
          put: (option?: { config?: T | undefined } | undefined) =>
            fetch<void, BasicHeaders, Methods_fuwusz['put']['status']>(prefix, PATH33, PUT, option).send(),
          /**
           * 社員モードのログアウト処理を行います。<br/>
           * サーバ側で保持している社員モード用リフレッシュトークンを削除します。<br/>
           */
          $put: (option?: { config?: T | undefined } | undefined) =>
            fetch<void, BasicHeaders, Methods_fuwusz['put']['status']>(prefix, PATH33, PUT, option).send().then(r => r.body),
          $path: () => `${prefix}${PATH33}`,
        },
        me: {
          /**
           * 社員モードでログイン中の社員情報を取得します。
           * @returns 正常処理
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_9kiydr['get']['resBody'], BasicHeaders, Methods_9kiydr['get']['status']>(prefix, PATH34, GET, option).json(),
          /**
           * 社員モードでログイン中の社員情報を取得します。
           * @returns 正常処理
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_9kiydr['get']['resBody'], BasicHeaders, Methods_9kiydr['get']['status']>(prefix, PATH34, GET, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH34}`,
        },
        proxy_stores: {
          _storeCode: (val3: string) => {
            const prefix3 = `${PATH35}/${val3}`;

            return {
              aggregation_units_and_stores_for_purchase: {
                /**
                 * ### 概要
                 * 仕入情報を検索するときに、ログインユーザーが選択可能な集計単位と店舗を取得する。
                 *
                 * ### 処理仕様
                 * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                 *
                 * - ログインユーザに設定されている仕入情報の集計範囲を確認する。
                 * - 集計範囲が得意先の場合、選択可能な集計単位は得意先とし、選択可能な店舗は自店舗とする。
                 * - 集計範囲が請求先の場合、選択可能な集計単位は得意先、請求先とし、選択可能な店舗は自店舗と自店舗の請求先に紐づく店舗とする。
                 * - 集計範囲が入金親の場合、選択可能な集計単位は得意先、請求先、入金親とし、選択可能な店舗は自店舗と自店舗の請求先に紐づく店舗、自店舗と自店舗の入金親に紐づく店舗とする。
                 * - 結果を返す。
                 *
                 * ### 並び順
                 * - 店舗名の昇順
                 *
                 * ### HTTPレスポンス
                 * - 200 正常
                 * - 400 パラメータ不正
                 * - 401 未ログイン
                 * - 403 権限のない代理操作対象店舗の指定
                 * - 500 サーバー側システムエラー
                 * @returns 正常処理
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1wusb49['get']['resBody'], BasicHeaders, Methods_1wusb49['get']['status']>(prefix, `${prefix3}${PATH36}`, GET, option).json(),
                /**
                 * ### 概要
                 * 仕入情報を検索するときに、ログインユーザーが選択可能な集計単位と店舗を取得する。
                 *
                 * ### 処理仕様
                 * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                 *
                 * - ログインユーザに設定されている仕入情報の集計範囲を確認する。
                 * - 集計範囲が得意先の場合、選択可能な集計単位は得意先とし、選択可能な店舗は自店舗とする。
                 * - 集計範囲が請求先の場合、選択可能な集計単位は得意先、請求先とし、選択可能な店舗は自店舗と自店舗の請求先に紐づく店舗とする。
                 * - 集計範囲が入金親の場合、選択可能な集計単位は得意先、請求先、入金親とし、選択可能な店舗は自店舗と自店舗の請求先に紐づく店舗、自店舗と自店舗の入金親に紐づく店舗とする。
                 * - 結果を返す。
                 *
                 * ### 並び順
                 * - 店舗名の昇順
                 *
                 * ### HTTPレスポンス
                 * - 200 正常
                 * - 400 パラメータ不正
                 * - 401 未ログイン
                 * - 403 権限のない代理操作対象店舗の指定
                 * - 500 サーバー側システムエラー
                 * @returns 正常処理
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1wusb49['get']['resBody'], BasicHeaders, Methods_1wusb49['get']['status']>(prefix, `${prefix3}${PATH36}`, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix3}${PATH36}`,
              },
              available_delivery_period: {
                /**
                 * ### 概要
                 * 社員代理操作で選択した得意先コードと郵便番号の組み合わせにおいて、指定可能な納品日の期間を取得する。
                 *
                 * ### HTTPレスポンス
                 * - 200 正常
                 * - 400 パラメータ不正
                 * - 401 未ログイン
                 * - 403 権限のない得意先コード
                 * - 500 システムエラー
                 * @returns 正常処理
                 */
                get: (option: { query: Methods_9i69og['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_9i69og['get']['resBody'], BasicHeaders, Methods_9i69og['get']['status']>(prefix, `${prefix3}${PATH37}`, GET, option).json(),
                /**
                 * ### 概要
                 * 社員代理操作で選択した得意先コードと郵便番号の組み合わせにおいて、指定可能な納品日の期間を取得する。
                 *
                 * ### HTTPレスポンス
                 * - 200 正常
                 * - 400 パラメータ不正
                 * - 401 未ログイン
                 * - 403 権限のない得意先コード
                 * - 500 システムエラー
                 * @returns 正常処理
                 */
                $get: (option: { query: Methods_9i69og['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_9i69og['get']['resBody'], BasicHeaders, Methods_9i69og['get']['status']>(prefix, `${prefix3}${PATH37}`, GET, option).json().then(r => r.body),
                $path: (option?: { method?: 'get' | undefined; query: Methods_9i69og['get']['query'] } | undefined) =>
                  `${prefix}${prefix3}${PATH37}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              },
              billed_amounts: {
                download: {
                  /**
                   * ### 概要
                   * - 請求金額一覧を取得し、CSVをダウンロード処理受付する。
                   * - 検索結果がなかった場合、ヘッダのみ返る。
                   * - ダウンロードのための、ダウンロードIDが返却される。
                   *
                   * ### 処理仕様
                   * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                   *
                   * - 検索条件に合致する請求金額結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
                   * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
                   *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
                   *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
                   *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
                   * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
                   * - ダウンロードする場合のファイル名は「仕入情報_請求金額_yyyyMMddHHmmssfff.csv」とする。
                   *
                   * - パラメータから検索条件を作成する。
                   * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                   * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。請求月の指定がない場合当月とする。
                   * - DBから結果を取得する。
                   * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
                   * - 上記の内容で処理を開始する。
                   *
                   * ### 並び順
                   * - 請求No
                   *
                   * ### HTTPレスポンス
                   * - 200 正常
                   * - 400 パラメータ不正
                   * - 401 未ログイン
                   * - 403 権限のない集計単位の指定
                   *
                   * ### CSVカラム
                   *
                   * 1. 請求日
                   * 2. お支払日
                   * 3. 請求No
                   * 4. 請求先コード
                   * 5. 請求先名
                   * 6. 売上合計
                   * 7. 伝票調整
                   * 8. 消費税
                   * 9. 今回請求金額
                   * @returns 正常処理
                   */
                  post: (option: { body: Methods_1dfta61['post']['reqBody'], config?: T | undefined }) =>
                    fetch<Methods_1dfta61['post']['resBody'], BasicHeaders, Methods_1dfta61['post']['status']>(prefix, `${prefix3}${PATH39}`, POST, option).json(),
                  /**
                   * ### 概要
                   * - 請求金額一覧を取得し、CSVをダウンロード処理受付する。
                   * - 検索結果がなかった場合、ヘッダのみ返る。
                   * - ダウンロードのための、ダウンロードIDが返却される。
                   *
                   * ### 処理仕様
                   * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                   *
                   * - 検索条件に合致する請求金額結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
                   * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
                   *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
                   *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
                   *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
                   * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
                   * - ダウンロードする場合のファイル名は「仕入情報_請求金額_yyyyMMddHHmmssfff.csv」とする。
                   *
                   * - パラメータから検索条件を作成する。
                   * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                   * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。請求月の指定がない場合当月とする。
                   * - DBから結果を取得する。
                   * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
                   * - 上記の内容で処理を開始する。
                   *
                   * ### 並び順
                   * - 請求No
                   *
                   * ### HTTPレスポンス
                   * - 200 正常
                   * - 400 パラメータ不正
                   * - 401 未ログイン
                   * - 403 権限のない集計単位の指定
                   *
                   * ### CSVカラム
                   *
                   * 1. 請求日
                   * 2. お支払日
                   * 3. 請求No
                   * 4. 請求先コード
                   * 5. 請求先名
                   * 6. 売上合計
                   * 7. 伝票調整
                   * 8. 消費税
                   * 9. 今回請求金額
                   * @returns 正常処理
                   */
                  $post: (option: { body: Methods_1dfta61['post']['reqBody'], config?: T | undefined }) =>
                    fetch<Methods_1dfta61['post']['resBody'], BasicHeaders, Methods_1dfta61['post']['status']>(prefix, `${prefix3}${PATH39}`, POST, option).json().then(r => r.body),
                  $path: () => `${prefix}${prefix3}${PATH39}`,
                },
                /**
                 * ### 概要
                 * 請求金額の一覧を取得する
                 *
                 * ### 処理仕様
                 * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                 *
                 * - パラメータから一覧取得条件を作成する。
                 * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                 * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。請求月の指定がない場合当月とする。
                 * - DBから結果を取得する。
                 * - 結果を返す。
                 *
                 * ### 並び順
                 * - 請求No
                 *
                 * ### HTTPレスポンス
                 * - 200 正常
                 * - 400 パラメータ不正
                 * - 401 未ログイン
                 * - 403 権限のない集計単位の指定
                 *
                 * ### カラム
                 * | No. | dataField | headerName | type |
                 * |-----|-----------|------------|------|
                 * | 1 | billDate | 請求日 | string |
                 * | 2 | paymentDate | お支払日 | string |
                 * | 3 | billNo | 請求No | string |
                 * | 4 | billCode | 請求先コード | string |
                 * | 5 | billName | 請求先名 | string |
                 * | 6 | total | 売上合計 | integer |
                 * | 7 | adjustment | 伝票調整 | integer |
                 * | 8 | tax | 消費税 | integer |
                 * | 9 | billedAmount | 今回請求金額 | integer |
                 * @returns 正常処理
                 */
                get: (option: { query: Methods_c8iaw['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_c8iaw['get']['resBody'], BasicHeaders, Methods_c8iaw['get']['status']>(prefix, `${prefix3}${PATH38}`, GET, option).json(),
                /**
                 * ### 概要
                 * 請求金額の一覧を取得する
                 *
                 * ### 処理仕様
                 * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                 *
                 * - パラメータから一覧取得条件を作成する。
                 * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                 * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。請求月の指定がない場合当月とする。
                 * - DBから結果を取得する。
                 * - 結果を返す。
                 *
                 * ### 並び順
                 * - 請求No
                 *
                 * ### HTTPレスポンス
                 * - 200 正常
                 * - 400 パラメータ不正
                 * - 401 未ログイン
                 * - 403 権限のない集計単位の指定
                 *
                 * ### カラム
                 * | No. | dataField | headerName | type |
                 * |-----|-----------|------------|------|
                 * | 1 | billDate | 請求日 | string |
                 * | 2 | paymentDate | お支払日 | string |
                 * | 3 | billNo | 請求No | string |
                 * | 4 | billCode | 請求先コード | string |
                 * | 5 | billName | 請求先名 | string |
                 * | 6 | total | 売上合計 | integer |
                 * | 7 | adjustment | 伝票調整 | integer |
                 * | 8 | tax | 消費税 | integer |
                 * | 9 | billedAmount | 今回請求金額 | integer |
                 * @returns 正常処理
                 */
                $get: (option: { query: Methods_c8iaw['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_c8iaw['get']['resBody'], BasicHeaders, Methods_c8iaw['get']['status']>(prefix, `${prefix3}${PATH38}`, GET, option).json().then(r => r.body),
                $path: (option?: { method?: 'get' | undefined; query: Methods_c8iaw['get']['query'] } | undefined) =>
                  `${prefix}${prefix3}${PATH38}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              },
              brands: {
                /**
                 * 社員代理操作で選択した得意先の商品検索用ブランド一覧を取得します。<br/>
                 * サロン別ラインアップ制限は適用せず、販売中の商品が存在するブランドを返却します。<br/>
                 * 指定した得意先を操作できない社員の場合は403を返します。
                 * @returns 正常処理
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_973lym['get']['resBody'], BasicHeaders, Methods_973lym['get']['status']>(prefix, `${prefix3}${PATH40}`, GET, option).json(),
                /**
                 * 社員代理操作で選択した得意先の商品検索用ブランド一覧を取得します。<br/>
                 * サロン別ラインアップ制限は適用せず、販売中の商品が存在するブランドを返却します。<br/>
                 * 指定した得意先を操作できない社員の場合は403を返します。
                 * @returns 正常処理
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_973lym['get']['resBody'], BasicHeaders, Methods_973lym['get']['status']>(prefix, `${prefix3}${PATH40}`, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix3}${PATH40}`,
              },
              cart: {
                count: {
                  /**
                   * 社員代理操作で選択した得意先の社員用カート内商品数を取得します。
                   * @returns 正常処理
                   */
                  get: (option?: { config?: T | undefined } | undefined) =>
                    fetch<Methods_1nvx5yu['get']['resBody'], BasicHeaders, Methods_1nvx5yu['get']['status']>(prefix, `${prefix3}${PATH42}`, GET, option).json(),
                  /**
                   * 社員代理操作で選択した得意先の社員用カート内商品数を取得します。
                   * @returns 正常処理
                   */
                  $get: (option?: { config?: T | undefined } | undefined) =>
                    fetch<Methods_1nvx5yu['get']['resBody'], BasicHeaders, Methods_1nvx5yu['get']['status']>(prefix, `${prefix3}${PATH42}`, GET, option).json().then(r => r.body),
                  $path: () => `${prefix}${prefix3}${PATH42}`,
                },
                delivery_date: {
                  /**
                   * 社員代理操作で選択した得意先の社員用カート希望納品日を更新します。
                   *
                   * 社員モードでは通常ユーザー用の `/v1/cart/delivery-date` は使用できません。
                   * 必ず選択中の得意先コードを path に含めて、この API を使用してください。
                   */
                  put: (option: { body: Methods_14ekawi['put']['reqBody'], config?: T | undefined }) =>
                    fetch<void, BasicHeaders, Methods_14ekawi['put']['status']>(prefix, `${prefix3}${PATH43}`, PUT, option).send(),
                  /**
                   * 社員代理操作で選択した得意先の社員用カート希望納品日を更新します。
                   *
                   * 社員モードでは通常ユーザー用の `/v1/cart/delivery-date` は使用できません。
                   * 必ず選択中の得意先コードを path に含めて、この API を使用してください。
                   */
                  $put: (option: { body: Methods_14ekawi['put']['reqBody'], config?: T | undefined }) =>
                    fetch<void, BasicHeaders, Methods_14ekawi['put']['status']>(prefix, `${prefix3}${PATH43}`, PUT, option).send().then(r => r.body),
                  $path: () => `${prefix}${prefix3}${PATH43}`,
                },
                items: {
                  _itemCode: (val6: string) => {
                    const prefix6 = `${prefix3}${PATH44}/${val6}`;

                    return {
                      /**
                       * 社員代理操作で選択した得意先の社員用カートから指定商品を削除します。
                       * @returns 正常処理
                       */
                      delete: (option?: { config?: T | undefined } | undefined) =>
                        fetch<Methods_mnqxhe['delete']['resBody'], BasicHeaders, Methods_mnqxhe['delete']['status']>(prefix, prefix6, DELETE, option).json(),
                      /**
                       * 社員代理操作で選択した得意先の社員用カートから指定商品を削除します。
                       * @returns 正常処理
                       */
                      $delete: (option?: { config?: T | undefined } | undefined) =>
                        fetch<Methods_mnqxhe['delete']['resBody'], BasicHeaders, Methods_mnqxhe['delete']['status']>(prefix, prefix6, DELETE, option).json().then(r => r.body),
                      $path: () => `${prefix}${prefix6}`,
                    };
                  },
                },
                order: {
                  /**
                   * 社員代理操作で選択した得意先の社員用カートを発注します。<br/>
                   * 社員代理注文は承認済みとして登録され、サロン/顧客メールは送信しません。<br/>
                   * 業務DB連携で商品別の業務エラーが返った場合は、HTTP 200 で orderStatus=FAILED
                   * と商品別 NG 理由を返します。欠品・一部欠品（エラーコード31/32）でも業務DBに
                   * 注文が作成された場合は orderStatus=SUCCESS とし、対象商品の status=NG と
                   * message で未引当内容を返します。この場合、unallocatedStatus と unallocatedItems に
                   * 現在の引当数・未引当数も返します。リクエスト不正、認証/認可、システムエラーは通常の
                   * 400/401/403/500 として返します。
                   * @returns 正常処理
                   */
                  patch: (option?: { config?: T | undefined } | undefined) =>
                    fetch<Methods_99ram9['patch']['resBody'], BasicHeaders, Methods_99ram9['patch']['status']>(prefix, `${prefix3}${PATH45}`, PATCH, option).json(),
                  /**
                   * 社員代理操作で選択した得意先の社員用カートを発注します。<br/>
                   * 社員代理注文は承認済みとして登録され、サロン/顧客メールは送信しません。<br/>
                   * 業務DB連携で商品別の業務エラーが返った場合は、HTTP 200 で orderStatus=FAILED
                   * と商品別 NG 理由を返します。欠品・一部欠品（エラーコード31/32）でも業務DBに
                   * 注文が作成された場合は orderStatus=SUCCESS とし、対象商品の status=NG と
                   * message で未引当内容を返します。この場合、unallocatedStatus と unallocatedItems に
                   * 現在の引当数・未引当数も返します。リクエスト不正、認証/認可、システムエラーは通常の
                   * 400/401/403/500 として返します。
                   * @returns 正常処理
                   */
                  $patch: (option?: { config?: T | undefined } | undefined) =>
                    fetch<Methods_99ram9['patch']['resBody'], BasicHeaders, Methods_99ram9['patch']['status']>(prefix, `${prefix3}${PATH45}`, PATCH, option).json().then(r => r.body),
                  $path: () => `${prefix}${prefix3}${PATH45}`,
                },
                shipping_information: {
                  /**
                   * 社員代理操作で選択した得意先の社員用カート発送情報を更新します。
                   *
                   * 社員モードでは通常ユーザー用の `/v1/cart/shipping-information` は使用できません。
                   * 必ず選択中の得意先コードを path に含めて、この API を使用してください。
                   */
                  put: (option: { body: Methods_l3vj6y['put']['reqBody'], config?: T | undefined }) =>
                    fetch<void, BasicHeaders, Methods_l3vj6y['put']['status']>(prefix, `${prefix3}${PATH46}`, PUT, option).send(),
                  /**
                   * 社員代理操作で選択した得意先の社員用カート発送情報を更新します。
                   *
                   * 社員モードでは通常ユーザー用の `/v1/cart/shipping-information` は使用できません。
                   * 必ず選択中の得意先コードを path に含めて、この API を使用してください。
                   */
                  $put: (option: { body: Methods_l3vj6y['put']['reqBody'], config?: T | undefined }) =>
                    fetch<void, BasicHeaders, Methods_l3vj6y['put']['status']>(prefix, `${prefix3}${PATH46}`, PUT, option).send().then(r => r.body),
                  $path: () => `${prefix}${prefix3}${PATH46}`,
                },
                /**
                 * 社員代理操作で選択した得意先の社員用カート情報を取得します。
                 * @returns 正常処理
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1n26z0a['get']['resBody'], BasicHeaders, Methods_1n26z0a['get']['status']>(prefix, `${prefix3}${PATH41}`, GET, option).json(),
                /**
                 * 社員代理操作で選択した得意先の社員用カート情報を取得します。
                 * @returns 正常処理
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1n26z0a['get']['resBody'], BasicHeaders, Methods_1n26z0a['get']['status']>(prefix, `${prefix3}${PATH41}`, GET, option).json().then(r => r.body),
                /**
                 * 社員代理操作で選択した得意先の社員用カート情報を更新します。
                 * @returns 正常処理
                 */
                put: (option: { body: Methods_1n26z0a['put']['reqBody'], config?: T | undefined }) =>
                  fetch<Methods_1n26z0a['put']['resBody'], BasicHeaders, Methods_1n26z0a['put']['status']>(prefix, `${prefix3}${PATH41}`, PUT, option).json(),
                /**
                 * 社員代理操作で選択した得意先の社員用カート情報を更新します。
                 * @returns 正常処理
                 */
                $put: (option: { body: Methods_1n26z0a['put']['reqBody'], config?: T | undefined }) =>
                  fetch<Methods_1n26z0a['put']['resBody'], BasicHeaders, Methods_1n26z0a['put']['status']>(prefix, `${prefix3}${PATH41}`, PUT, option).json().then(r => r.body),
                /**
                 * 社員代理操作で選択した得意先の社員用カート商品を商品単位で編集します。
                 * @returns 正常処理
                 */
                patch: (option: { body: Methods_1n26z0a['patch']['reqBody'], config?: T | undefined }) =>
                  fetch<Methods_1n26z0a['patch']['resBody'], BasicHeaders, Methods_1n26z0a['patch']['status']>(prefix, `${prefix3}${PATH41}`, PATCH, option).json(),
                /**
                 * 社員代理操作で選択した得意先の社員用カート商品を商品単位で編集します。
                 * @returns 正常処理
                 */
                $patch: (option: { body: Methods_1n26z0a['patch']['reqBody'], config?: T | undefined }) =>
                  fetch<Methods_1n26z0a['patch']['resBody'], BasicHeaders, Methods_1n26z0a['patch']['status']>(prefix, `${prefix3}${PATH41}`, PATCH, option).json().then(r => r.body),
                /**
                 * 社員代理操作で選択した得意先の社員用カート情報を削除します。
                 */
                delete: (option?: { config?: T | undefined } | undefined) =>
                  fetch<void, BasicHeaders, Methods_1n26z0a['delete']['status']>(prefix, `${prefix3}${PATH41}`, DELETE, option).send(),
                /**
                 * 社員代理操作で選択した得意先の社員用カート情報を削除します。
                 */
                $delete: (option?: { config?: T | undefined } | undefined) =>
                  fetch<void, BasicHeaders, Methods_1n26z0a['delete']['status']>(prefix, `${prefix3}${PATH41}`, DELETE, option).send().then(r => r.body),
                $path: () => `${prefix}${prefix3}${PATH41}`,
              },
              categories: {
                /**
                 * 社員代理操作で選択した得意先の商品検索用カテゴリー一覧を取得します。<br/>
                 * サロン別ラインアップ制限は適用せず、販売中の商品を集計対象にします。<br/>
                 * 指定した得意先を操作できない社員の場合は403を返します。
                 * @returns 正常処理
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1wpbfo8['get']['resBody'], BasicHeaders, Methods_1wpbfo8['get']['status']>(prefix, `${prefix3}${PATH47}`, GET, option).json(),
                /**
                 * 社員代理操作で選択した得意先の商品検索用カテゴリー一覧を取得します。<br/>
                 * サロン別ラインアップ制限は適用せず、販売中の商品を集計対象にします。<br/>
                 * 指定した得意先を操作できない社員の場合は403を返します。
                 * @returns 正常処理
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1wpbfo8['get']['resBody'], BasicHeaders, Methods_1wpbfo8['get']['status']>(prefix, `${prefix3}${PATH47}`, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix3}${PATH47}`,
              },
              favorites: {
                _setNo: (val5: number) => {
                  const prefix5 = `${prefix3}${PATH48}/${val5}`;

                  return {
                    _favoriteStoreCode: (val6: string) => {
                      const prefix6 = `${prefix5}/${val6}`;

                      return {
                        /**
                         * ### 概要
                         * 社員代理注文で選択中の店舗として、お気に入りリストの商品一覧を取得します。<br/>
                         * 通常のお気に入り詳細と同じレスポンス形式を返しますが、社員モードでは参照と注文利用のみ許可します。<br/>
                         * `isEditableByMe` と `canDuplicateByMe` は常に `false` です。<br/>
                         * 商品情報は社員代理注文の商品検索と同じく、サロン別ラインアップ制限を適用しません。
                         *
                         * ### HTTPレスポンス
                         * - 200 正常
                         * - 400 パラメータ不正
                         * - 401 未ログイン
                         * - 403 代理操作権限なし
                         * - 404 存在しないお気に入りリスト
                         * @returns 正常処理
                         */
                        get: (option?: { config?: T | undefined } | undefined) =>
                          fetch<Methods_kkxvgg['get']['resBody'], BasicHeaders, Methods_kkxvgg['get']['status']>(prefix, prefix6, GET, option).json(),
                        /**
                         * ### 概要
                         * 社員代理注文で選択中の店舗として、お気に入りリストの商品一覧を取得します。<br/>
                         * 通常のお気に入り詳細と同じレスポンス形式を返しますが、社員モードでは参照と注文利用のみ許可します。<br/>
                         * `isEditableByMe` と `canDuplicateByMe` は常に `false` です。<br/>
                         * 商品情報は社員代理注文の商品検索と同じく、サロン別ラインアップ制限を適用しません。
                         *
                         * ### HTTPレスポンス
                         * - 200 正常
                         * - 400 パラメータ不正
                         * - 401 未ログイン
                         * - 403 代理操作権限なし
                         * - 404 存在しないお気に入りリスト
                         * @returns 正常処理
                         */
                        $get: (option?: { config?: T | undefined } | undefined) =>
                          fetch<Methods_kkxvgg['get']['resBody'], BasicHeaders, Methods_kkxvgg['get']['status']>(prefix, prefix6, GET, option).json().then(r => r.body),
                        $path: () => `${prefix}${prefix6}`,
                      };
                    },
                  };
                },
                /**
                 * ### 概要
                 * 社員代理注文で選択中の店舗のお気に入りリスト一覧を取得します。<br/>
                 * 通常のお気に入り一覧と同じレスポンス形式を返しますが、社員モードでは参照と注文利用のみ許可します。<br/>
                 * `isEditableByMe` と `canDuplicateByMe` は常に `false` です。
                 *
                 * ### HTTPレスポンス
                 * - 200 正常
                 * - 401 未ログイン
                 * - 403 代理操作権限なし
                 * @returns 正常処理
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1n1hi9['get']['resBody'], BasicHeaders, Methods_1n1hi9['get']['status']>(prefix, `${prefix3}${PATH48}`, GET, option).json(),
                /**
                 * ### 概要
                 * 社員代理注文で選択中の店舗のお気に入りリスト一覧を取得します。<br/>
                 * 通常のお気に入り一覧と同じレスポンス形式を返しますが、社員モードでは参照と注文利用のみ許可します。<br/>
                 * `isEditableByMe` と `canDuplicateByMe` は常に `false` です。
                 *
                 * ### HTTPレスポンス
                 * - 200 正常
                 * - 401 未ログイン
                 * - 403 代理操作権限なし
                 * @returns 正常処理
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_1n1hi9['get']['resBody'], BasicHeaders, Methods_1n1hi9['get']['status']>(prefix, `${prefix3}${PATH48}`, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix3}${PATH48}`,
              },
              items: {
                _itemCode: (val5: string) => {
                  const prefix5 = `${prefix3}${PATH49}/${val5}`;

                  return {
                    /**
                     * 社員代理操作で選択した得意先の商品詳細を取得します。
                     * @returns 正常処理
                     */
                    get: (option?: { config?: T | undefined } | undefined) =>
                      fetch<Methods_l2naf9['get']['resBody'], BasicHeaders, Methods_l2naf9['get']['status']>(prefix, prefix5, GET, option).json(),
                    /**
                     * 社員代理操作で選択した得意先の商品詳細を取得します。
                     * @returns 正常処理
                     */
                    $get: (option?: { config?: T | undefined } | undefined) =>
                      fetch<Methods_l2naf9['get']['resBody'], BasicHeaders, Methods_l2naf9['get']['status']>(prefix, prefix5, GET, option).json().then(r => r.body),
                    $path: () => `${prefix}${prefix5}`,
                  };
                },
                count: {
                  /**
                   * 社員代理操作で選択した得意先の商品検索件数を取得します。
                   * @returns 正常処理
                   */
                  get: (option?: { query?: Methods_19qzqs['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                    fetch<Methods_19qzqs['get']['resBody'], BasicHeaders, Methods_19qzqs['get']['status']>(prefix, `${prefix3}${PATH50}`, GET, option).json(),
                  /**
                   * 社員代理操作で選択した得意先の商品検索件数を取得します。
                   * @returns 正常処理
                   */
                  $get: (option?: { query?: Methods_19qzqs['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                    fetch<Methods_19qzqs['get']['resBody'], BasicHeaders, Methods_19qzqs['get']['status']>(prefix, `${prefix3}${PATH50}`, GET, option).json().then(r => r.body),
                  $path: (option?: { method?: 'get' | undefined; query: Methods_19qzqs['get']['query'] } | undefined) =>
                    `${prefix}${prefix3}${PATH50}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
                },
                /**
                 * 社員代理操作で選択した得意先の商品検索を行います。<br/>
                 * サロン別ラインアップ制限は適用せず、販売中の商品を返却します。<br/>
                 * 指定した得意先を操作できない社員の場合は403を返します。
                 * @returns 正常処理
                 */
                get: (option: { query: Methods_ts07ag['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_ts07ag['get']['resBody'], BasicHeaders, Methods_ts07ag['get']['status']>(prefix, `${prefix3}${PATH49}`, GET, option).json(),
                /**
                 * 社員代理操作で選択した得意先の商品検索を行います。<br/>
                 * サロン別ラインアップ制限は適用せず、販売中の商品を返却します。<br/>
                 * 指定した得意先を操作できない社員の場合は403を返します。
                 * @returns 正常処理
                 */
                $get: (option: { query: Methods_ts07ag['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_ts07ag['get']['resBody'], BasicHeaders, Methods_ts07ag['get']['status']>(prefix, `${prefix3}${PATH49}`, GET, option).json().then(r => r.body),
                $path: (option?: { method?: 'get' | undefined; query: Methods_ts07ag['get']['query'] } | undefined) =>
                  `${prefix}${prefix3}${PATH49}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              },
              order_histories: {
                _salesOrderNo: (val5: string) => {
                  const prefix5 = `${prefix3}${PATH51}/${val5}`;

                  return {
                    /**
                     * 社員代理操作で選択した得意先の出荷済み注文詳細を受注番号で取得します。
                     * @returns 正常処理
                     */
                    get: (option?: { query?: Methods_1y9xd05['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                      fetch<Methods_1y9xd05['get']['resBody'], BasicHeaders, Methods_1y9xd05['get']['status']>(prefix, prefix5, GET, option).json(),
                    /**
                     * 社員代理操作で選択した得意先の出荷済み注文詳細を受注番号で取得します。
                     * @returns 正常処理
                     */
                    $get: (option?: { query?: Methods_1y9xd05['get']['query'] | undefined, config?: T | undefined } | undefined) =>
                      fetch<Methods_1y9xd05['get']['resBody'], BasicHeaders, Methods_1y9xd05['get']['status']>(prefix, prefix5, GET, option).json().then(r => r.body),
                    $path: (option?: { method?: 'get' | undefined; query: Methods_1y9xd05['get']['query'] } | undefined) =>
                      `${prefix}${prefix5}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
                  };
                },
                unshipped: {
                  /**
                   * 社員代理操作で選択した得意先の未出荷注文詳細を配送単位条件で取得します。
                   * @returns 正常処理
                   */
                  get: (option: { query: Methods_1byau1c['get']['query'], config?: T | undefined }) =>
                    fetch<Methods_1byau1c['get']['resBody'], BasicHeaders, Methods_1byau1c['get']['status']>(prefix, `${prefix3}${PATH52}`, GET, option).json(),
                  /**
                   * 社員代理操作で選択した得意先の未出荷注文詳細を配送単位条件で取得します。
                   * @returns 正常処理
                   */
                  $get: (option: { query: Methods_1byau1c['get']['query'], config?: T | undefined }) =>
                    fetch<Methods_1byau1c['get']['resBody'], BasicHeaders, Methods_1byau1c['get']['status']>(prefix, `${prefix3}${PATH52}`, GET, option).json().then(r => r.body),
                  $path: (option?: { method?: 'get' | undefined; query: Methods_1byau1c['get']['query'] } | undefined) =>
                    `${prefix}${prefix3}${PATH52}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
                },
                /**
                 * 社員代理操作で選択した得意先の注文履歴一覧を取得します。検索対象店舗はパスのstoreCodeに固定されます。
                 * @returns 正常処理
                 */
                post: (option: { body: Methods_mfoyxt['post']['reqBody'], query?: Methods_mfoyxt['post']['query'] | undefined, config?: T | undefined }) =>
                  fetch<Methods_mfoyxt['post']['resBody'], BasicHeaders, Methods_mfoyxt['post']['status']>(prefix, `${prefix3}${PATH51}`, POST, option).json(),
                /**
                 * 社員代理操作で選択した得意先の注文履歴一覧を取得します。検索対象店舗はパスのstoreCodeに固定されます。
                 * @returns 正常処理
                 */
                $post: (option: { body: Methods_mfoyxt['post']['reqBody'], query?: Methods_mfoyxt['post']['query'] | undefined, config?: T | undefined }) =>
                  fetch<Methods_mfoyxt['post']['resBody'], BasicHeaders, Methods_mfoyxt['post']['status']>(prefix, `${prefix3}${PATH51}`, POST, option).json().then(r => r.body),
                $path: (option?: { method: 'post'; query: Methods_mfoyxt['post']['query'] } | undefined) =>
                  `${prefix}${prefix3}${PATH51}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              },
              purchases: {
                _downloadId: (val5: string) => {
                  const prefix5 = `${prefix3}${PATH53}/${val5}`;

                  return {
                    download: {
                      /**
                       * ### 概要
                       * - ダウンロード受付した、CSVファイルの作成処理終了確認とダウンロードを行う。
                       * ### 処理仕様
                       * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                       * - ダウンロード受付し、作成されたCSVファイルをローカルにダウンロードする。
                       * - 処理中の場合、ファイル名と内容は空を返す。
                       * - 処理が完了した場合、ファイル名と内容が返る。
                       * - 処理中エラーが発生した場合はエラーが返りファイル内容等は返却されない。
                       * @returns 正常処理
                       */
                      get: (option?: { config?: T | undefined } | undefined) =>
                        fetch<Methods_95u1jd['get']['resBody'], BasicHeaders, Methods_95u1jd['get']['status']>(prefix, `${prefix5}${PATH28}`, GET, option).json(),
                      /**
                       * ### 概要
                       * - ダウンロード受付した、CSVファイルの作成処理終了確認とダウンロードを行う。
                       * ### 処理仕様
                       * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                       * - ダウンロード受付し、作成されたCSVファイルをローカルにダウンロードする。
                       * - 処理中の場合、ファイル名と内容は空を返す。
                       * - 処理が完了した場合、ファイル名と内容が返る。
                       * - 処理中エラーが発生した場合はエラーが返りファイル内容等は返却されない。
                       * @returns 正常処理
                       */
                      $get: (option?: { config?: T | undefined } | undefined) =>
                        fetch<Methods_95u1jd['get']['resBody'], BasicHeaders, Methods_95u1jd['get']['status']>(prefix, `${prefix5}${PATH28}`, GET, option).json().then(r => r.body),
                      $path: () => `${prefix}${prefix5}${PATH28}`,
                    },
                  };
                },
                makers: {
                  download: {
                    /**
                     * ### 概要
                     * - 仕入情報のメーカー別で一覧をCSVファイルダウンロード受付する。
                     * - ダウンロードのための、ダウンロードIDが返却される。
                     * ### 処理仕様
                     * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                     *
                     * - 検索条件に合致するメーカー別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
                     * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
                     *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
                     *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
                     *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
                     * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
                     * - ダウンロードする場合のファイル名は「仕入情報_メーカー別_yyyyMMddHHmmssfff.csv」とする。
                     *
                     * - パラメータから一覧取得条件を作成する。
                     * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                     * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                     * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                     * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                     * - 請求月の指定がない場合当月とする。
                     * - 値引き価格表示ありの場合は、値引き後の価格とする。
                     * - DBから結果を取得する。
                     * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
                     * - 上記の内容で処理を開始する。
                     *
                     * ### 並び順
                     * - メーカーコード
                     *
                     * ### HTTPレスポンス
                     * - 200 正常
                     * - 400 パラメータ不正
                     * - 401 未ログイン
                     * - 403 権限のない集計単位の指定
                     *
                     * ### CSVカラム
                     * 1. メーカー
                     * 1. メーカーコード
                     * 1. 数量
                     * 1. サロン価格
                     * @returns 正常処理
                     */
                    post: (option: { body: Methods_1b0j5zt['post']['reqBody'], config?: T | undefined }) =>
                      fetch<Methods_1b0j5zt['post']['resBody'], BasicHeaders, Methods_1b0j5zt['post']['status']>(prefix, `${prefix3}${PATH55}`, POST, option).json(),
                    /**
                     * ### 概要
                     * - 仕入情報のメーカー別で一覧をCSVファイルダウンロード受付する。
                     * - ダウンロードのための、ダウンロードIDが返却される。
                     * ### 処理仕様
                     * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                     *
                     * - 検索条件に合致するメーカー別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
                     * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
                     *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
                     *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
                     *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
                     * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
                     * - ダウンロードする場合のファイル名は「仕入情報_メーカー別_yyyyMMddHHmmssfff.csv」とする。
                     *
                     * - パラメータから一覧取得条件を作成する。
                     * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                     * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                     * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                     * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                     * - 請求月の指定がない場合当月とする。
                     * - 値引き価格表示ありの場合は、値引き後の価格とする。
                     * - DBから結果を取得する。
                     * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
                     * - 上記の内容で処理を開始する。
                     *
                     * ### 並び順
                     * - メーカーコード
                     *
                     * ### HTTPレスポンス
                     * - 200 正常
                     * - 400 パラメータ不正
                     * - 401 未ログイン
                     * - 403 権限のない集計単位の指定
                     *
                     * ### CSVカラム
                     * 1. メーカー
                     * 1. メーカーコード
                     * 1. 数量
                     * 1. サロン価格
                     * @returns 正常処理
                     */
                    $post: (option: { body: Methods_1b0j5zt['post']['reqBody'], config?: T | undefined }) =>
                      fetch<Methods_1b0j5zt['post']['resBody'], BasicHeaders, Methods_1b0j5zt['post']['status']>(prefix, `${prefix3}${PATH55}`, POST, option).json().then(r => r.body),
                    $path: () => `${prefix}${prefix3}${PATH55}`,
                  },
                  stores: {
                    download: {
                      /**
                       * ### 概要
                       * - 仕入情報のメーカー別店舗別で一覧をCSVファイルダウンロード処理受付する。
                       * - ダウンロードのための、ダウンロードIDが返却される。
                       *
                       * ### 処理仕様
                       * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                       *
                       * - 検索条件に合致するメーカ別店舗別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
                       * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
                       *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
                       *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
                       *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
                       * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
                       * - ダウンロードする場合のファイル名は「仕入情報_メーカ別店舗別_yyyyMMddHHmmssfff.csv」とする。
                       *
                       * - パラメータから一覧取得条件を作成する。
                       * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                       * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                       * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                       * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                       * - 請求月の指定がない場合当月とする。
                       * - 値引き価格表示ありの場合は、値引き後の価格とする。
                       * - DBから結果を取得する。
                       * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
                       * - 上記の内容で処理を開始する。
                       *
                       * ### 並び順
                       * - 店舗コード
                       * - メーカーコード
                       *
                       * ### HTTPレスポンス
                       * - 200 正常
                       * - 400 パラメータ不正
                       * - 401 未ログイン
                       * - 403 権限のない集計単位の指定
                       *
                       * ### CSVカラム
                       * 1. 店舗コード
                       * 1. 店舗名
                       * 1. メーカー名:金額(複数あり)
                       * @returns 正常処理
                       */
                      post: (option: { body: Methods_91ivc8['post']['reqBody'], config?: T | undefined }) =>
                        fetch<Methods_91ivc8['post']['resBody'], BasicHeaders, Methods_91ivc8['post']['status']>(prefix, `${prefix3}${PATH57}`, POST, option).json(),
                      /**
                       * ### 概要
                       * - 仕入情報のメーカー別店舗別で一覧をCSVファイルダウンロード処理受付する。
                       * - ダウンロードのための、ダウンロードIDが返却される。
                       *
                       * ### 処理仕様
                       * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                       *
                       * - 検索条件に合致するメーカ別店舗別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
                       * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
                       *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
                       *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
                       *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
                       * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
                       * - ダウンロードする場合のファイル名は「仕入情報_メーカ別店舗別_yyyyMMddHHmmssfff.csv」とする。
                       *
                       * - パラメータから一覧取得条件を作成する。
                       * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                       * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                       * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                       * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                       * - 請求月の指定がない場合当月とする。
                       * - 値引き価格表示ありの場合は、値引き後の価格とする。
                       * - DBから結果を取得する。
                       * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
                       * - 上記の内容で処理を開始する。
                       *
                       * ### 並び順
                       * - 店舗コード
                       * - メーカーコード
                       *
                       * ### HTTPレスポンス
                       * - 200 正常
                       * - 400 パラメータ不正
                       * - 401 未ログイン
                       * - 403 権限のない集計単位の指定
                       *
                       * ### CSVカラム
                       * 1. 店舗コード
                       * 1. 店舗名
                       * 1. メーカー名:金額(複数あり)
                       * @returns 正常処理
                       */
                      $post: (option: { body: Methods_91ivc8['post']['reqBody'], config?: T | undefined }) =>
                        fetch<Methods_91ivc8['post']['resBody'], BasicHeaders, Methods_91ivc8['post']['status']>(prefix, `${prefix3}${PATH57}`, POST, option).json().then(r => r.body),
                      $path: () => `${prefix}${prefix3}${PATH57}`,
                    },
                    /**
                     * ### 概要
                     * 仕入情報のメーカー別店舗別で一覧を取得する。
                     * ### 処理仕様
                     * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                     * - パラメータから一覧取得条件を作成する。
                     * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                     * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                     * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                     * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                     * - 請求月の指定がない場合当月とする。
                     * - 値引き価格表示ありの場合は、値引き後の価格とする。
                     * - DBから結果を取得する。
                     * - 結果を返す。
                     *
                     * ### 並び順
                     * - 店舗コード
                     * - メーカーコード
                     *
                     * ### HTTPレスポンス
                     * - 200 正常
                     * - 400 パラメータ不正
                     * - 401 未ログイン
                     * - 403 権限のない集計単位の指定
                     *
                     * ### カラム
                     * | No. | dataField | headerName | type |
                     * |-----|-----------|------------|------|
                     * | 1 | storeCode | 店舗コード | string |
                     * | 2 | storeName | 店舗名 | string |
                     * | 3 | price | メーカー名ごとに金額(複数あり) | integer |
                     * @returns 正常処理
                     */
                    get: (option: { query: Methods_149yu87['get']['query'], config?: T | undefined }) =>
                      fetch<Methods_149yu87['get']['resBody'], BasicHeaders, Methods_149yu87['get']['status']>(prefix, `${prefix3}${PATH56}`, GET, option).json(),
                    /**
                     * ### 概要
                     * 仕入情報のメーカー別店舗別で一覧を取得する。
                     * ### 処理仕様
                     * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                     * - パラメータから一覧取得条件を作成する。
                     * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                     * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                     * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                     * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                     * - 請求月の指定がない場合当月とする。
                     * - 値引き価格表示ありの場合は、値引き後の価格とする。
                     * - DBから結果を取得する。
                     * - 結果を返す。
                     *
                     * ### 並び順
                     * - 店舗コード
                     * - メーカーコード
                     *
                     * ### HTTPレスポンス
                     * - 200 正常
                     * - 400 パラメータ不正
                     * - 401 未ログイン
                     * - 403 権限のない集計単位の指定
                     *
                     * ### カラム
                     * | No. | dataField | headerName | type |
                     * |-----|-----------|------------|------|
                     * | 1 | storeCode | 店舗コード | string |
                     * | 2 | storeName | 店舗名 | string |
                     * | 3 | price | メーカー名ごとに金額(複数あり) | integer |
                     * @returns 正常処理
                     */
                    $get: (option: { query: Methods_149yu87['get']['query'], config?: T | undefined }) =>
                      fetch<Methods_149yu87['get']['resBody'], BasicHeaders, Methods_149yu87['get']['status']>(prefix, `${prefix3}${PATH56}`, GET, option).json().then(r => r.body),
                    $path: (option?: { method?: 'get' | undefined; query: Methods_149yu87['get']['query'] } | undefined) =>
                      `${prefix}${prefix3}${PATH56}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
                  },
                  /**
                   * ### 概要
                   * 仕入情報のメーカー別で一覧を取得する。
                   * ### 処理仕様
                   * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                   *
                   * - パラメータから一覧取得条件を作成する。
                   * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                   * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                   * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                   * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                   * - 請求月の指定がない場合当月とする。
                   * - DBから結果を取得する。
                   * - 結果を返す。
                   * - (追記)出荷数量で「０」の場合、「欠品」として表示する。
                   *
                   * ### 並び順
                   * - メーカーコード
                   *
                   * ### HTTPレスポンス
                   * - 200 正常
                   * - 400 パラメータ不正
                   * - 401 未ログイン
                   * - 403 権限のない集計単位の指定
                   *
                   * ### カラム
                   * | No. | dataField | headerName | type |
                   * |-----|-----------|------------|------|
                   * | 1 | makerName | メーカー | string |
                   * | 2 | makerCode | メーカーコード | string |
                   * | 3 | orderQuantity | 受注数量 | integer |
                   * | 4 | quantity | 出荷数量 | string |
                   * | 5 | salonPrice | サロン価格 | integer |
                   * @returns 正常処理
                   */
                  get: (option: { query: Methods_w5h37s['get']['query'], config?: T | undefined }) =>
                    fetch<Methods_w5h37s['get']['resBody'], BasicHeaders, Methods_w5h37s['get']['status']>(prefix, `${prefix3}${PATH54}`, GET, option).json(),
                  /**
                   * ### 概要
                   * 仕入情報のメーカー別で一覧を取得する。
                   * ### 処理仕様
                   * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                   *
                   * - パラメータから一覧取得条件を作成する。
                   * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                   * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                   * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                   * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                   * - 請求月の指定がない場合当月とする。
                   * - DBから結果を取得する。
                   * - 結果を返す。
                   * - (追記)出荷数量で「０」の場合、「欠品」として表示する。
                   *
                   * ### 並び順
                   * - メーカーコード
                   *
                   * ### HTTPレスポンス
                   * - 200 正常
                   * - 400 パラメータ不正
                   * - 401 未ログイン
                   * - 403 権限のない集計単位の指定
                   *
                   * ### カラム
                   * | No. | dataField | headerName | type |
                   * |-----|-----------|------------|------|
                   * | 1 | makerName | メーカー | string |
                   * | 2 | makerCode | メーカーコード | string |
                   * | 3 | orderQuantity | 受注数量 | integer |
                   * | 4 | quantity | 出荷数量 | string |
                   * | 5 | salonPrice | サロン価格 | integer |
                   * @returns 正常処理
                   */
                  $get: (option: { query: Methods_w5h37s['get']['query'], config?: T | undefined }) =>
                    fetch<Methods_w5h37s['get']['resBody'], BasicHeaders, Methods_w5h37s['get']['status']>(prefix, `${prefix3}${PATH54}`, GET, option).json().then(r => r.body),
                  $path: (option?: { method?: 'get' | undefined; query: Methods_w5h37s['get']['query'] } | undefined) =>
                    `${prefix}${prefix3}${PATH54}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
                },
                stores: {
                  download: {
                    /**
                     * ### 概要
                     * - 仕入情報の店舗別で一覧をCSVファイルダウンロード受付する。
                     * - ダウンロードのための、ダウンロードIDが返却される。
                     *
                     * ### 処理仕様
                     * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                     *
                     * - 検索条件に合致する店舗別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
                     * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
                     *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
                     *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
                     *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
                     * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
                     * - ダウンロードする場合のファイル名は「仕入情報_店舗別_yyyyMMddHHmmssfff.csv」とする。
                     *
                     * - パラメータから一覧取得条件を作成する。
                     * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                     * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                     * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                     * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                     * - 請求月の指定がない場合当月とする。
                     * - DBから結果を取得する。
                     * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
                     * - 上記の内容で処理を開始する。
                     *
                     * ### 並び順
                     * - 店舗コード
                     *
                     * ### HTTPレスポンス
                     * - 200 正常
                     * - 400 パラメータ不正
                     * - 401 未ログイン
                     * - 403 権限のない集計単位の指定
                     *
                     * ### CSVカラム
                     * 1. 店舗コード
                     * 1. 店舗名
                     * 1. 数量
                     * 1. サロン価格
                     * @returns 正常処理
                     */
                    post: (option: { body: Methods_ek0dck['post']['reqBody'], config?: T | undefined }) =>
                      fetch<Methods_ek0dck['post']['resBody'], BasicHeaders, Methods_ek0dck['post']['status']>(prefix, `${prefix3}${PATH59}`, POST, option).json(),
                    /**
                     * ### 概要
                     * - 仕入情報の店舗別で一覧をCSVファイルダウンロード受付する。
                     * - ダウンロードのための、ダウンロードIDが返却される。
                     *
                     * ### 処理仕様
                     * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                     *
                     * - 検索条件に合致する店舗別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
                     * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
                     *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
                     *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
                     *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
                     * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
                     * - ダウンロードする場合のファイル名は「仕入情報_店舗別_yyyyMMddHHmmssfff.csv」とする。
                     *
                     * - パラメータから一覧取得条件を作成する。
                     * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                     * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                     * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                     * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                     * - 請求月の指定がない場合当月とする。
                     * - DBから結果を取得する。
                     * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
                     * - 上記の内容で処理を開始する。
                     *
                     * ### 並び順
                     * - 店舗コード
                     *
                     * ### HTTPレスポンス
                     * - 200 正常
                     * - 400 パラメータ不正
                     * - 401 未ログイン
                     * - 403 権限のない集計単位の指定
                     *
                     * ### CSVカラム
                     * 1. 店舗コード
                     * 1. 店舗名
                     * 1. 数量
                     * 1. サロン価格
                     * @returns 正常処理
                     */
                    $post: (option: { body: Methods_ek0dck['post']['reqBody'], config?: T | undefined }) =>
                      fetch<Methods_ek0dck['post']['resBody'], BasicHeaders, Methods_ek0dck['post']['status']>(prefix, `${prefix3}${PATH59}`, POST, option).json().then(r => r.body),
                    $path: () => `${prefix}${prefix3}${PATH59}`,
                  },
                  makers: {
                    sales_types: {
                      download: {
                        /**
                         * ### 概要
                         * - 仕入情報の店舗別メーカー別売上種別別で金額一覧をCSVファイルダウンロード処理受付する。
                         * - ダウンロードのための、ダウンロードIDが返却される。
                         * ### 処理仕様
                         * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                         *
                         * - 検索条件に合致する店舗別メーカー別売上種別別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
                         * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
                         *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
                         *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
                         *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
                         * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
                         * - ダウンロードする場合のファイル名は「仕入情報_店舗別メーカー別売上種別別_yyyyMMddHHmmssfff.csv」とする。
                         *
                         * - パラメータから一覧取得条件を作成する。
                         * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                         * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                         * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                         * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                         * - 請求月の指定がない場合当月とする。
                         * - 値引き価格表示ありの場合は、値引き後の価格とする。
                         * - DBから結果を取得する。
                         * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
                         * - 上記の内容で処理を開始する。
                         *
                         * ### 並び順
                         * - 店舗コード
                         * - メーカーコード
                         * - 売上種別コード
                         *
                         * ### HTTPレスポンス
                         * - 200 正常
                         * - 400 パラメータ不正
                         * - 401 未ログイン
                         * - 403 権限のない集計単位の指定
                         *
                         * ### CSVカラム
                         * 1. 店舗コード
                         * 1. 店舗名
                         * 1. メーカー名(複数あり)
                         * 1. 売上種別(複数あり)
                         * @returns 正常処理
                         */
                        post: (option: { body: Methods_glrecz['post']['reqBody'], config?: T | undefined }) =>
                          fetch<Methods_glrecz['post']['resBody'], BasicHeaders, Methods_glrecz['post']['status']>(prefix, `${prefix3}${PATH61}`, POST, option).json(),
                        /**
                         * ### 概要
                         * - 仕入情報の店舗別メーカー別売上種別別で金額一覧をCSVファイルダウンロード処理受付する。
                         * - ダウンロードのための、ダウンロードIDが返却される。
                         * ### 処理仕様
                         * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                         *
                         * - 検索条件に合致する店舗別メーカー別売上種別別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
                         * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
                         *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
                         *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
                         *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
                         * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
                         * - ダウンロードする場合のファイル名は「仕入情報_店舗別メーカー別売上種別別_yyyyMMddHHmmssfff.csv」とする。
                         *
                         * - パラメータから一覧取得条件を作成する。
                         * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                         * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                         * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                         * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                         * - 請求月の指定がない場合当月とする。
                         * - 値引き価格表示ありの場合は、値引き後の価格とする。
                         * - DBから結果を取得する。
                         * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
                         * - 上記の内容で処理を開始する。
                         *
                         * ### 並び順
                         * - 店舗コード
                         * - メーカーコード
                         * - 売上種別コード
                         *
                         * ### HTTPレスポンス
                         * - 200 正常
                         * - 400 パラメータ不正
                         * - 401 未ログイン
                         * - 403 権限のない集計単位の指定
                         *
                         * ### CSVカラム
                         * 1. 店舗コード
                         * 1. 店舗名
                         * 1. メーカー名(複数あり)
                         * 1. 売上種別(複数あり)
                         * @returns 正常処理
                         */
                        $post: (option: { body: Methods_glrecz['post']['reqBody'], config?: T | undefined }) =>
                          fetch<Methods_glrecz['post']['resBody'], BasicHeaders, Methods_glrecz['post']['status']>(prefix, `${prefix3}${PATH61}`, POST, option).json().then(r => r.body),
                        $path: () => `${prefix}${prefix3}${PATH61}`,
                      },
                      /**
                       * ### 概要
                       * 仕入情報の店舗別メーカー別売上種別別で一覧を取得する。
                       * ### 処理仕様
                       * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                       * - パラメータから一覧取得条件を作成する。
                       * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                       * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                       * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                       * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                       * - 請求月の指定がない場合当月とする。
                       * - 値引き価格表示ありの場合は、値引き後の価格とする。
                       * - DBから結果を取得する。
                       * - 結果を返す。
                       *
                       * ### 並び順
                       * - 店舗コード
                       * - メーカーコード
                       * - 売上種別コード
                       *
                       * ### HTTPレスポンス
                       * - 200 正常
                       * - 400 パラメータ不正
                       * - 401 未ログイン
                       * - 403 権限のない集計単位の指定
                       *
                       * ### カラム
                       * | No. | dataField | headerName | type |
                       * |-----|-----------|------------|------|
                       * | 1 | storeCode | 店舗コード | string |
                       * | 2 | storeName | 店舗名 | string |
                       * | 3 | makerName | メーカー名(複数あり) | string |
                       * | 4 | price | 売上種別ごとの金額(複数あり) | integer |
                       * @returns 正常処理
                       */
                      get: (option: { query: Methods_vlzpzm['get']['query'], config?: T | undefined }) =>
                        fetch<Methods_vlzpzm['get']['resBody'], BasicHeaders, Methods_vlzpzm['get']['status']>(prefix, `${prefix3}${PATH60}`, GET, option).json(),
                      /**
                       * ### 概要
                       * 仕入情報の店舗別メーカー別売上種別別で一覧を取得する。
                       * ### 処理仕様
                       * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                       * - パラメータから一覧取得条件を作成する。
                       * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                       * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                       * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                       * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                       * - 請求月の指定がない場合当月とする。
                       * - 値引き価格表示ありの場合は、値引き後の価格とする。
                       * - DBから結果を取得する。
                       * - 結果を返す。
                       *
                       * ### 並び順
                       * - 店舗コード
                       * - メーカーコード
                       * - 売上種別コード
                       *
                       * ### HTTPレスポンス
                       * - 200 正常
                       * - 400 パラメータ不正
                       * - 401 未ログイン
                       * - 403 権限のない集計単位の指定
                       *
                       * ### カラム
                       * | No. | dataField | headerName | type |
                       * |-----|-----------|------------|------|
                       * | 1 | storeCode | 店舗コード | string |
                       * | 2 | storeName | 店舗名 | string |
                       * | 3 | makerName | メーカー名(複数あり) | string |
                       * | 4 | price | 売上種別ごとの金額(複数あり) | integer |
                       * @returns 正常処理
                       */
                      $get: (option: { query: Methods_vlzpzm['get']['query'], config?: T | undefined }) =>
                        fetch<Methods_vlzpzm['get']['resBody'], BasicHeaders, Methods_vlzpzm['get']['status']>(prefix, `${prefix3}${PATH60}`, GET, option).json().then(r => r.body),
                      $path: (option?: { method?: 'get' | undefined; query: Methods_vlzpzm['get']['query'] } | undefined) =>
                        `${prefix}${prefix3}${PATH60}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
                    },
                  },
                  sales_types: {
                    download: {
                      /**
                       * ### 概要
                       * - 仕入情報の店舗別売上種別別で一覧をCSVファイルダウンロード処理受付する。
                       * - ダウンロードのための、ダウンロードIDが返却される。
                       *
                       * ### 処理仕様
                       * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                       *
                       * - 検索条件に合致する店舗別売上種別別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
                       * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
                       *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
                       *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
                       *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
                       * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
                       * - ダウンロードする場合のファイル名は「仕入情報_店舗別売上種別別_yyyyMMddHHmmssfff.csv」とする。
                       *
                       * - パラメータから一覧取得条件を作成する。
                       * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                       * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                       * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                       * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                       * - 請求月の指定がない場合当月とする。
                       * - 値引き価格表示ありの場合は、値引き後の価格とする。
                       * - DBから結果を取得する。
                       * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
                       * - 上記の内容で処理を開始する。
                       * ### 並び順
                       * - 店舗コード
                       * - 売上種別コード
                       *
                       * ### HTTPレスポンス
                       * - 200 正常
                       * - 400 パラメータ不正
                       * - 401 未ログイン
                       * - 403 権限のない集計単位の指定
                       *
                       * ### CSVカラム
                       * 1. 店舗コード
                       * 1. 店舗名
                       * 1. 売上種別(複数あり)
                       * @returns 正常処理
                       */
                      post: (option: { body: Methods_hn88jt['post']['reqBody'], config?: T | undefined }) =>
                        fetch<Methods_hn88jt['post']['resBody'], BasicHeaders, Methods_hn88jt['post']['status']>(prefix, `${prefix3}${PATH63}`, POST, option).json(),
                      /**
                       * ### 概要
                       * - 仕入情報の店舗別売上種別別で一覧をCSVファイルダウンロード処理受付する。
                       * - ダウンロードのための、ダウンロードIDが返却される。
                       *
                       * ### 処理仕様
                       * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                       *
                       * - 検索条件に合致する店舗別売上種別別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
                       * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
                       *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
                       *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
                       *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
                       * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
                       * - ダウンロードする場合のファイル名は「仕入情報_店舗別売上種別別_yyyyMMddHHmmssfff.csv」とする。
                       *
                       * - パラメータから一覧取得条件を作成する。
                       * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                       * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                       * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                       * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                       * - 請求月の指定がない場合当月とする。
                       * - 値引き価格表示ありの場合は、値引き後の価格とする。
                       * - DBから結果を取得する。
                       * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
                       * - 上記の内容で処理を開始する。
                       * ### 並び順
                       * - 店舗コード
                       * - 売上種別コード
                       *
                       * ### HTTPレスポンス
                       * - 200 正常
                       * - 400 パラメータ不正
                       * - 401 未ログイン
                       * - 403 権限のない集計単位の指定
                       *
                       * ### CSVカラム
                       * 1. 店舗コード
                       * 1. 店舗名
                       * 1. 売上種別(複数あり)
                       * @returns 正常処理
                       */
                      $post: (option: { body: Methods_hn88jt['post']['reqBody'], config?: T | undefined }) =>
                        fetch<Methods_hn88jt['post']['resBody'], BasicHeaders, Methods_hn88jt['post']['status']>(prefix, `${prefix3}${PATH63}`, POST, option).json().then(r => r.body),
                      $path: () => `${prefix}${prefix3}${PATH63}`,
                    },
                    /**
                     * ### 概要
                     * 仕入情報の店舗別売上種別別で一覧を取得する。
                     * ### 処理仕様
                     * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                     * - パラメータから一覧取得条件を作成する。
                     * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                     * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                     * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                     * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                     * - 請求月の指定がない場合当月とする。
                     * - 値引き価格表示ありの場合は、値引き後の価格とする。
                     * - DBから結果を取得する。
                     * - 結果を返す。
                     *
                     * ### 並び順
                     * - 店舗コード
                     * - 売上種別コード
                     *
                     * ### HTTPレスポンス
                     * - 200 正常
                     * - 400 パラメータ不正
                     * - 401 未ログイン
                     * - 403 権限のない集計単位の指定
                     *
                     * ### カラム
                     * | No. | dataField | headerName | type |
                     * |-----|-----------|------------|------|
                     * | 1 | storeCode | 店舗コード | string |
                     * | 2 | storeName | 店舗名 | string |
                     * | 3 | price | 売上種別ごとの金額(複数あり) | integer |
                     * @returns 正常処理
                     */
                    get: (option: { query: Methods_7wgm9k['get']['query'], config?: T | undefined }) =>
                      fetch<Methods_7wgm9k['get']['resBody'], BasicHeaders, Methods_7wgm9k['get']['status']>(prefix, `${prefix3}${PATH62}`, GET, option).json(),
                    /**
                     * ### 概要
                     * 仕入情報の店舗別売上種別別で一覧を取得する。
                     * ### 処理仕様
                     * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                     * - パラメータから一覧取得条件を作成する。
                     * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                     * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                     * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                     * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                     * - 請求月の指定がない場合当月とする。
                     * - 値引き価格表示ありの場合は、値引き後の価格とする。
                     * - DBから結果を取得する。
                     * - 結果を返す。
                     *
                     * ### 並び順
                     * - 店舗コード
                     * - 売上種別コード
                     *
                     * ### HTTPレスポンス
                     * - 200 正常
                     * - 400 パラメータ不正
                     * - 401 未ログイン
                     * - 403 権限のない集計単位の指定
                     *
                     * ### カラム
                     * | No. | dataField | headerName | type |
                     * |-----|-----------|------------|------|
                     * | 1 | storeCode | 店舗コード | string |
                     * | 2 | storeName | 店舗名 | string |
                     * | 3 | price | 売上種別ごとの金額(複数あり) | integer |
                     * @returns 正常処理
                     */
                    $get: (option: { query: Methods_7wgm9k['get']['query'], config?: T | undefined }) =>
                      fetch<Methods_7wgm9k['get']['resBody'], BasicHeaders, Methods_7wgm9k['get']['status']>(prefix, `${prefix3}${PATH62}`, GET, option).json().then(r => r.body),
                    $path: (option?: { method?: 'get' | undefined; query: Methods_7wgm9k['get']['query'] } | undefined) =>
                      `${prefix}${prefix3}${PATH62}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
                  },
                  /**
                   * ### 概要
                   * 仕入情報の店舗別で一覧を取得する。
                   * ### 処理仕様
                   * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                   * - パラメータから一覧取得条件を作成する。
                   * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                   * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                   * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                   * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                   * - 請求月の指定がない場合当月とする。
                   * - 値引き価格表示ありの場合は、値引き後の価格とする。
                   * - DBから結果を取得する。
                   * - 結果を返す。
                   * - (追記)出荷数量で「０」の場合、「欠品」として表示する。
                   *
                   * ### 並び順
                   * - 店舗コード
                   *
                   * ### HTTPレスポンス
                   * - 200 正常
                   * - 400 パラメータ不正
                   * - 401 未ログイン
                   * - 403 権限のない集計単位の指定
                   *
                   * ### カラム
                   * | No. | dataField | headerName | type |
                   * |-----|-----------|------------|------|
                   * | 1 | storeCode | 店舗コード | string |
                   * | 2 | storeName | 店舗名 | string |
                   * | 3 | orderQuantity | 受注数量 | integer |
                   * | 4 | quantity | 出荷数量 | string |
                   * | 5 | salonPrice | サロン価格 | integer |
                   * @returns 正常処理
                   */
                  get: (option: { query: Methods_1eg1rsb['get']['query'], config?: T | undefined }) =>
                    fetch<Methods_1eg1rsb['get']['resBody'], BasicHeaders, Methods_1eg1rsb['get']['status']>(prefix, `${prefix3}${PATH58}`, GET, option).json(),
                  /**
                   * ### 概要
                   * 仕入情報の店舗別で一覧を取得する。
                   * ### 処理仕様
                   * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                   * - パラメータから一覧取得条件を作成する。
                   * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                   * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                   * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                   * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                   * - 請求月の指定がない場合当月とする。
                   * - 値引き価格表示ありの場合は、値引き後の価格とする。
                   * - DBから結果を取得する。
                   * - 結果を返す。
                   * - (追記)出荷数量で「０」の場合、「欠品」として表示する。
                   *
                   * ### 並び順
                   * - 店舗コード
                   *
                   * ### HTTPレスポンス
                   * - 200 正常
                   * - 400 パラメータ不正
                   * - 401 未ログイン
                   * - 403 権限のない集計単位の指定
                   *
                   * ### カラム
                   * | No. | dataField | headerName | type |
                   * |-----|-----------|------------|------|
                   * | 1 | storeCode | 店舗コード | string |
                   * | 2 | storeName | 店舗名 | string |
                   * | 3 | orderQuantity | 受注数量 | integer |
                   * | 4 | quantity | 出荷数量 | string |
                   * | 5 | salonPrice | サロン価格 | integer |
                   * @returns 正常処理
                   */
                  $get: (option: { query: Methods_1eg1rsb['get']['query'], config?: T | undefined }) =>
                    fetch<Methods_1eg1rsb['get']['resBody'], BasicHeaders, Methods_1eg1rsb['get']['status']>(prefix, `${prefix3}${PATH58}`, GET, option).json().then(r => r.body),
                  $path: (option?: { method?: 'get' | undefined; query: Methods_1eg1rsb['get']['query'] } | undefined) =>
                    `${prefix}${prefix3}${PATH58}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
                },
              },
              sales_details: {
                download: {
                  /**
                   * ### 概要
                   * - 売上明細の一覧を取得しCSVをダウンロード処理受付する。
                   * - 検索結果が0件の場合、ヘッダのみを返却する。
                   * - ダウンロードのための、ダウンロードIDが返却される。
                   * ### 処理仕様
                   * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                   *
                   * - 検索条件に合致する売上明細結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
                   * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
                   *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
                   *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
                   *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
                   * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
                   * - ダウンロードする場合のファイル名は「仕入情報_売上明細_yyyyMMddHHmmssfff.csv」とする。
                   *
                   * - パラメータから検索条件を作成する。
                   * - 指定された集計単位の店舗コードを対象に検索する。店舗コードが指定されている場合、指定された店舗コードで検索する。
                   * - 集計対象に注文を指定した場合、注文日、または、出荷日で抽出する。注文日、出荷日の指定がない場合、当月分の注文日を指定する。
                   * - 商品コードは前方一致で絞り込みを行う。
                   * - 集計対象に請求を指定した場合、請求月で抽出を行する。請求月の指定がない場合、当月の請求月を指定する。
                   * - DBから売上明細情報を取得する。
                   * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
                   * - 結果を返す。
                   * ### 並び順
                   * 1. 受注日の降順
                   * 1. 売上番号
                   * 1. 売上行番号
                   * ### HTTPレスポンス
                   * - 200 正常
                   * - 400 パラメータ不正
                   * - 401 未ログイン
                   * - 403 権限のない集計単位の指定
                   * ### CSVカラム
                   * 1. 受注日
                   * 1. 出荷日
                   * 1. 売上番号
                   * 1. 売上行番号
                   * 1. 店舗コード
                   * 1. 店舗名
                   * 1. 売上種別
                   * 1. メーカー
                   * 1. 商品コード
                   * 1. 商品名
                   * 1. JANコード
                   * 1. カテゴリ
                   * 1. 数量
                   * 1. 単価
                   * 1. 金額
                   * 1. 備考
                   * 1. サロン価格
                   * 1. メーカー希望小売価格
                   * 1. 取り込み番号
                   * @returns 正常処理
                   */
                  post: (option: { body: Methods_107izuc['post']['reqBody'], config?: T | undefined }) =>
                    fetch<Methods_107izuc['post']['resBody'], BasicHeaders, Methods_107izuc['post']['status']>(prefix, `${prefix3}${PATH65}`, POST, option).json(),
                  /**
                   * ### 概要
                   * - 売上明細の一覧を取得しCSVをダウンロード処理受付する。
                   * - 検索結果が0件の場合、ヘッダのみを返却する。
                   * - ダウンロードのための、ダウンロードIDが返却される。
                   * ### 処理仕様
                   * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                   *
                   * - 検索条件に合致する売上明細結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
                   * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
                   *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
                   *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
                   *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
                   * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
                   * - ダウンロードする場合のファイル名は「仕入情報_売上明細_yyyyMMddHHmmssfff.csv」とする。
                   *
                   * - パラメータから検索条件を作成する。
                   * - 指定された集計単位の店舗コードを対象に検索する。店舗コードが指定されている場合、指定された店舗コードで検索する。
                   * - 集計対象に注文を指定した場合、注文日、または、出荷日で抽出する。注文日、出荷日の指定がない場合、当月分の注文日を指定する。
                   * - 商品コードは前方一致で絞り込みを行う。
                   * - 集計対象に請求を指定した場合、請求月で抽出を行する。請求月の指定がない場合、当月の請求月を指定する。
                   * - DBから売上明細情報を取得する。
                   * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
                   * - 結果を返す。
                   * ### 並び順
                   * 1. 受注日の降順
                   * 1. 売上番号
                   * 1. 売上行番号
                   * ### HTTPレスポンス
                   * - 200 正常
                   * - 400 パラメータ不正
                   * - 401 未ログイン
                   * - 403 権限のない集計単位の指定
                   * ### CSVカラム
                   * 1. 受注日
                   * 1. 出荷日
                   * 1. 売上番号
                   * 1. 売上行番号
                   * 1. 店舗コード
                   * 1. 店舗名
                   * 1. 売上種別
                   * 1. メーカー
                   * 1. 商品コード
                   * 1. 商品名
                   * 1. JANコード
                   * 1. カテゴリ
                   * 1. 数量
                   * 1. 単価
                   * 1. 金額
                   * 1. 備考
                   * 1. サロン価格
                   * 1. メーカー希望小売価格
                   * 1. 取り込み番号
                   * @returns 正常処理
                   */
                  $post: (option: { body: Methods_107izuc['post']['reqBody'], config?: T | undefined }) =>
                    fetch<Methods_107izuc['post']['resBody'], BasicHeaders, Methods_107izuc['post']['status']>(prefix, `${prefix3}${PATH65}`, POST, option).json().then(r => r.body),
                  $path: () => `${prefix}${prefix3}${PATH65}`,
                },
                /**
                 * ### 概要
                 * - 売上明細の一覧を取得する。
                 * ### 処理仕様
                 * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                 * - パラメータから検索条件を作成する。
                 * - 指定された集計単位の店舗コードを対象に検索する。店舗コードが指定されている場合、指定された店舗コードで検索する。
                 * - 集計対象に注文を指定した場合、注文日、または、出荷日で抽出する。注文日、出荷日の指定がない場合、当月分の注文日を指定する。
                 * - 商品コードは前方一致で絞り込みを行う。
                 * - 集計対象に請求を指定した場合、請求月で抽出を行する。請求月の指定がない場合、当月の請求月を指定する。
                 * - DBから明細情報を取得し返却する。
                 * - (追記)出荷数量で「０」の場合、「欠品」として表示する。
                 * ### 並び順
                 * 1. 受注日の降順
                 * 1. 売上番号
                 * 1. 売上行番号
                 * ### HTTPレスポンス
                 * - 200 正常
                 * - 400 パラメータ不正
                 * - 401 未ログイン
                 * - 403 権限のない集計単位の指定
                 *
                 * ### カラム
                 * | No. | dataField | headerName | type |
                 * |-----|-----------|------------|------|
                 * | 1 | orderDate | 受注日 | string |
                 * | 2 | shippingDate | 出荷日 | string |
                 * | 3 | salesNo | 売上番号 | string |
                 * | 4 | salesRowNo | 売上行番号 | string |
                 * | 5 | storeCode | 店舗コード | string |
                 * | 6 | storeName | 店舗名 | string |
                 * | 7 | salesType | 売上種別 | string |
                 * | 8 | makerName | メーカー | string |
                 * | 9 | itemCode | 商品コード | string |
                 * | 10 | itemName | 商品名 | string |
                 * | 11 | janCode | JANコード | string |
                 * | 12 | categoryName | カテゴリ | string |
                 * | 13 | orderQuantity | 受注数量 | integer |
                 * | 14 | quantity | 出荷数量 | string |
                 * | 15 | discountPrice| 単価 | integer |
                 * | 16 | totalPrice | 金額 | integer |
                 * | 17 | note | 備考 | string |
                 * | 18 | salonPrice | サロン価格 | integer |
                 * | 19 | retailPrice | メーカー希望小売価格 | integer |
                 * | 20 | importNo | 取り込み番号 | string |
                 * @returns 正常処理
                 */
                get: (option: { query: Methods_fjnb2j['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_fjnb2j['get']['resBody'], BasicHeaders, Methods_fjnb2j['get']['status']>(prefix, `${prefix3}${PATH64}`, GET, option).json(),
                /**
                 * ### 概要
                 * - 売上明細の一覧を取得する。
                 * ### 処理仕様
                 * - 社員モードでは、代理操作対象店舗に対して社員が作成した注文・仕入情報のみを対象とする。
                 * - パラメータから検索条件を作成する。
                 * - 指定された集計単位の店舗コードを対象に検索する。店舗コードが指定されている場合、指定された店舗コードで検索する。
                 * - 集計対象に注文を指定した場合、注文日、または、出荷日で抽出する。注文日、出荷日の指定がない場合、当月分の注文日を指定する。
                 * - 商品コードは前方一致で絞り込みを行う。
                 * - 集計対象に請求を指定した場合、請求月で抽出を行する。請求月の指定がない場合、当月の請求月を指定する。
                 * - DBから明細情報を取得し返却する。
                 * - (追記)出荷数量で「０」の場合、「欠品」として表示する。
                 * ### 並び順
                 * 1. 受注日の降順
                 * 1. 売上番号
                 * 1. 売上行番号
                 * ### HTTPレスポンス
                 * - 200 正常
                 * - 400 パラメータ不正
                 * - 401 未ログイン
                 * - 403 権限のない集計単位の指定
                 *
                 * ### カラム
                 * | No. | dataField | headerName | type |
                 * |-----|-----------|------------|------|
                 * | 1 | orderDate | 受注日 | string |
                 * | 2 | shippingDate | 出荷日 | string |
                 * | 3 | salesNo | 売上番号 | string |
                 * | 4 | salesRowNo | 売上行番号 | string |
                 * | 5 | storeCode | 店舗コード | string |
                 * | 6 | storeName | 店舗名 | string |
                 * | 7 | salesType | 売上種別 | string |
                 * | 8 | makerName | メーカー | string |
                 * | 9 | itemCode | 商品コード | string |
                 * | 10 | itemName | 商品名 | string |
                 * | 11 | janCode | JANコード | string |
                 * | 12 | categoryName | カテゴリ | string |
                 * | 13 | orderQuantity | 受注数量 | integer |
                 * | 14 | quantity | 出荷数量 | string |
                 * | 15 | discountPrice| 単価 | integer |
                 * | 16 | totalPrice | 金額 | integer |
                 * | 17 | note | 備考 | string |
                 * | 18 | salonPrice | サロン価格 | integer |
                 * | 19 | retailPrice | メーカー希望小売価格 | integer |
                 * | 20 | importNo | 取り込み番号 | string |
                 * @returns 正常処理
                 */
                $get: (option: { query: Methods_fjnb2j['get']['query'], config?: T | undefined }) =>
                  fetch<Methods_fjnb2j['get']['resBody'], BasicHeaders, Methods_fjnb2j['get']['status']>(prefix, `${prefix3}${PATH64}`, GET, option).json().then(r => r.body),
                $path: (option?: { method?: 'get' | undefined; query: Methods_fjnb2j['get']['query'] } | undefined) =>
                  `${prefix}${prefix3}${PATH64}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
              },
            };
          },
          /**
           * 社員が代理操作できる店舗一覧を取得します。<br/>
           * ログイン社員の所属事業所に紐づく店舗のみ返します。<br/>
           * @returns 正常処理
           */
          get: (option?: { query?: Methods_152s4mw['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_152s4mw['get']['resBody'], BasicHeaders, Methods_152s4mw['get']['status']>(prefix, PATH35, GET, option).json(),
          /**
           * 社員が代理操作できる店舗一覧を取得します。<br/>
           * ログイン社員の所属事業所に紐づく店舗のみ返します。<br/>
           * @returns 正常処理
           */
          $get: (option?: { query?: Methods_152s4mw['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_152s4mw['get']['resBody'], BasicHeaders, Methods_152s4mw['get']['status']>(prefix, PATH35, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_152s4mw['get']['query'] } | undefined) =>
            `${prefix}${PATH35}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        sales_types: {
          /**
           * 社員モードで利用する売上種別一覧を取得します。
           * 取得結果の並び順は、売上種別コードの昇順になります。
           * @returns 正常処理
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_9xkihr['get']['resBody'], BasicHeaders, Methods_9xkihr['get']['status']>(prefix, PATH66, GET, option).json(),
          /**
           * 社員モードで利用する売上種別一覧を取得します。
           * 取得結果の並び順は、売上種別コードの昇順になります。
           * @returns 正常処理
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_9xkihr['get']['resBody'], BasicHeaders, Methods_9xkihr['get']['status']>(prefix, PATH66, GET, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH66}`,
        },
        unallocated_order_items: {
          /**
           * ログイン社員と同一事業所の社員が代理注文した商品のうち、現在も未引当数量がある商品を取得します。<br/>
           * 得意先の事前選択は不要です。店舗コードを指定した場合は、その店舗に絞り込みます。<br/>
           * @returns 正常処理
           */
          get: (option: { query: Methods_1h48aln['get']['query'], config?: T | undefined }) =>
            fetch<Methods_1h48aln['get']['resBody'], BasicHeaders, Methods_1h48aln['get']['status']>(prefix, PATH67, GET, option).json(),
          /**
           * ログイン社員と同一事業所の社員が代理注文した商品のうち、現在も未引当数量がある商品を取得します。<br/>
           * 得意先の事前選択は不要です。店舗コードを指定した場合は、その店舗に絞り込みます。<br/>
           * @returns 正常処理
           */
          $get: (option: { query: Methods_1h48aln['get']['query'], config?: T | undefined }) =>
            fetch<Methods_1h48aln['get']['resBody'], BasicHeaders, Methods_1h48aln['get']['status']>(prefix, PATH67, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_1h48aln['get']['query'] } | undefined) =>
            `${prefix}${PATH67}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
      },
      favorites: {
        _setNo: (val2: number) => {
          const prefix2 = `${PATH68}/${val2}`;

          return {
            _storeCode: (val3: string) => {
              const prefix3 = `${prefix2}/${val3}`;

              return {
                duplicate: {
                  /**
                   * ### 概要
                   * 店舗コードを指定して、お気に入りリストを複製します。<br/>
                   * 複製される対象の商品は、指定したお気に入りリストに登録されている販売中の商品になります。<br/>
                   * 複製された名称は「***（コピー）」のように末尾に「（コピー）」が追記されます。<br/>
                   * 複製されたお気に入りリストの並び順は最後尾に追加されます。
                   *
                   * ### HTTPレスポンス
                   * - 200 正常
                   * - 400 パラメータ不正
                   * - 401 未ログイン
                   * - 403 参照権限がないお気に入りリスト
                   * - 404 存在しないお気に入りリスト
                   * @returns 正常処理
                   */
                  post: (option?: { config?: T | undefined } | undefined) =>
                    fetch<Methods_1yj2142['post']['resBody'], BasicHeaders, Methods_1yj2142['post']['status']>(prefix, `${prefix3}${PATH69}`, POST, option).json(),
                  /**
                   * ### 概要
                   * 店舗コードを指定して、お気に入りリストを複製します。<br/>
                   * 複製される対象の商品は、指定したお気に入りリストに登録されている販売中の商品になります。<br/>
                   * 複製された名称は「***（コピー）」のように末尾に「（コピー）」が追記されます。<br/>
                   * 複製されたお気に入りリストの並び順は最後尾に追加されます。
                   *
                   * ### HTTPレスポンス
                   * - 200 正常
                   * - 400 パラメータ不正
                   * - 401 未ログイン
                   * - 403 参照権限がないお気に入りリスト
                   * - 404 存在しないお気に入りリスト
                   * @returns 正常処理
                   */
                  $post: (option?: { config?: T | undefined } | undefined) =>
                    fetch<Methods_1yj2142['post']['resBody'], BasicHeaders, Methods_1yj2142['post']['status']>(prefix, `${prefix3}${PATH69}`, POST, option).json().then(r => r.body),
                  $path: () => `${prefix}${prefix3}${PATH69}`,
                },
                items: {
                  /**
                   * ### 概要
                   * 店舗コードを指定して、お気に入りリストの商品一覧を更新します。<br/>
                   * 存在しない商品コードの更新は行われません。<br/>
                   * <br/>
                   * リクエストにお気に入りリストに登録する商品コード一覧を設定します。<br/>
                   * ステータスが販売中以外の商品は、レスポンスの unavailablePurchase として返却されます。<br/>
                   * リクエストの順序がそのまま並び順になります。
                   *
                   * ### 商品ステータス
                   * - available：販売中<
                   * - unavailable：販売終了商品
                   * - expired：販売期間外商品
                   * - forbidden：扱えない商品
                   * - noItemCode：存在しない商品コード
                   *
                   * ### HTTPレスポンス
                   * - 200 正常
                   * - 400 パラメータ不正
                   * - 401 未ログイン
                   * - 403 参照権限がないお気に入りリスト
                   * - 404 存在しないお気に入りリスト
                   * @returns 正常処理
                   */
                  put: (option: { body: Methods_qgmcd7['put']['reqBody'], config?: T | undefined }) =>
                    fetch<Methods_qgmcd7['put']['resBody'], BasicHeaders, Methods_qgmcd7['put']['status']>(prefix, `${prefix3}${PATH49}`, PUT, option).json(),
                  /**
                   * ### 概要
                   * 店舗コードを指定して、お気に入りリストの商品一覧を更新します。<br/>
                   * 存在しない商品コードの更新は行われません。<br/>
                   * <br/>
                   * リクエストにお気に入りリストに登録する商品コード一覧を設定します。<br/>
                   * ステータスが販売中以外の商品は、レスポンスの unavailablePurchase として返却されます。<br/>
                   * リクエストの順序がそのまま並び順になります。
                   *
                   * ### 商品ステータス
                   * - available：販売中<
                   * - unavailable：販売終了商品
                   * - expired：販売期間外商品
                   * - forbidden：扱えない商品
                   * - noItemCode：存在しない商品コード
                   *
                   * ### HTTPレスポンス
                   * - 200 正常
                   * - 400 パラメータ不正
                   * - 401 未ログイン
                   * - 403 参照権限がないお気に入りリスト
                   * - 404 存在しないお気に入りリスト
                   * @returns 正常処理
                   */
                  $put: (option: { body: Methods_qgmcd7['put']['reqBody'], config?: T | undefined }) =>
                    fetch<Methods_qgmcd7['put']['resBody'], BasicHeaders, Methods_qgmcd7['put']['status']>(prefix, `${prefix3}${PATH49}`, PUT, option).json().then(r => r.body),
                  /**
                   * ### 概要
                   * 店舗コードを指定して、お気に入りリスト間での商品移動・複製をします。<br/>
                   * 販売中の商品にのみ移動・複製が行われます。<br/>
                   *
                   * リクエストに移動・複製する商品コード一覧を設定します。<br/>
                   * ステータスが販売中以外の商品は、レスポンスの unavailablePurchase として返却されます。<br/>
                   * リクエストの順序がそのまま並び順になります。
                   *
                   * ### 商品のステータス
                   * - available：販売中
                   * - unavailable：販売終了商品
                   * - expired：販売期間外商品
                   * - forbidden：扱えない商品
                   * - noItemCode：存在しない商品コード
                   *
                   * ### クエリーパラメータ：action
                   * - move：移動
                   * - copy：複製
                   *
                   * ### HTTPレスポンス
                   * - 200 正常
                   * - 400 パラメータ不正
                   * - 401 未ログイン
                   * - 403 参照権限がないお気に入りリスト
                   * - 404 存在しないお気に入りリスト
                   * @returns 正常処理
                   */
                  post: (option: { body: Methods_qgmcd7['post']['reqBody'], query: Methods_qgmcd7['post']['query'], config?: T | undefined }) =>
                    fetch<Methods_qgmcd7['post']['resBody'], BasicHeaders, Methods_qgmcd7['post']['status']>(prefix, `${prefix3}${PATH49}`, POST, option).json(),
                  /**
                   * ### 概要
                   * 店舗コードを指定して、お気に入りリスト間での商品移動・複製をします。<br/>
                   * 販売中の商品にのみ移動・複製が行われます。<br/>
                   *
                   * リクエストに移動・複製する商品コード一覧を設定します。<br/>
                   * ステータスが販売中以外の商品は、レスポンスの unavailablePurchase として返却されます。<br/>
                   * リクエストの順序がそのまま並び順になります。
                   *
                   * ### 商品のステータス
                   * - available：販売中
                   * - unavailable：販売終了商品
                   * - expired：販売期間外商品
                   * - forbidden：扱えない商品
                   * - noItemCode：存在しない商品コード
                   *
                   * ### クエリーパラメータ：action
                   * - move：移動
                   * - copy：複製
                   *
                   * ### HTTPレスポンス
                   * - 200 正常
                   * - 400 パラメータ不正
                   * - 401 未ログイン
                   * - 403 参照権限がないお気に入りリスト
                   * - 404 存在しないお気に入りリスト
                   * @returns 正常処理
                   */
                  $post: (option: { body: Methods_qgmcd7['post']['reqBody'], query: Methods_qgmcd7['post']['query'], config?: T | undefined }) =>
                    fetch<Methods_qgmcd7['post']['resBody'], BasicHeaders, Methods_qgmcd7['post']['status']>(prefix, `${prefix3}${PATH49}`, POST, option).json().then(r => r.body),
                  $path: (option?: { method: 'post'; query: Methods_qgmcd7['post']['query'] } | undefined) =>
                    `${prefix}${prefix3}${PATH49}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
                },
                /**
                 * ### 概要
                 * 店舗コードを指定して、お気に入りリストの名称を更新をします。
                 *
                 * ### HTTPレスポンス
                 * - 200 正常
                 * - 400 パラメータ不正
                 * - 401 未ログイン
                 * - 403 参照権限がないお気に入りリスト
                 * - 404 存在しないお気に入りリスト
                 * @returns 正常処理
                 */
                put: (option: { body: Methods_i33vyc['put']['reqBody'], config?: T | undefined }) =>
                  fetch<Methods_i33vyc['put']['resBody'], BasicHeaders, Methods_i33vyc['put']['status']>(prefix, prefix3, PUT, option).json(),
                /**
                 * ### 概要
                 * 店舗コードを指定して、お気に入りリストの名称を更新をします。
                 *
                 * ### HTTPレスポンス
                 * - 200 正常
                 * - 400 パラメータ不正
                 * - 401 未ログイン
                 * - 403 参照権限がないお気に入りリスト
                 * - 404 存在しないお気に入りリスト
                 * @returns 正常処理
                 */
                $put: (option: { body: Methods_i33vyc['put']['reqBody'], config?: T | undefined }) =>
                  fetch<Methods_i33vyc['put']['resBody'], BasicHeaders, Methods_i33vyc['put']['status']>(prefix, prefix3, PUT, option).json().then(r => r.body),
                /**
                 * ### 概要
                 * 店舗コードを指定して、お気に入りリストを削除をします。
                 *
                 * ### HTTPレスポンス
                 * - 200 正常
                 * - 400 パラメータ不正
                 * - 401 未ログイン
                 * - 403 参照権限がないお気に入りリスト
                 * - 404 存在しないお気に入りリスト
                 * @returns 正常処理
                 */
                delete: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_i33vyc['delete']['resBody'], BasicHeaders, Methods_i33vyc['delete']['status']>(prefix, prefix3, DELETE, option).json(),
                /**
                 * ### 概要
                 * 店舗コードを指定して、お気に入りリストを削除をします。
                 *
                 * ### HTTPレスポンス
                 * - 200 正常
                 * - 400 パラメータ不正
                 * - 401 未ログイン
                 * - 403 参照権限がないお気に入りリスト
                 * - 404 存在しないお気に入りリスト
                 * @returns 正常処理
                 */
                $delete: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_i33vyc['delete']['resBody'], BasicHeaders, Methods_i33vyc['delete']['status']>(prefix, prefix3, DELETE, option).json().then(r => r.body),
                /**
                 * ### 概要
                 * 店舗コードを指定して、お気に入りリストの商品一覧を取得します。<br/>
                 * 商品一覧に扱えない商品が含まれる場合、該当の商品情報はnullで返却されます。<br/>
                 * 画面上には販売中の商品のみ表示します。
                 *
                 * ### 商品ステータス
                 * - available：販売中
                 * - unavailable：販売終了商品
                 * - expired：販売期間外商品
                 * - forbidden：扱えない商品
                 *
                 * ### 商品一覧の並び順
                 * - 商品一覧：mm_favm.sort_no の昇順
                 *
                 * ### 売上種別一覧の並び順
                 * - salestypes_defaulted_to_favorites.sort_no の昇順
                 *
                 * ### HTTPレスポンス
                 * - 200 正常
                 * - 400 パラメータ不正
                 * - 401 未ログイン
                 * - 403 参照権限がないお気に入りリスト
                 * - 404 存在しないお気に入りリスト
                 * @returns 正常処理
                 */
                get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_i33vyc['get']['resBody'], BasicHeaders, Methods_i33vyc['get']['status']>(prefix, prefix3, GET, option).json(),
                /**
                 * ### 概要
                 * 店舗コードを指定して、お気に入りリストの商品一覧を取得します。<br/>
                 * 商品一覧に扱えない商品が含まれる場合、該当の商品情報はnullで返却されます。<br/>
                 * 画面上には販売中の商品のみ表示します。
                 *
                 * ### 商品ステータス
                 * - available：販売中
                 * - unavailable：販売終了商品
                 * - expired：販売期間外商品
                 * - forbidden：扱えない商品
                 *
                 * ### 商品一覧の並び順
                 * - 商品一覧：mm_favm.sort_no の昇順
                 *
                 * ### 売上種別一覧の並び順
                 * - salestypes_defaulted_to_favorites.sort_no の昇順
                 *
                 * ### HTTPレスポンス
                 * - 200 正常
                 * - 400 パラメータ不正
                 * - 401 未ログイン
                 * - 403 参照権限がないお気に入りリスト
                 * - 404 存在しないお気に入りリスト
                 * @returns 正常処理
                 */
                $get: (option?: { config?: T | undefined } | undefined) =>
                  fetch<Methods_i33vyc['get']['resBody'], BasicHeaders, Methods_i33vyc['get']['status']>(prefix, prefix3, GET, option).json().then(r => r.body),
                $path: () => `${prefix}${prefix3}`,
              };
            },
          };
        },
        items: {
          /**
           * ### 概要
           * お気に入りリストの並び順を更新します。<br/>
           * リクエストの順序がそのまま並び順になります。
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * - 403 参照権限がないお気に入りリスト
           * - 404 存在しないお気に入りリスト
           */
          put: (option: { body: Methods_1fwrbc2['put']['reqBody'], config?: T | undefined }) =>
            fetch<void, BasicHeaders, Methods_1fwrbc2['put']['status']>(prefix, PATH70, PUT, option).send(),
          /**
           * ### 概要
           * お気に入りリストの並び順を更新します。<br/>
           * リクエストの順序がそのまま並び順になります。
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * - 403 参照権限がないお気に入りリスト
           * - 404 存在しないお気に入りリスト
           */
          $put: (option: { body: Methods_1fwrbc2['put']['reqBody'], config?: T | undefined }) =>
            fetch<void, BasicHeaders, Methods_1fwrbc2['put']['status']>(prefix, PATH70, PUT, option).send().then(r => r.body),
          $path: () => `${prefix}${PATH70}`,
        },
        /**
         * ### 概要
         * お気に入りリストを作成します。
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 400 パラメータ不正
         * - 401 未ログイン
         * @returns 正常処理
         */
        post: (option: { body: Methods_6bhzgt['post']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_6bhzgt['post']['resBody'], BasicHeaders, Methods_6bhzgt['post']['status']>(prefix, PATH68, POST, option).json(),
        /**
         * ### 概要
         * お気に入りリストを作成します。
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 400 パラメータ不正
         * - 401 未ログイン
         * @returns 正常処理
         */
        $post: (option: { body: Methods_6bhzgt['post']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_6bhzgt['post']['resBody'], BasicHeaders, Methods_6bhzgt['post']['status']>(prefix, PATH68, POST, option).json().then(r => r.body),
        /**
         * ### 概要
         * お気に入りリストの一覧を取得します。<br/>
         * セットNo.及び名前と店舗情報、登録済みの商品コード一覧を返却します。<br/>
         * 返却する店舗コードは、店舗タイプで判別できます。<br/>
         * 編集可能可否と複製可能可否は、自店舗のお気に入りリストの場合、trueを、<br/>
         * 入金親から共有されたお気に入りリストの場合、falseを返却します。<br/>
         * <br/>
         * 編集可能可否は、お気に入りリストの名称変更、削除、商品の並び替え、移動、削除を制限します。<br/>
         * 複製可能可否は、お気に入りリストの複製を制限します。<br/>
         * <br/>
         * 入金親の場合、自店舗のお気に入りリストを取得します。<br/>
         * 子店舗の場合、自店舗のお気に入りリストと入金親から共有されたお気に入りリストを取得します。
         *
         * ### お気に入りリスト一覧の並び順
         * - mm_favh.sort_no の昇順
         *
         * ### 商品コード一覧の並び順
         * - mm_favm.sort_no の昇順
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 401 未ログイン
         * @returns 正常処理
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_6bhzgt['get']['resBody'], BasicHeaders, Methods_6bhzgt['get']['status']>(prefix, PATH68, GET, option).json(),
        /**
         * ### 概要
         * お気に入りリストの一覧を取得します。<br/>
         * セットNo.及び名前と店舗情報、登録済みの商品コード一覧を返却します。<br/>
         * 返却する店舗コードは、店舗タイプで判別できます。<br/>
         * 編集可能可否と複製可能可否は、自店舗のお気に入りリストの場合、trueを、<br/>
         * 入金親から共有されたお気に入りリストの場合、falseを返却します。<br/>
         * <br/>
         * 編集可能可否は、お気に入りリストの名称変更、削除、商品の並び替え、移動、削除を制限します。<br/>
         * 複製可能可否は、お気に入りリストの複製を制限します。<br/>
         * <br/>
         * 入金親の場合、自店舗のお気に入りリストを取得します。<br/>
         * 子店舗の場合、自店舗のお気に入りリストと入金親から共有されたお気に入りリストを取得します。
         *
         * ### お気に入りリスト一覧の並び順
         * - mm_favh.sort_no の昇順
         *
         * ### 商品コード一覧の並び順
         * - mm_favm.sort_no の昇順
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 401 未ログイン
         * @returns 正常処理
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_6bhzgt['get']['resBody'], BasicHeaders, Methods_6bhzgt['get']['status']>(prefix, PATH68, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH68}`,
      },
      invoices: {
        _invoiceId: (val2: string) => {
          const prefix2 = `${PATH71}/${val2}`;

          return {
            download: {
              /**
               * ## 説明
               * * 請求書PDFをダウンロードします。<br/>
               *   ただし、関連ファイルが存在する場合、請求書のPDFと関連ファイルをzipでダウンロードします。
               * * ダウンロードを行った履歴を登録します。
               *
               * ## Response の補足説明
               * ### 請求書のみをダウンロードする場合
               * * Content-Type に application/pdf を指定する。
               * * Content-Disposition に `attachment; filename*=UTF-8''ファイル名` を指定する。<br/>
               *   ex: `attachment; filename*=UTF-8''20240220_15597_%E3%83%86%E3%82%B9%E3%83%88%E7%92%B0%E5%A2%83%E3%83%87%E3%83%A2%E3%82%B5%E3%83%AD%E3%83%B3_35238_20240201163153.pdf`
               *  
               * ### 請求書と関連ファイルをダウンロードする場合
               * * Content-Type に application/zip を指定する。
               * * Content-Disposition に `attachment; filename*=UTF-8''ファイル名` を指定する。<br/>
               *   ファイル名は `invoice_yyyyMMddhhmmssfff.zip` とする。<br/>
               *   ex: `attachment; filename*=UTF-8''invoice_20240312102300995.zip`
               *
               * ## HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * - 403 ログインユーザに権限がない場合
               * - 404 存在しない請求書IDの場合
               * @returns 正常処理
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1edvdju['get']['resBody'], BasicHeaders, Methods_1edvdju['get']['status']>(prefix, `${prefix2}${PATH28}`, GET, option).blob(),
              /**
               * ## 説明
               * * 請求書PDFをダウンロードします。<br/>
               *   ただし、関連ファイルが存在する場合、請求書のPDFと関連ファイルをzipでダウンロードします。
               * * ダウンロードを行った履歴を登録します。
               *
               * ## Response の補足説明
               * ### 請求書のみをダウンロードする場合
               * * Content-Type に application/pdf を指定する。
               * * Content-Disposition に `attachment; filename*=UTF-8''ファイル名` を指定する。<br/>
               *   ex: `attachment; filename*=UTF-8''20240220_15597_%E3%83%86%E3%82%B9%E3%83%88%E7%92%B0%E5%A2%83%E3%83%87%E3%83%A2%E3%82%B5%E3%83%AD%E3%83%B3_35238_20240201163153.pdf`
               *  
               * ### 請求書と関連ファイルをダウンロードする場合
               * * Content-Type に application/zip を指定する。
               * * Content-Disposition に `attachment; filename*=UTF-8''ファイル名` を指定する。<br/>
               *   ファイル名は `invoice_yyyyMMddhhmmssfff.zip` とする。<br/>
               *   ex: `attachment; filename*=UTF-8''invoice_20240312102300995.zip`
               *
               * ## HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * - 403 ログインユーザに権限がない場合
               * - 404 存在しない請求書IDの場合
               * @returns 正常処理
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1edvdju['get']['resBody'], BasicHeaders, Methods_1edvdju['get']['status']>(prefix, `${prefix2}${PATH28}`, GET, option).blob().then(r => r.body),
              /**
               * ## 説明
               * * 有効期限付きのパスワードと照合し、パスワードが正しければ請求書のPDFをダウンロードします。<br/>
               *   ただし、関連ファイルが存在する場合、請求書のPDFと関連ファイルをzipでダウンロードします。<br/>
               *   また、パスワードの有効期限は、パスワード発行日時から30日間とします。
               * * ダウンロードを行った履歴を登録します。
               *
               * ## Response の補足説明
               * ### 請求書のみをダウンロードする場合
               * * Content-Type に application/pdf を指定する。
               * * Content-Disposition に `attachment; filename*=UTF-8''ファイル名` を指定する。<br/>
               *   ex: `attachment; filename*=UTF-8''20240220_15597_%E3%83%86%E3%82%B9%E3%83%88%E7%92%B0%E5%A2%83%E3%83%87%E3%83%A2%E3%82%B5%E3%83%AD%E3%83%B3_35238_20240201163153.pdf`
               *  
               * ### 請求書と関連ファイルをダウンロードする場合
               * * Content-Type に application/zip を指定する。
               * * Content-Disposition に `attachment; filename*=UTF-8''ファイル名` を指定する。<br/>
               *   ファイル名は `invoice_yyyyMMddhhmmssfff.zip` とする。<br/>
               *   ex: `attachment; filename*=UTF-8''invoice_20240312102300995.zip`
               *
               * ## HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 403 パスワード不正、パスワードの有効期限切れ
               * - 404 存在しないファイルID
               * @returns 正常処理
               */
              post: (option: { body: Methods_1edvdju['post']['reqBody'], config?: T | undefined }) =>
                fetch<Methods_1edvdju['post']['resBody'], BasicHeaders, Methods_1edvdju['post']['status']>(prefix, `${prefix2}${PATH28}`, POST, option).blob(),
              /**
               * ## 説明
               * * 有効期限付きのパスワードと照合し、パスワードが正しければ請求書のPDFをダウンロードします。<br/>
               *   ただし、関連ファイルが存在する場合、請求書のPDFと関連ファイルをzipでダウンロードします。<br/>
               *   また、パスワードの有効期限は、パスワード発行日時から30日間とします。
               * * ダウンロードを行った履歴を登録します。
               *
               * ## Response の補足説明
               * ### 請求書のみをダウンロードする場合
               * * Content-Type に application/pdf を指定する。
               * * Content-Disposition に `attachment; filename*=UTF-8''ファイル名` を指定する。<br/>
               *   ex: `attachment; filename*=UTF-8''20240220_15597_%E3%83%86%E3%82%B9%E3%83%88%E7%92%B0%E5%A2%83%E3%83%87%E3%83%A2%E3%82%B5%E3%83%AD%E3%83%B3_35238_20240201163153.pdf`
               *  
               * ### 請求書と関連ファイルをダウンロードする場合
               * * Content-Type に application/zip を指定する。
               * * Content-Disposition に `attachment; filename*=UTF-8''ファイル名` を指定する。<br/>
               *   ファイル名は `invoice_yyyyMMddhhmmssfff.zip` とする。<br/>
               *   ex: `attachment; filename*=UTF-8''invoice_20240312102300995.zip`
               *
               * ## HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 403 パスワード不正、パスワードの有効期限切れ
               * - 404 存在しないファイルID
               * @returns 正常処理
               */
              $post: (option: { body: Methods_1edvdju['post']['reqBody'], config?: T | undefined }) =>
                fetch<Methods_1edvdju['post']['resBody'], BasicHeaders, Methods_1edvdju['post']['status']>(prefix, `${prefix2}${PATH28}`, POST, option).blob().then(r => r.body),
              $path: () => `${prefix}${prefix2}${PATH28}`,
            },
            preview: {
              /**
               * ### 概要
               * 請求書のプレビューを表示する。
               *
               * ### 処理仕様
               *
               * - 請求書IDからS3に格納された請求書の画像(jpg)を取得する。
               * - 画像をbase64でエンコードする。
               * - ファイル内容を返す。
               *
               * ### HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * - 403 ログインユーザに権限がない場合
               * - 404 存在しない請求書IDの場合
               * @returns 正常処理
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_127gk1y['get']['resBody'], BasicHeaders, Methods_127gk1y['get']['status']>(prefix, `${prefix2}${PATH72}`, GET, option).json(),
              /**
               * ### 概要
               * 請求書のプレビューを表示する。
               *
               * ### 処理仕様
               *
               * - 請求書IDからS3に格納された請求書の画像(jpg)を取得する。
               * - 画像をbase64でエンコードする。
               * - ファイル内容を返す。
               *
               * ### HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * - 403 ログインユーザに権限がない場合
               * - 404 存在しない請求書IDの場合
               * @returns 正常処理
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_127gk1y['get']['resBody'], BasicHeaders, Methods_127gk1y['get']['status']>(prefix, `${prefix2}${PATH72}`, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix2}${PATH72}`,
            },
          };
        },
        comments: {
          _commentId: (val3: string) => {
            const prefix3 = `${PATH73}/${val3}`;

            return {
              read: {
                /**
                 * 指定した請求書コメントに対して既読履歴を登録します。既に既読済みの場合は処理を行わず正常終了します。
                 */
                post: (option?: { config?: T | undefined } | undefined) =>
                  fetch<void, BasicHeaders, Methods_7vtnl5['post']['status']>(prefix, `${prefix3}${PATH4}`, POST, option).send(),
                /**
                 * 指定した請求書コメントに対して既読履歴を登録します。既に既読済みの場合は処理を行わず正常終了します。
                 */
                $post: (option?: { config?: T | undefined } | undefined) =>
                  fetch<void, BasicHeaders, Methods_7vtnl5['post']['status']>(prefix, `${prefix3}${PATH4}`, POST, option).send().then(r => r.body),
                $path: () => `${prefix}${prefix3}${PATH4}`,
              },
            };
          },
        },
        download: {
          /**
           * ## 説明
           * * 指定された請求書をzip圧縮して、まとめてダウンロードします。<br/>
           *   単月の場合のファイル名は「yyyyMM_請求書_yyyyMMddHHmmssfff.zip」、複数月の場合は「yyyyMM-yyyyMM_請求書_yyyyMMddHHmmssfff.zip」とします。
           * * 指定した請求書に関連ファイルが存在する場合、関連ファイルもダウンロードします。
           * * 指定した請求書に紐づく領収書が存在する場合、領収書もダウンロードします。
           * * 単月ダウンロード時は従来どおりフラット構造、複数月ダウンロード時は請求月フォルダー（yyyyMM）単位で格納します。
           *
           * ### ダウンロードしたファイルの中身のサンプル（複数月）
           *
           * * 202601-202602_請求書_20260714120000000.zip
           *     * 202601/
           *         * 20260101_15597_店舗A_100000_20260101120000000.pdf
           *         * 20260101_15597_店舗A_100000_20260101120000000_請求書_関連ファイル/
           *             * 15597_2024年2月分売上データ.xlsx
           *         * 領収書/
           *             * receipt_15597_202601.pdf
           *     * 202602/
           *         * 20260201_15597_店舗A_120000_20260201120000000.pdf
           *         * 領収書/
           *             * receipt_15597_202602.pdf
           *
           * ### Response の補足説明
           * * Content-Type に application/zip を指定する。
           * * Content-Disposition に `attachment; filename*=UTF-8''ファイル名` を指定する。<br/>
           *   単月指定時のファイル名は `yyyyMM_請求書_yyyyMMddhhmmssfff.zip`、複数月指定時は `yyyyMM-yyyyMM_請求書_yyyyMMddhhmmssfff.zip`。<br/>
           *   ex(単月): `attachment; filename*=UTF-8''202601_請求書_20240312102300995.zip`<br/>
           *   ex(複数月): `attachment; filename*=UTF-8''202601-202602_請求書_20240312102300995.zip`
           *
           * ## HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * - 403 ログインユーザに権限がない場合
           * - 404 存在しない請求書IDの場合
           * @returns 正常処理
           */
          post: (option: { body: Methods_yrhm8x['post']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_yrhm8x['post']['resBody'], BasicHeaders, Methods_yrhm8x['post']['status']>(prefix, PATH74, POST, option).blob(),
          /**
           * ## 説明
           * * 指定された請求書をzip圧縮して、まとめてダウンロードします。<br/>
           *   単月の場合のファイル名は「yyyyMM_請求書_yyyyMMddHHmmssfff.zip」、複数月の場合は「yyyyMM-yyyyMM_請求書_yyyyMMddHHmmssfff.zip」とします。
           * * 指定した請求書に関連ファイルが存在する場合、関連ファイルもダウンロードします。
           * * 指定した請求書に紐づく領収書が存在する場合、領収書もダウンロードします。
           * * 単月ダウンロード時は従来どおりフラット構造、複数月ダウンロード時は請求月フォルダー（yyyyMM）単位で格納します。
           *
           * ### ダウンロードしたファイルの中身のサンプル（複数月）
           *
           * * 202601-202602_請求書_20260714120000000.zip
           *     * 202601/
           *         * 20260101_15597_店舗A_100000_20260101120000000.pdf
           *         * 20260101_15597_店舗A_100000_20260101120000000_請求書_関連ファイル/
           *             * 15597_2024年2月分売上データ.xlsx
           *         * 領収書/
           *             * receipt_15597_202601.pdf
           *     * 202602/
           *         * 20260201_15597_店舗A_120000_20260201120000000.pdf
           *         * 領収書/
           *             * receipt_15597_202602.pdf
           *
           * ### Response の補足説明
           * * Content-Type に application/zip を指定する。
           * * Content-Disposition に `attachment; filename*=UTF-8''ファイル名` を指定する。<br/>
           *   単月指定時のファイル名は `yyyyMM_請求書_yyyyMMddhhmmssfff.zip`、複数月指定時は `yyyyMM-yyyyMM_請求書_yyyyMMddhhmmssfff.zip`。<br/>
           *   ex(単月): `attachment; filename*=UTF-8''202601_請求書_20240312102300995.zip`<br/>
           *   ex(複数月): `attachment; filename*=UTF-8''202601-202602_請求書_20240312102300995.zip`
           *
           * ## HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * - 403 ログインユーザに権限がない場合
           * - 404 存在しない請求書IDの場合
           * @returns 正常処理
           */
          $post: (option: { body: Methods_yrhm8x['post']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_yrhm8x['post']['resBody'], BasicHeaders, Methods_yrhm8x['post']['status']>(prefix, PATH74, POST, option).blob().then(r => r.body),
          $path: () => `${prefix}${PATH74}`,
        },
        histories: {
          download: {
            /**
             * ### 概要
             * 請求書の操作履歴を取得し、CSVをダウンロードする。<br/>
             * 検索結果が0件の場合、400エラーを返す。<br/>
             * ファイル名は、「請求書履歴_店舗コード_店舗名_yyyyMMddHHmmssSSS.csv」となる。
             *
             * ### 処理仕様
             *
             * - パラメータから検索条件を作成する。
             * - DBから結果を取得し、UTF-8 BOM形式CSVに整形する。
             * - Content-Type に text/csv を指定する。
             * - Content-Disposition に `attachment; filename="請求書履歴_店舗コード_店舗名_yyyyMMddHHmmssSSS.csv" を指定する。
             * - バイナリデータを返却する。
             *
             * ### 並び順
             * - 操作時刻の降順
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 ログインユーザに権限がない場合
             *
             * ### CSVカラム
             *
             * 1. 操作時刻
             * 2. 請求先コード
             * 3. 請求先名
             * 4. 請求書ファイル名
             * 5. 操作者種別
             * 6. 操作者名
             * 7. 操作内容
             * @returns 正常処理
             */
            get: (option: { query: Methods_t48ma8['get']['query'], config?: T | undefined }) =>
              fetch<Methods_t48ma8['get']['resBody'], BasicHeaders, Methods_t48ma8['get']['status']>(prefix, PATH76, GET, option).blob(),
            /**
             * ### 概要
             * 請求書の操作履歴を取得し、CSVをダウンロードする。<br/>
             * 検索結果が0件の場合、400エラーを返す。<br/>
             * ファイル名は、「請求書履歴_店舗コード_店舗名_yyyyMMddHHmmssSSS.csv」となる。
             *
             * ### 処理仕様
             *
             * - パラメータから検索条件を作成する。
             * - DBから結果を取得し、UTF-8 BOM形式CSVに整形する。
             * - Content-Type に text/csv を指定する。
             * - Content-Disposition に `attachment; filename="請求書履歴_店舗コード_店舗名_yyyyMMddHHmmssSSS.csv" を指定する。
             * - バイナリデータを返却する。
             *
             * ### 並び順
             * - 操作時刻の降順
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 ログインユーザに権限がない場合
             *
             * ### CSVカラム
             *
             * 1. 操作時刻
             * 2. 請求先コード
             * 3. 請求先名
             * 4. 請求書ファイル名
             * 5. 操作者種別
             * 6. 操作者名
             * 7. 操作内容
             * @returns 正常処理
             */
            $get: (option: { query: Methods_t48ma8['get']['query'], config?: T | undefined }) =>
              fetch<Methods_t48ma8['get']['resBody'], BasicHeaders, Methods_t48ma8['get']['status']>(prefix, PATH76, GET, option).blob().then(r => r.body),
            $path: (option?: { method?: 'get' | undefined; query: Methods_t48ma8['get']['query'] } | undefined) =>
              `${prefix}${PATH76}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
          },
          /**
           * ### 概要
           * 請求書の操作履歴を取得する。
           *
           * ### 処理仕様
           *
           * - パラメータから検索条件を作成する。
           * - DBから結果を取得する。
           * - 結果を返す。
           *
           * ### 並び順
           * - 操作時刻の降順
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * - 403 ログインユーザに権限がない場合
           * @returns 正常処理
           */
          get: (option: { query: Methods_1bygs33['get']['query'], config?: T | undefined }) =>
            fetch<Methods_1bygs33['get']['resBody'], BasicHeaders, Methods_1bygs33['get']['status']>(prefix, PATH75, GET, option).json(),
          /**
           * ### 概要
           * 請求書の操作履歴を取得する。
           *
           * ### 処理仕様
           *
           * - パラメータから検索条件を作成する。
           * - DBから結果を取得する。
           * - 結果を返す。
           *
           * ### 並び順
           * - 操作時刻の降順
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * - 403 ログインユーザに権限がない場合
           * @returns 正常処理
           */
          $get: (option: { query: Methods_1bygs33['get']['query'], config?: T | undefined }) =>
            fetch<Methods_1bygs33['get']['resBody'], BasicHeaders, Methods_1bygs33['get']['status']>(prefix, PATH75, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_1bygs33['get']['query'] } | undefined) =>
            `${prefix}${PATH75}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        /**
         * ### 仕様
         * - 検索条件に一致する請求書を取得する。
         * - ログインユーザーに請求書機能の権限がない場合、403エラーとする。
         * - ログインユーザーに管理者権限がある場合、すべての請求先に紐づく請求書が閲覧可能となる。<br/>管理者権限がない場合、担当支店に紐づく請求先の請求書のみが閲覧可能となる。
         * - 請求月の指定がない場合は、当月の請求書を対象とする。
         * - 取得対象は、請求書ファイルステータスが```published``` ```unPublished```の請求書となる。
         *
         * ### 並び順
         * - 店舗コードの昇順
         * - 請求書公開日の降順
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 400 パラメータ不正
         * - 401 未ログイン
         * - 403 ログインユーザに権限がない場合
         * @returns 正常処理
         */
        get: (option?: { query?: Methods_2gd440['get']['query'] | undefined, config?: T | undefined } | undefined) =>
          fetch<Methods_2gd440['get']['resBody'], BasicHeaders, Methods_2gd440['get']['status']>(prefix, PATH71, GET, option).json(),
        /**
         * ### 仕様
         * - 検索条件に一致する請求書を取得する。
         * - ログインユーザーに請求書機能の権限がない場合、403エラーとする。
         * - ログインユーザーに管理者権限がある場合、すべての請求先に紐づく請求書が閲覧可能となる。<br/>管理者権限がない場合、担当支店に紐づく請求先の請求書のみが閲覧可能となる。
         * - 請求月の指定がない場合は、当月の請求書を対象とする。
         * - 取得対象は、請求書ファイルステータスが```published``` ```unPublished```の請求書となる。
         *
         * ### 並び順
         * - 店舗コードの昇順
         * - 請求書公開日の降順
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 400 パラメータ不正
         * - 401 未ログイン
         * - 403 ログインユーザに権限がない場合
         * @returns 正常処理
         */
        $get: (option?: { query?: Methods_2gd440['get']['query'] | undefined, config?: T | undefined } | undefined) =>
          fetch<Methods_2gd440['get']['resBody'], BasicHeaders, Methods_2gd440['get']['status']>(prefix, PATH71, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_2gd440['get']['query'] } | undefined) =>
          `${prefix}${PATH71}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      items: {
        _itemCode: (val2: string) => {
          const prefix2 = `${PATH77}/${val2}`;

          return {
            prices: {
              /**
               * 商品の売上種別ごとの販売価格一覧を取得する。
               * 購入価格表示権限がない場合403が返却される。
               * @returns 正常処理
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_lxoro8['get']['resBody'], BasicHeaders, Methods_lxoro8['get']['status']>(prefix, `${prefix2}${PATH78}`, GET, option).json(),
              /**
               * 商品の売上種別ごとの販売価格一覧を取得する。
               * 購入価格表示権限がない場合403が返却される。
               * @returns 正常処理
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_lxoro8['get']['resBody'], BasicHeaders, Methods_lxoro8['get']['status']>(prefix, `${prefix2}${PATH78}`, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix2}${PATH78}`,
            },
            /**
             * 商品の詳細情報を取得します。<br/>
             * 詳細情報は販売中の商品のみ返却します。<br/>
             * <br/>
             * 商品ステータスは以下になります。<br/>
             * <ul>
             * <li>available：販売中</li>
             * <li>expired：販売終了商品</li>
             * <li>unavailable：販売期間外商品</li>
             * <li>forbidden：扱えない商品</li>
             * </ul>
             * @returns 正常処理
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1ncm5e9['get']['resBody'], BasicHeaders, Methods_1ncm5e9['get']['status']>(prefix, prefix2, GET, option).json(),
            /**
             * 商品の詳細情報を取得します。<br/>
             * 詳細情報は販売中の商品のみ返却します。<br/>
             * <br/>
             * 商品ステータスは以下になります。<br/>
             * <ul>
             * <li>available：販売中</li>
             * <li>expired：販売終了商品</li>
             * <li>unavailable：販売期間外商品</li>
             * <li>forbidden：扱えない商品</li>
             * </ul>
             * @returns 正常処理
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1ncm5e9['get']['resBody'], BasicHeaders, Methods_1ncm5e9['get']['status']>(prefix, prefix2, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          };
        },
        count: {
          /**
           * 商品検索件数取得
           * @returns 正常処理
           */
          get: (option?: { query?: Methods_137r4s8['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_137r4s8['get']['resBody'], BasicHeaders, Methods_137r4s8['get']['status']>(prefix, PATH79, GET, option).json(),
          /**
           * 商品検索件数取得
           * @returns 正常処理
           */
          $get: (option?: { query?: Methods_137r4s8['get']['query'] | undefined, config?: T | undefined } | undefined) =>
            fetch<Methods_137r4s8['get']['resBody'], BasicHeaders, Methods_137r4s8['get']['status']>(prefix, PATH79, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_137r4s8['get']['query'] } | undefined) =>
            `${prefix}${PATH79}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        /**
         * 商品検索を行います。<br>
         * 検索結果は販売中の商品のみを返却します。<br/>
         * <br/>
         * 商品ステータスは以下になります。<br/>
         * <ul>
         * <li>available：販売中</li>
         * <li>expired：販売終了商品</li>
         * <li>unavailable：販売期間外商品</li>
         * <li>forbidden：扱えない商品</li>
         * </ul>
         * @returns 正常処理
         */
        get: (option: { query: Methods_19aunck['get']['query'], config?: T | undefined }) =>
          fetch<Methods_19aunck['get']['resBody'], BasicHeaders, Methods_19aunck['get']['status']>(prefix, PATH77, GET, option).json(),
        /**
         * 商品検索を行います。<br>
         * 検索結果は販売中の商品のみを返却します。<br/>
         * <br/>
         * 商品ステータスは以下になります。<br/>
         * <ul>
         * <li>available：販売中</li>
         * <li>expired：販売終了商品</li>
         * <li>unavailable：販売期間外商品</li>
         * <li>forbidden：扱えない商品</li>
         * </ul>
         * @returns 正常処理
         */
        $get: (option: { query: Methods_19aunck['get']['query'], config?: T | undefined }) =>
          fetch<Methods_19aunck['get']['resBody'], BasicHeaders, Methods_19aunck['get']['status']>(prefix, PATH77, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_19aunck['get']['query'] } | undefined) =>
          `${prefix}${PATH77}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      login: {
        /**
         * ログイン処理を行い、認証結果を返します。<br/>
         * 正しく認証できた場合は、JWTとアカウント情報を返します。<br/>
         * @returns 正常処理
         */
        post: (option: { body: Methods_uasdn1['post']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_uasdn1['post']['resBody'], BasicHeaders, Methods_uasdn1['post']['status']>(prefix, PATH80, POST, option).json(),
        /**
         * ログイン処理を行い、認証結果を返します。<br/>
         * 正しく認証できた場合は、JWTとアカウント情報を返します。<br/>
         * @returns 正常処理
         */
        $post: (option: { body: Methods_uasdn1['post']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_uasdn1['post']['resBody'], BasicHeaders, Methods_uasdn1['post']['status']>(prefix, PATH80, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH80}`,
      },
      logout: {
        /**
         * ログアウト処理を行います。<br/>
         * サーバ側で保持しているリフレッシュトークンを削除します。<br/>
         * <br/>
         * 以下のレスポンスはHTTPステータスのみの返却となります。<br/>
         *
         * <ul>
         * <li>200：ログアウト成功。</li>
         * <li>401：認証に失敗した場合。</li>
         * </ul>
         */
        put: (option?: { config?: T | undefined } | undefined) =>
          fetch<void, BasicHeaders, Methods_ca0h2u['put']['status']>(prefix, PATH81, PUT, option).send(),
        /**
         * ログアウト処理を行います。<br/>
         * サーバ側で保持しているリフレッシュトークンを削除します。<br/>
         * <br/>
         * 以下のレスポンスはHTTPステータスのみの返却となります。<br/>
         *
         * <ul>
         * <li>200：ログアウト成功。</li>
         * <li>401：認証に失敗した場合。</li>
         * </ul>
         */
        $put: (option?: { config?: T | undefined } | undefined) =>
          fetch<void, BasicHeaders, Methods_ca0h2u['put']['status']>(prefix, PATH81, PUT, option).send().then(r => r.body),
        $path: () => `${prefix}${PATH81}`,
      },
      makers: {
        /**
         * ### 概要
         * メーカーマスタ（R_SIIRE）からメーカー一覧を取得する。
         *
         * ### 仕様
         * - `makerCode` を指定した場合、メーカーコードの部分一致で絞り込む。
         * - `makerName` を指定した場合、メーカー名・メーカー名カナの部分一致で絞り込む。
         * - 並び順はメーカーコード昇順とする。
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 400 パラメータ不正
         * - 401 未ログイン
         * @returns 正常処理
         */
        get: (option?: { query?: Methods_cupold['get']['query'] | undefined, config?: T | undefined } | undefined) =>
          fetch<Methods_cupold['get']['resBody'], BasicHeaders, Methods_cupold['get']['status']>(prefix, PATH82, GET, option).json(),
        /**
         * ### 概要
         * メーカーマスタ（R_SIIRE）からメーカー一覧を取得する。
         *
         * ### 仕様
         * - `makerCode` を指定した場合、メーカーコードの部分一致で絞り込む。
         * - `makerName` を指定した場合、メーカー名・メーカー名カナの部分一致で絞り込む。
         * - 並び順はメーカーコード昇順とする。
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 400 パラメータ不正
         * - 401 未ログイン
         * @returns 正常処理
         */
        $get: (option?: { query?: Methods_cupold['get']['query'] | undefined, config?: T | undefined } | undefined) =>
          fetch<Methods_cupold['get']['resBody'], BasicHeaders, Methods_cupold['get']['status']>(prefix, PATH82, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_cupold['get']['query'] } | undefined) =>
          `${prefix}${PATH82}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      order_histories: {
        _downloadId: (val2: number | string) => {
          const prefix2 = `${PATH83}/${val2}`;

          return {
            download: {
              /**
               * ## 説明
               * * 指定したダウンロードIDのCSVファイルの作成処理終了確認とダウンロードを行います。
               * * ステータスが処理中の場合、ファイル名と内容は空を返します。
               * * ステータスが完了の場合、ファイル名と内容を返します。<br/>
               *   ファイル名は「Altair_注文履歴_yyyyMMddHHmmssfff.csv」とします。
               * * 処理中エラーが発生した場合はエラーが返りファイル内容等は返却しません。
               * @returns 正常終了
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1k2r77n['get']['resBody'], Methods_1k2r77n['get']['resHeaders'], Methods_1k2r77n['get']['status']>(prefix, `${prefix2}${PATH28}`, GET, option).json(),
              /**
               * ## 説明
               * * 指定したダウンロードIDのCSVファイルの作成処理終了確認とダウンロードを行います。
               * * ステータスが処理中の場合、ファイル名と内容は空を返します。
               * * ステータスが完了の場合、ファイル名と内容を返します。<br/>
               *   ファイル名は「Altair_注文履歴_yyyyMMddHHmmssfff.csv」とします。
               * * 処理中エラーが発生した場合はエラーが返りファイル内容等は返却しません。
               * @returns 正常終了
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1k2r77n['get']['resBody'], Methods_1k2r77n['get']['resHeaders'], Methods_1k2r77n['get']['status']>(prefix, `${prefix2}${PATH28}`, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix2}${PATH28}`,
            },
          };
        },
        _orderNo: (val2: string) => {
          const prefix2 = `${PATH83}/${val2}`;

          return {
            delivery_date: {
              /**
               * ### 概要
               * パスパラメータで指定した発注番号、および、同一配送になる発注番号の発注に対して、<br/>
               * ご希望納品日を一括更新する。
               *
               * ### 配送単位の条件
               * - 店舗コード
               * - 郵便番号
               * - 住所1
               * - 住所2
               * - お届け先名
               * - ご希望納品日
               * - 未承認 or 未出荷ステータス
               *
               * ### HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * - 403 権限なし
               * - 404 存在しない注文詳細
               * @returns 正常処理
               */
              put: (option: { body: Methods_1j7lyoz['put']['reqBody'], config?: T | undefined }) =>
                fetch<Methods_1j7lyoz['put']['resBody'], BasicHeaders, Methods_1j7lyoz['put']['status']>(prefix, `${prefix2}${PATH84}`, PUT, option).json(),
              /**
               * ### 概要
               * パスパラメータで指定した発注番号、および、同一配送になる発注番号の発注に対して、<br/>
               * ご希望納品日を一括更新する。
               *
               * ### 配送単位の条件
               * - 店舗コード
               * - 郵便番号
               * - 住所1
               * - 住所2
               * - お届け先名
               * - ご希望納品日
               * - 未承認 or 未出荷ステータス
               *
               * ### HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * - 403 権限なし
               * - 404 存在しない注文詳細
               * @returns 正常処理
               */
              $put: (option: { body: Methods_1j7lyoz['put']['reqBody'], config?: T | undefined }) =>
                fetch<Methods_1j7lyoz['put']['resBody'], BasicHeaders, Methods_1j7lyoz['put']['status']>(prefix, `${prefix2}${PATH84}`, PUT, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix2}${PATH84}`,
            },
            shipping_infomation: {
              /**
               * ### 概要
               * パスパラメータで指定した発注番号、および、同一配送になる発注番号の発注に対して、<br/>
               * お届け先情報を一括更新する。
               *
               * ### 配送単位の条件
               * - 店舗コード
               * - 郵便番号
               * - 住所1
               * - 住所2
               * - お届け先名
               * - ご希望納品日
               * - 未承認 or 未出荷ステータス
               *
               * ### HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * - 403 権限なし
               * - 404 存在しない注文詳細
               * @returns 正常処理
               */
              put: (option: { body: Methods_1wplcw5['put']['reqBody'], config?: T | undefined }) =>
                fetch<Methods_1wplcw5['put']['resBody'], BasicHeaders, Methods_1wplcw5['put']['status']>(prefix, `${prefix2}${PATH85}`, PUT, option).json(),
              /**
               * ### 概要
               * パスパラメータで指定した発注番号、および、同一配送になる発注番号の発注に対して、<br/>
               * お届け先情報を一括更新する。
               *
               * ### 配送単位の条件
               * - 店舗コード
               * - 郵便番号
               * - 住所1
               * - 住所2
               * - お届け先名
               * - ご希望納品日
               * - 未承認 or 未出荷ステータス
               *
               * ### HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * - 403 権限なし
               * - 404 存在しない注文詳細
               * @returns 正常処理
               */
              $put: (option: { body: Methods_1wplcw5['put']['reqBody'], config?: T | undefined }) =>
                fetch<Methods_1wplcw5['put']['resBody'], BasicHeaders, Methods_1wplcw5['put']['status']>(prefix, `${prefix2}${PATH85}`, PUT, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix2}${PATH85}`,
            },
          };
        },
        _salesOrderNo: (val2: string) => {
          const prefix2 = `${PATH83}/${val2}`;

          return {
            /**
             * ### 概要
             * 指定した受注番号に紐づく出荷済みの発注情報を取得する。<br/>
             * 配送単位のサマリーと、紐づく発注番号の一覧等を取得する。<br/>
             * 商品情報は、商品ステータスによる制限なく返却する。<br/>
             *
             * ### 商品ステータス
             * - available：販売中
             * - unavailable：販売終了商品
             * - expired：販売期間外商品
             * - forbidden：扱えない商品
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 権限なし
             * - 404 存在しない受注番号
             * @returns 正常処理
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1d6h7x5['get']['resBody'], BasicHeaders, Methods_1d6h7x5['get']['status']>(prefix, prefix2, GET, option).json(),
            /**
             * ### 概要
             * 指定した受注番号に紐づく出荷済みの発注情報を取得する。<br/>
             * 配送単位のサマリーと、紐づく発注番号の一覧等を取得する。<br/>
             * 商品情報は、商品ステータスによる制限なく返却する。<br/>
             *
             * ### 商品ステータス
             * - available：販売中
             * - unavailable：販売終了商品
             * - expired：販売期間外商品
             * - forbidden：扱えない商品
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 権限なし
             * - 404 存在しない受注番号
             * @returns 正常処理
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_1d6h7x5['get']['resBody'], BasicHeaders, Methods_1d6h7x5['get']['status']>(prefix, prefix2, GET, option).json().then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          };
        },
        download: {
          /**
           * ## 説明
           * * 指定した抽出条件で抽出する注文履歴をCSVファイルでダウンロードするためのファイル作成を受け付けます。
           * * ファイルの作成を受け付けたら、ダウンロードIDを返します。
           *
           * ## 作成するCSVファイルの説明
           *   | 項目名               | 例                      | 補足説明                                                                     |
           *   |----------------------|-------------------------|------------------------------------------------------------------------------|
           *   | 店舗コード           | 15597                   |                                                                              |
           *   | 店舗名               | デモサロン              |                                                                              |
           *   | ご希望納品日         | 2024-04-01              |                                                                              |
           *   | 取込番号             | 1000000123              | 未連携の場合、空。                                                           |
           *   | お届け先郵便番号     | 1500021                 |                                                                              |
           *   | お届け先住所１       | 東京都渋谷区恵比寿西    |                                                                              |
           *   | お届け先住所２       | アーチビル              |                                                                              |
           *   | お届先電話番号       | 0312345678              |                                                                              |
           *   | お届け先名           | デモサロン              |                                                                              |
           *   | メーカーコード       | 035                     |                                                                              |
           *   | メーカー名           | 日本ロレアル　株式会社  |                                                                              |
           *   | 商品コード           | 0350030170112           |                                                                              |
           *   | JANコード            | 3474636613212           |                                                                              |
           *   | 商品名               | RE ﾌﾟﾛﾄｺﾙ ｴｸｽﾃ ｿﾜﾝ2 500 |                                                                              |
           *   | 売上種別             | 店販                    |                                                                              |
           *   | 単価                 | 3000                    | ログインユーザーが値引き表示ありなら、値引後価格。そうでないならサロン価格。 |
           *   | 数量                 | 2                       |                                                                              |
           *   | 金額                 | 6000                    | 単価 * 数量。                                                                |
           *   | 備考                 | 山田太郎様注文分        |                                                                              |
           *   | サロン価格           | 3285                    |                                                                              |
           *   | メーカー希望小売価格 | 4500                    |                                                                              |
           *
           * ### データの並び順
           * 1. お届け予定日の昇順
           * 2. 店舗コードの昇順
           * 3. 取込番号の昇順。ただし取込番号がない（未連携）のものを後に出力
           * 4. 商品コードの昇順
           * 5. 売上種別コードの昇順
           * 6. 備考の昇順。ただし、備考が空のものを先に出力。
           * @returns 正常処理
           */
          post: (option: { body: Methods_zx5yb2['post']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_zx5yb2['post']['resBody'], Methods_zx5yb2['post']['resHeaders'], Methods_zx5yb2['post']['status']>(prefix, PATH86, POST, option).json(),
          /**
           * ## 説明
           * * 指定した抽出条件で抽出する注文履歴をCSVファイルでダウンロードするためのファイル作成を受け付けます。
           * * ファイルの作成を受け付けたら、ダウンロードIDを返します。
           *
           * ## 作成するCSVファイルの説明
           *   | 項目名               | 例                      | 補足説明                                                                     |
           *   |----------------------|-------------------------|------------------------------------------------------------------------------|
           *   | 店舗コード           | 15597                   |                                                                              |
           *   | 店舗名               | デモサロン              |                                                                              |
           *   | ご希望納品日         | 2024-04-01              |                                                                              |
           *   | 取込番号             | 1000000123              | 未連携の場合、空。                                                           |
           *   | お届け先郵便番号     | 1500021                 |                                                                              |
           *   | お届け先住所１       | 東京都渋谷区恵比寿西    |                                                                              |
           *   | お届け先住所２       | アーチビル              |                                                                              |
           *   | お届先電話番号       | 0312345678              |                                                                              |
           *   | お届け先名           | デモサロン              |                                                                              |
           *   | メーカーコード       | 035                     |                                                                              |
           *   | メーカー名           | 日本ロレアル　株式会社  |                                                                              |
           *   | 商品コード           | 0350030170112           |                                                                              |
           *   | JANコード            | 3474636613212           |                                                                              |
           *   | 商品名               | RE ﾌﾟﾛﾄｺﾙ ｴｸｽﾃ ｿﾜﾝ2 500 |                                                                              |
           *   | 売上種別             | 店販                    |                                                                              |
           *   | 単価                 | 3000                    | ログインユーザーが値引き表示ありなら、値引後価格。そうでないならサロン価格。 |
           *   | 数量                 | 2                       |                                                                              |
           *   | 金額                 | 6000                    | 単価 * 数量。                                                                |
           *   | 備考                 | 山田太郎様注文分        |                                                                              |
           *   | サロン価格           | 3285                    |                                                                              |
           *   | メーカー希望小売価格 | 4500                    |                                                                              |
           *
           * ### データの並び順
           * 1. お届け予定日の昇順
           * 2. 店舗コードの昇順
           * 3. 取込番号の昇順。ただし取込番号がない（未連携）のものを後に出力
           * 4. 商品コードの昇順
           * 5. 売上種別コードの昇順
           * 6. 備考の昇順。ただし、備考が空のものを先に出力。
           * @returns 正常処理
           */
          $post: (option: { body: Methods_zx5yb2['post']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_zx5yb2['post']['resBody'], Methods_zx5yb2['post']['resHeaders'], Methods_zx5yb2['post']['status']>(prefix, PATH86, POST, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH86}`,
        },
        unshipped: {
          /**
           * ### 概要
           * 配送単位を特定するパラメータを指定して、未出荷の発注情報を取得する。<br/>
           * 配送単位のサマリーと、紐づく発注番号の一覧等を取得する。<br/>
           * 商品情報は、商品ステータスによる制限なく返却する。<br/>
           *
           * ### 商品ステータス
           * - available：販売中
           * - unavailable：販売終了商品
           * - expired：販売期間外商品
           * - forbidden：扱えない商品
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * - 403 権限なし
           * - 404 存在しない受注番号
           * @returns 正常処理
           */
          get: (option: { query: Methods_kkochw['get']['query'], config?: T | undefined }) =>
            fetch<Methods_kkochw['get']['resBody'], BasicHeaders, Methods_kkochw['get']['status']>(prefix, PATH87, GET, option).json(),
          /**
           * ### 概要
           * 配送単位を特定するパラメータを指定して、未出荷の発注情報を取得する。<br/>
           * 配送単位のサマリーと、紐づく発注番号の一覧等を取得する。<br/>
           * 商品情報は、商品ステータスによる制限なく返却する。<br/>
           *
           * ### 商品ステータス
           * - available：販売中
           * - unavailable：販売終了商品
           * - expired：販売期間外商品
           * - forbidden：扱えない商品
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * - 403 権限なし
           * - 404 存在しない受注番号
           * @returns 正常処理
           */
          $get: (option: { query: Methods_kkochw['get']['query'], config?: T | undefined }) =>
            fetch<Methods_kkochw['get']['resBody'], BasicHeaders, Methods_kkochw['get']['status']>(prefix, PATH87, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_kkochw['get']['query'] } | undefined) =>
            `${prefix}${PATH87}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        /**
         * ## 説明
         * * 配送単位の注文履歴一覧を取得する。<br>
         * * 商品一覧は、null で返却する。<br/>
         * * 配送単位の条件
         *   * 店舗コード
         *   * 郵便番号
         *   * 住所1
         *   * 住所2
         *   * お届け先名
         *   * ご希望納品日
         *   * 未承認 or 未出荷ステータス
         *
         * ### 並び順
         * 1. 着荷予定日の昇順
         * 1. 受注番号の昇順、ただし、受注番号が存在しないものを前にする
         * 1. 発注に含まれる一番小さい発注番号の昇順
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 400 パラメータ不正
         * - 401 未ログイン
         * @returns 正常処理
         */
        post: (option: { body: Methods_1l15ybx['post']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_1l15ybx['post']['resBody'], BasicHeaders, Methods_1l15ybx['post']['status']>(prefix, PATH83, POST, option).json(),
        /**
         * ## 説明
         * * 配送単位の注文履歴一覧を取得する。<br>
         * * 商品一覧は、null で返却する。<br/>
         * * 配送単位の条件
         *   * 店舗コード
         *   * 郵便番号
         *   * 住所1
         *   * 住所2
         *   * お届け先名
         *   * ご希望納品日
         *   * 未承認 or 未出荷ステータス
         *
         * ### 並び順
         * 1. 着荷予定日の昇順
         * 1. 受注番号の昇順、ただし、受注番号が存在しないものを前にする
         * 1. 発注に含まれる一番小さい発注番号の昇順
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 400 パラメータ不正
         * - 401 未ログイン
         * @returns 正常処理
         */
        $post: (option: { body: Methods_1l15ybx['post']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_1l15ybx['post']['resBody'], BasicHeaders, Methods_1l15ybx['post']['status']>(prefix, PATH83, POST, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH83}`,
      },
      orders: {
        _orderNo: (val2: string) => {
          const prefix2 = `${PATH88}/${val2}`;

          return {
            items: {
              _itemCode: (val4: string) => {
                const prefix4 = `${prefix2}${PATH49}/${val4}`;

                return {
                  /**
                   * ### 概要
                   * - 発注の指定した商品を削除する。
                   *
                   * ### 処理仕様
                   *
                   * - パラメータで指定した商品を、発注からすべての売上種別で削除する。
                   * - 発注内にすべての商品が無くなる場合、400で返り、削除できない。
                   * - 出荷済み、出荷準備中の場合400が返る。
                   * - 承認権限がない場合、承認済みは削除できず、400が返る。
                   * - 発注に無い商品の場合、404が返る。
                   *
                   *
                   * ### HTTPレスポンス
                   * - 200 正常
                   * - 400 パラメータ不正
                   * - 401 未ログイン
                   * - 404 商品なし
                   * @returns OK
                   */
                  delete: (option?: { config?: T | undefined } | undefined) =>
                    fetch<Methods_1su3kz1['delete']['resBody'], BasicHeaders, Methods_1su3kz1['delete']['status']>(prefix, prefix4, DELETE, option).json(),
                  /**
                   * ### 概要
                   * - 発注の指定した商品を削除する。
                   *
                   * ### 処理仕様
                   *
                   * - パラメータで指定した商品を、発注からすべての売上種別で削除する。
                   * - 発注内にすべての商品が無くなる場合、400で返り、削除できない。
                   * - 出荷済み、出荷準備中の場合400が返る。
                   * - 承認権限がない場合、承認済みは削除できず、400が返る。
                   * - 発注に無い商品の場合、404が返る。
                   *
                   *
                   * ### HTTPレスポンス
                   * - 200 正常
                   * - 400 パラメータ不正
                   * - 401 未ログイン
                   * - 404 商品なし
                   * @returns OK
                   */
                  $delete: (option?: { config?: T | undefined } | undefined) =>
                    fetch<Methods_1su3kz1['delete']['resBody'], BasicHeaders, Methods_1su3kz1['delete']['status']>(prefix, prefix4, DELETE, option).json().then(r => r.body),
                  $path: () => `${prefix}${prefix4}`,
                };
              },
            },
            /**
             * ### 概要
             * 指定した発注番号に紐づく発注をキャンセルする。<br/>
             * 一般ユーザーは未承認の発注のみキャンセル可能。承認済みの場合は400を返す。<br/>
             * 承認権限を持つユーザーは、未出荷の承認済み発注もキャンセル可能。
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 権限なし
             * - 404 存在しない発注番号
             */
            delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<void, BasicHeaders, Methods_k8gs2z['delete']['status']>(prefix, prefix2, DELETE, option).send(),
            /**
             * ### 概要
             * 指定した発注番号に紐づく発注をキャンセルする。<br/>
             * 一般ユーザーは未承認の発注のみキャンセル可能。承認済みの場合は400を返す。<br/>
             * 承認権限を持つユーザーは、未出荷の承認済み発注もキャンセル可能。
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 権限なし
             * - 404 存在しない発注番号
             */
            $delete: (option?: { config?: T | undefined } | undefined) =>
              fetch<void, BasicHeaders, Methods_k8gs2z['delete']['status']>(prefix, prefix2, DELETE, option).send().then(r => r.body),
            /**
             * ### 概要
             * 指定した発注番号にて発注詳細を取得する。<br/>
             * 商品情報は、商品ステータスによる制限なく返却する。<br/>
             *
             * ### 商品ステータス
             * - available：販売中
             * - unavailable：販売終了商品
             * - expired：販売期間外商品
             * - forbidden：扱えない商品
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 権限なし
             * - 404 存在しない発注番号
             * @returns 正常処理
             */
            get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_k8gs2z['get']['resBody'], BasicHeaders, Methods_k8gs2z['get']['status']>(prefix, prefix2, GET, option).json(),
            /**
             * ### 概要
             * 指定した発注番号にて発注詳細を取得する。<br/>
             * 商品情報は、商品ステータスによる制限なく返却する。<br/>
             *
             * ### 商品ステータス
             * - available：販売中
             * - unavailable：販売終了商品
             * - expired：販売期間外商品
             * - forbidden：扱えない商品
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 権限なし
             * - 404 存在しない発注番号
             * @returns 正常処理
             */
            $get: (option?: { config?: T | undefined } | undefined) =>
              fetch<Methods_k8gs2z['get']['resBody'], BasicHeaders, Methods_k8gs2z['get']['status']>(prefix, prefix2, GET, option).json().then(r => r.body),
            /**
             * ### 概要
             * 指定した発注番号に紐づく発注内容を変更する。
             *
             * - 発注内にすべての商品が無くなる場合、400で返り、更新できない。
             * - 出荷済み、出荷準備中の場合400が返る。
             * - 承認権限がない場合、承認済みは更新できず、400が返る。
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 権限なし
             * - 404 存在しない発注番号
             */
            put: (option: { body: Methods_k8gs2z['put']['reqBody'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_k8gs2z['put']['status']>(prefix, prefix2, PUT, option).send(),
            /**
             * ### 概要
             * 指定した発注番号に紐づく発注内容を変更する。
             *
             * - 発注内にすべての商品が無くなる場合、400で返り、更新できない。
             * - 出荷済み、出荷準備中の場合400が返る。
             * - 承認権限がない場合、承認済みは更新できず、400が返る。
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 権限なし
             * - 404 存在しない発注番号
             */
            $put: (option: { body: Methods_k8gs2z['put']['reqBody'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_k8gs2z['put']['status']>(prefix, prefix2, PUT, option).send().then(r => r.body),
            /**
             * ### 概要
             * 指定した発注番号に紐づく発注の商品の売上種別、数量を変更する。
             *
             * ### 処理仕様
             *
             * - パラメータに指定された商品の数量を更新する。
             * - 商品の数量が0の場合、指定の商品は発注から削除する。
             * - 登録のない商品が指定された場合は新たに追加する。
             * - 指定された商品に対して指定された売上種別、数量で置き換える。
             * - 発注内にすべての商品が無くなる場合、400で返り、削除できない。
             * - 出荷済み、出荷準備中の場合400が返る。
             * - 承認権限がない場合、承認済みは更新できず、400が返る。
             *
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 権限なし
             * - 404 存在しない発注番号
             */
            patch: (option: { body: Methods_k8gs2z['patch']['reqBody'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_k8gs2z['patch']['status']>(prefix, prefix2, PATCH, option).send(),
            /**
             * ### 概要
             * 指定した発注番号に紐づく発注の商品の売上種別、数量を変更する。
             *
             * ### 処理仕様
             *
             * - パラメータに指定された商品の数量を更新する。
             * - 商品の数量が0の場合、指定の商品は発注から削除する。
             * - 登録のない商品が指定された場合は新たに追加する。
             * - 指定された商品に対して指定された売上種別、数量で置き換える。
             * - 発注内にすべての商品が無くなる場合、400で返り、削除できない。
             * - 出荷済み、出荷準備中の場合400が返る。
             * - 承認権限がない場合、承認済みは更新できず、400が返る。
             *
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 権限なし
             * - 404 存在しない発注番号
             */
            $patch: (option: { body: Methods_k8gs2z['patch']['reqBody'], config?: T | undefined }) =>
              fetch<void, BasicHeaders, Methods_k8gs2z['patch']['status']>(prefix, prefix2, PATCH, option).send().then(r => r.body),
            $path: () => `${prefix}${prefix2}`,
          };
        },
        approve: {
          /**
           * ### 概要
           * 発注を承認する。<br/>
           * 承認は処理ステータスが正常である発注に対して発注単位または一括で承認が可能となる。<br/>
           * 指定した発注番号に紐づく発注情報に対して権限がない場合、ステータス：noAuthority を返す。<br/>
           * なお、入金親店舗に紐づく承認ユーザーの場合、自店舗と紐づく子店舗の発注を承認可能。<br/>
           * 子店舗に紐づく承認ユーザーの場合、自店舗の発注のみ承認可能。<br/>
           * 一般ユーザーは承認不可。<br/>
           *
           * ### 処理ステータス
           * - ok：正常
           * - noOrder：存在しない発注番号
           * - noAuthority：権限がない発注番号
           * - deliveryDateError：ご希望納品日エラー
           * - orderStatusApproved：承認済み
           * - orderStatusShipped：出荷済み
           * - unavailableItems：販売不可商品を含む
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * @param option.body - 発注番号を指定する
           * @returns 正常処理
           */
          patch: (option: { body: Methods_pf7t8j['patch']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_pf7t8j['patch']['resBody'], BasicHeaders, Methods_pf7t8j['patch']['status']>(prefix, PATH89, PATCH, option).json(),
          /**
           * ### 概要
           * 発注を承認する。<br/>
           * 承認は処理ステータスが正常である発注に対して発注単位または一括で承認が可能となる。<br/>
           * 指定した発注番号に紐づく発注情報に対して権限がない場合、ステータス：noAuthority を返す。<br/>
           * なお、入金親店舗に紐づく承認ユーザーの場合、自店舗と紐づく子店舗の発注を承認可能。<br/>
           * 子店舗に紐づく承認ユーザーの場合、自店舗の発注のみ承認可能。<br/>
           * 一般ユーザーは承認不可。<br/>
           *
           * ### 処理ステータス
           * - ok：正常
           * - noOrder：存在しない発注番号
           * - noAuthority：権限がない発注番号
           * - deliveryDateError：ご希望納品日エラー
           * - orderStatusApproved：承認済み
           * - orderStatusShipped：出荷済み
           * - unavailableItems：販売不可商品を含む
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * @param option.body - 発注番号を指定する
           * @returns 正常処理
           */
          $patch: (option: { body: Methods_pf7t8j['patch']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_pf7t8j['patch']['resBody'], BasicHeaders, Methods_pf7t8j['patch']['status']>(prefix, PATH89, PATCH, option).json().then(r => r.body),
          /**
           * ### 概要
           * 発注承認をキャンセルする。<br/>
           * 発注承認キャンセルは処理ステータスが正常である発注に対して発注単位または一括でキャンセルが可能となる。<br/>
           * 指定した発注番号に紐づく発注情報に対して権限がない場合、ステータス：noAuthority を返す。<br/>
           * なお、入金親店舗に紐づく承認ユーザーの場合、自店舗と紐づく子店舗の発注承認をキャンセル可能。<br/>
           * 子店舗に紐づく承認ユーザーの場合、自店舗の発注承認のみキャンセル可能。<br/>
           * 一般ユーザーは発注承認キャンセル不可。<br/>
           *
           * ### 処理ステータス
           * - ok：正常
           * - noOrder：存在しない発注番号
           * - noAuthority：権限がない発注番号
           * - orderStatusUnApproved：承認キャンセル済み
           * - orderStatusShipped：出荷済み
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * - 403 権限なし
           * - 404 存在しない発注番号
           * @param option.body - 発注番号を指定する
           * @returns 正常処理
           */
          delete: (option: { body: Methods_pf7t8j['delete']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_pf7t8j['delete']['resBody'], BasicHeaders, Methods_pf7t8j['delete']['status']>(prefix, PATH89, DELETE, option).json(),
          /**
           * ### 概要
           * 発注承認をキャンセルする。<br/>
           * 発注承認キャンセルは処理ステータスが正常である発注に対して発注単位または一括でキャンセルが可能となる。<br/>
           * 指定した発注番号に紐づく発注情報に対して権限がない場合、ステータス：noAuthority を返す。<br/>
           * なお、入金親店舗に紐づく承認ユーザーの場合、自店舗と紐づく子店舗の発注承認をキャンセル可能。<br/>
           * 子店舗に紐づく承認ユーザーの場合、自店舗の発注承認のみキャンセル可能。<br/>
           * 一般ユーザーは発注承認キャンセル不可。<br/>
           *
           * ### 処理ステータス
           * - ok：正常
           * - noOrder：存在しない発注番号
           * - noAuthority：権限がない発注番号
           * - orderStatusUnApproved：承認キャンセル済み
           * - orderStatusShipped：出荷済み
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * - 403 権限なし
           * - 404 存在しない発注番号
           * @param option.body - 発注番号を指定する
           * @returns 正常処理
           */
          $delete: (option: { body: Methods_pf7t8j['delete']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_pf7t8j['delete']['resBody'], BasicHeaders, Methods_pf7t8j['delete']['status']>(prefix, PATH89, DELETE, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH89}`,
        },
        unapproved: {
          /**
           * ### 概要
           * 未承認の発注一覧を取得する。
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 401 未ログイン
           * @returns 正常処理
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_36jp5a['get']['resBody'], BasicHeaders, Methods_36jp5a['get']['status']>(prefix, PATH90, GET, option).json(),
          /**
           * ### 概要
           * 未承認の発注一覧を取得する。
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 401 未ログイン
           * @returns 正常処理
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_36jp5a['get']['resBody'], BasicHeaders, Methods_36jp5a['get']['status']>(prefix, PATH90, GET, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH90}`,
        },
        /**
         * ### 概要
         * 指定した複数の発注に対して発注キャンセル処理を行う。<br>
         * 発注キャンセルは処理ステータスが正常である発注に対して発注単位または一括でキャンセルが可能となる。<br/>
         * 指定した発注番号に紐づく発注情報に対して権限がない場合、ステータス：noAuthority を返す。<br/>
         * なお、入金親店舗に紐づくユーザーの場合、自店舗と紐づく子店舗の発注をキャンセル可能。<br/>
         * 子店舗に紐づくユーザーの場合、自店舗の発注のみキャンセル可能。<br/>
         * 一般ユーザーは未承認の発注のみキャンセル可能。承認済みの発注は、承認者による承認取り消し後にキャンセル可能。<br/>
         * 承認権限を持つユーザーは、未出荷の承認済み発注もキャンセル可能。<br/>
         *
         * ### 処理ステータス
         * - ok：正常
         * - noOrder：存在しない発注番号
         * - noAuthority：権限が発注番号
         * - orderStatusShipped：出荷済み
         * - orderStatusApproved：承認済みのため一般ユーザーはキャンセル不可
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 400 パラメータ不正
         * - 401 未ログイン
         * @returns 正常処理
         */
        delete: (option: { body: Methods_1p1uf81['delete']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_1p1uf81['delete']['resBody'], BasicHeaders, Methods_1p1uf81['delete']['status']>(prefix, PATH88, DELETE, option).json(),
        /**
         * ### 概要
         * 指定した複数の発注に対して発注キャンセル処理を行う。<br>
         * 発注キャンセルは処理ステータスが正常である発注に対して発注単位または一括でキャンセルが可能となる。<br/>
         * 指定した発注番号に紐づく発注情報に対して権限がない場合、ステータス：noAuthority を返す。<br/>
         * なお、入金親店舗に紐づくユーザーの場合、自店舗と紐づく子店舗の発注をキャンセル可能。<br/>
         * 子店舗に紐づくユーザーの場合、自店舗の発注のみキャンセル可能。<br/>
         * 一般ユーザーは未承認の発注のみキャンセル可能。承認済みの発注は、承認者による承認取り消し後にキャンセル可能。<br/>
         * 承認権限を持つユーザーは、未出荷の承認済み発注もキャンセル可能。<br/>
         *
         * ### 処理ステータス
         * - ok：正常
         * - noOrder：存在しない発注番号
         * - noAuthority：権限が発注番号
         * - orderStatusShipped：出荷済み
         * - orderStatusApproved：承認済みのため一般ユーザーはキャンセル不可
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 400 パラメータ不正
         * - 401 未ログイン
         * @returns 正常処理
         */
        $delete: (option: { body: Methods_1p1uf81['delete']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_1p1uf81['delete']['resBody'], BasicHeaders, Methods_1p1uf81['delete']['status']>(prefix, PATH88, DELETE, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH88}`,
      },
      price_changes: {
        _downloadId: (val2: string) => {
          const prefix2 = `${PATH91}/${val2}`;

          return {
            download: {
              /**
               * ### 概要
               * - ダウンロード受付した、CSVファイルの作成処理終了確認とダウンロードを行う。
               *
               * ### 処理仕様
               * - ダウンロード受付し、作成されたCSVファイルをローカルにダウンロードする。
               * - 処理中の場合、ファイル名と内容は空を返す。
               * - 処理が完了した場合、ファイル名と内容が返る。
               * - 処理中エラーが発生した場合はエラーが返りファイル内容等は返却されない。
               *
               * ### HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * @returns 正常処理
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1grucdw['get']['resBody'], BasicHeaders, Methods_1grucdw['get']['status']>(prefix, `${prefix2}${PATH28}`, GET, option).json(),
              /**
               * ### 概要
               * - ダウンロード受付した、CSVファイルの作成処理終了確認とダウンロードを行う。
               *
               * ### 処理仕様
               * - ダウンロード受付し、作成されたCSVファイルをローカルにダウンロードする。
               * - 処理中の場合、ファイル名と内容は空を返す。
               * - 処理が完了した場合、ファイル名と内容が返る。
               * - 処理中エラーが発生した場合はエラーが返りファイル内容等は返却されない。
               *
               * ### HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * @returns 正常処理
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1grucdw['get']['resBody'], BasicHeaders, Methods_1grucdw['get']['status']>(prefix, `${prefix2}${PATH28}`, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix2}${PATH28}`,
            },
          };
        },
        download: {
          /**
           * ### 概要
           * - ログイン店舗で購入可能な価格改定・商品コード変更の詳細一覧をCSVファイルでダウンロードするためのファイル作成を受け付ける。
           * - ダウンロードのための、ダウンロードIDが返却される。
           *
           * ### 処理仕様
           * - 検索条件に合致する一覧を抽出し、抽出結果をCSVファイルとしてS3に保存する。
           * - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
           * - 処理終了の確認、及びファイルのダウンロードは、`GET /v1/price-changes/{downloadId}/download`にて行う。
           * - ダウンロードする場合のファイル名は「価格・商品コード変更情報_yyyyMMddHHmmssfff.csv」とする。
           * - 検索条件は一覧取得API（`GET /v1/price-changes`）と同じものを使用する。ページングは行わず、検索条件に合致する全件を出力する。
           * - ログイン店舗で購入できない商品は出力しない。
           * - UTF-8 BOM形式CSVに整形して保存する。
           *
           * ### 並び順
           * - 改定日、商品コード（一覧取得APIと同じ）
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           *
           * ### CSVカラム（changeType=price）
           * 1. 商品コード
           * 1. 商品名
           * 1. メーカーコード
           * 1. メーカー名
           * 1. 旧上代
           * 1. 旧BS価
           * 1. 上代
           * 1. BS価
           * 1. 価格変更日
           * 1. データ更新日
           *
           * ### CSVカラム（changeType=productCode）
           * 1. 旧商品コード
           * 1. 旧商品名
           * 1. 新商品コード
           * 1. 新商品名
           * 1. メーカーコード
           * 1. メーカー名
           * 1. 旧上代
           * 1. 旧BS価
           * 1. 上代
           * 1. BS価
           * 1. 価格変更日
           * 1. データ更新日
           * @returns 正常処理
           */
          post: (option: { body: Methods_1j88vwq['post']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_1j88vwq['post']['resBody'], BasicHeaders, Methods_1j88vwq['post']['status']>(prefix, PATH92, POST, option).json(),
          /**
           * ### 概要
           * - ログイン店舗で購入可能な価格改定・商品コード変更の詳細一覧をCSVファイルでダウンロードするためのファイル作成を受け付ける。
           * - ダウンロードのための、ダウンロードIDが返却される。
           *
           * ### 処理仕様
           * - 検索条件に合致する一覧を抽出し、抽出結果をCSVファイルとしてS3に保存する。
           * - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
           * - 処理終了の確認、及びファイルのダウンロードは、`GET /v1/price-changes/{downloadId}/download`にて行う。
           * - ダウンロードする場合のファイル名は「価格・商品コード変更情報_yyyyMMddHHmmssfff.csv」とする。
           * - 検索条件は一覧取得API（`GET /v1/price-changes`）と同じものを使用する。ページングは行わず、検索条件に合致する全件を出力する。
           * - ログイン店舗で購入できない商品は出力しない。
           * - UTF-8 BOM形式CSVに整形して保存する。
           *
           * ### 並び順
           * - 改定日、商品コード（一覧取得APIと同じ）
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           *
           * ### CSVカラム（changeType=price）
           * 1. 商品コード
           * 1. 商品名
           * 1. メーカーコード
           * 1. メーカー名
           * 1. 旧上代
           * 1. 旧BS価
           * 1. 上代
           * 1. BS価
           * 1. 価格変更日
           * 1. データ更新日
           *
           * ### CSVカラム（changeType=productCode）
           * 1. 旧商品コード
           * 1. 旧商品名
           * 1. 新商品コード
           * 1. 新商品名
           * 1. メーカーコード
           * 1. メーカー名
           * 1. 旧上代
           * 1. 旧BS価
           * 1. 上代
           * 1. BS価
           * 1. 価格変更日
           * 1. データ更新日
           * @returns 正常処理
           */
          $post: (option: { body: Methods_1j88vwq['post']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_1j88vwq['post']['resBody'], BasicHeaders, Methods_1j88vwq['post']['status']>(prefix, PATH92, POST, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH92}`,
        },
        /**
         * ### 概要
         * ログイン店舗で購入可能な価格改定・商品コード変更の詳細一覧を取得する。
         *
         * ### 仕様
         * - お知らせ詳細の `priceChange.changeType` と `priceChange.effectiveDate` を検索条件として使用できる。
         * - `changeType = price` の場合、価格のみ変更された商品を返却する。
         * - `changeType = productCode` の場合、商品コード変更を伴う商品を返却する。
         * - `date` を指定した場合、指定日の改定のみ返却する。
         * - `dateFrom` / `dateTo` を指定した場合、改定日範囲で絞り込む。
         * - `date` と `dateFrom` / `dateTo` は同時指定できない。同時指定時は400を返す。
         * - `makerCode` を指定した場合、指定メーカーの商品のみ返却する。
         * - ログイン店舗で購入できない商品は返却しない。
         * @returns 正常処理
         */
        get: (option: { query: Methods_1xtjw35['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1xtjw35['get']['resBody'], BasicHeaders, Methods_1xtjw35['get']['status']>(prefix, PATH91, GET, option).json(),
        /**
         * ### 概要
         * ログイン店舗で購入可能な価格改定・商品コード変更の詳細一覧を取得する。
         *
         * ### 仕様
         * - お知らせ詳細の `priceChange.changeType` と `priceChange.effectiveDate` を検索条件として使用できる。
         * - `changeType = price` の場合、価格のみ変更された商品を返却する。
         * - `changeType = productCode` の場合、商品コード変更を伴う商品を返却する。
         * - `date` を指定した場合、指定日の改定のみ返却する。
         * - `dateFrom` / `dateTo` を指定した場合、改定日範囲で絞り込む。
         * - `date` と `dateFrom` / `dateTo` は同時指定できない。同時指定時は400を返す。
         * - `makerCode` を指定した場合、指定メーカーの商品のみ返却する。
         * - ログイン店舗で購入できない商品は返却しない。
         * @returns 正常処理
         */
        $get: (option: { query: Methods_1xtjw35['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1xtjw35['get']['resBody'], BasicHeaders, Methods_1xtjw35['get']['status']>(prefix, PATH91, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_1xtjw35['get']['query'] } | undefined) =>
          `${prefix}${PATH91}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      purchases: {
        _downloadId: (val2: string) => {
          const prefix2 = `${PATH93}/${val2}`;

          return {
            download: {
              /**
               * ### 概要
               * - ダウンロード受付した、CSVファイルの作成処理終了確認とダウンロードを行う。
               * ### 処理仕様
               * - ダウンロード受付し、作成されたCSVファイルをローカルにダウンロードする。
               * - 処理中の場合、ファイル名と内容は空を返す。
               * - 処理が完了した場合、ファイル名と内容が返る。
               * - 処理中エラーが発生した場合はエラーが返りファイル内容等は返却されない。
               * @returns 正常処理
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_qr3kfp['get']['resBody'], BasicHeaders, Methods_qr3kfp['get']['status']>(prefix, `${prefix2}${PATH28}`, GET, option).json(),
              /**
               * ### 概要
               * - ダウンロード受付した、CSVファイルの作成処理終了確認とダウンロードを行う。
               * ### 処理仕様
               * - ダウンロード受付し、作成されたCSVファイルをローカルにダウンロードする。
               * - 処理中の場合、ファイル名と内容は空を返す。
               * - 処理が完了した場合、ファイル名と内容が返る。
               * - 処理中エラーが発生した場合はエラーが返りファイル内容等は返却されない。
               * @returns 正常処理
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_qr3kfp['get']['resBody'], BasicHeaders, Methods_qr3kfp['get']['status']>(prefix, `${prefix2}${PATH28}`, GET, option).json().then(r => r.body),
              $path: () => `${prefix}${prefix2}${PATH28}`,
            },
          };
        },
        ec_site_orders: {
          _systemType: (val3: string) => {
            const prefix3 = `${PATH94}/${val3}`;

            return {
              /**
               * EC注文番号を指定して、EC注文取込結果詳細を取得します。
               * @returns 正常処理
               */
              get: (option: { query: Methods_5odokl['get']['query'], config?: T | undefined }) =>
                fetch<Methods_5odokl['get']['resBody'], BasicHeaders, Methods_5odokl['get']['status']>(prefix, prefix3, GET, option).json(),
              /**
               * EC注文番号を指定して、EC注文取込結果詳細を取得します。
               * @returns 正常処理
               */
              $get: (option: { query: Methods_5odokl['get']['query'], config?: T | undefined }) =>
                fetch<Methods_5odokl['get']['resBody'], BasicHeaders, Methods_5odokl['get']['status']>(prefix, prefix3, GET, option).json().then(r => r.body),
              $path: (option?: { method?: 'get' | undefined; query: Methods_5odokl['get']['query'] } | undefined) =>
                `${prefix}${prefix3}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
            };
          },
          download: {
            /**
             * ### 処理概要
             *
             * - 仕入情報のEC注文取込結果で一覧をCSVファイルダウンロード受付する。
             * - ダウンロードのための、ダウンロードIDが返却される。
             *
             * ### 仕様
             *
             * - 検索条件に合致する EC注文取込結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
             * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
             *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
             *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
             *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
             * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
             * - ダウンロードする場合のファイル名は「仕入情報_EC注文取込結果_yyyyMMddHHmmssfff.csv」とする。
             *
             * ### CSVカラム
             *
             * - EC注文番号,取込日時,出荷ステータス,システム種別,送付先ID,お届先都道府県,お届先名,出荷日,送り状番号,ファイル名,配送希望日,配送希望時間,出荷予定日,着荷予定日,出荷倉庫,運送会社,運送会社コード,受注番号,売上番号,行番号,JANコード,商品名,数量
             * @returns 正常処理
             */
            post: (option: { body: Methods_1hbvq4w['post']['reqBody'], config?: T | undefined }) =>
              fetch<Methods_1hbvq4w['post']['resBody'], Methods_1hbvq4w['post']['resHeaders'], Methods_1hbvq4w['post']['status']>(prefix, PATH95, POST, option).json(),
            /**
             * ### 処理概要
             *
             * - 仕入情報のEC注文取込結果で一覧をCSVファイルダウンロード受付する。
             * - ダウンロードのための、ダウンロードIDが返却される。
             *
             * ### 仕様
             *
             * - 検索条件に合致する EC注文取込結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
             * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
             *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
             *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
             *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
             * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
             * - ダウンロードする場合のファイル名は「仕入情報_EC注文取込結果_yyyyMMddHHmmssfff.csv」とする。
             *
             * ### CSVカラム
             *
             * - EC注文番号,取込日時,出荷ステータス,システム種別,送付先ID,お届先都道府県,お届先名,出荷日,送り状番号,ファイル名,配送希望日,配送希望時間,出荷予定日,着荷予定日,出荷倉庫,運送会社,運送会社コード,受注番号,売上番号,行番号,JANコード,商品名,数量
             * @returns 正常処理
             */
            $post: (option: { body: Methods_1hbvq4w['post']['reqBody'], config?: T | undefined }) =>
              fetch<Methods_1hbvq4w['post']['resBody'], Methods_1hbvq4w['post']['resHeaders'], Methods_1hbvq4w['post']['status']>(prefix, PATH95, POST, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH95}`,
          },
          /**
           * EC注文取込結果の検索を行います。<br/>
           * 検索結果の並び順は、取込日時の降順、EC注文番号の昇順になります。
           * @returns 正常処理
           */
          get: (option: { query: Methods_bu33lb['get']['query'], config?: T | undefined }) =>
            fetch<Methods_bu33lb['get']['resBody'], BasicHeaders, Methods_bu33lb['get']['status']>(prefix, PATH94, GET, option).json(),
          /**
           * EC注文取込結果の検索を行います。<br/>
           * 検索結果の並び順は、取込日時の降順、EC注文番号の昇順になります。
           * @returns 正常処理
           */
          $get: (option: { query: Methods_bu33lb['get']['query'], config?: T | undefined }) =>
            fetch<Methods_bu33lb['get']['resBody'], BasicHeaders, Methods_bu33lb['get']['status']>(prefix, PATH94, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_bu33lb['get']['query'] } | undefined) =>
            `${prefix}${PATH94}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        makers: {
          download: {
            /**
             * ### 概要
             * - 仕入情報のメーカー別で一覧をCSVファイルダウンロード受付する。
             * - ダウンロードのための、ダウンロードIDが返却される。
             * ### 処理仕様
             *
             * - 検索条件に合致するメーカー別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
             * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
             *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
             *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
             *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
             * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
             * - ダウンロードする場合のファイル名は「仕入情報_メーカー別_yyyyMMddHHmmssfff.csv」とする。
             *
             * - パラメータから一覧取得条件を作成する。
             * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
             * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
             * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
             * - 集計対象に請求を指定した場合、請求月で抽出を行う。
             * - 請求月の指定がない場合当月とする。
             * - 値引き価格表示ありの場合は、値引き後の価格とする。
             * - DBから結果を取得する。
             * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
             * - 上記の内容で処理を開始する。
             *
             * ### 並び順
             * - メーカーコード
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 権限のない集計単位の指定
             *
             * ### CSVカラム
             * 1. メーカー
             * 1. メーカーコード
             * 1. 数量
             * 1. サロン価格
             * @returns 正常処理
             */
            post: (option: { body: Methods_66sjad['post']['reqBody'], config?: T | undefined }) =>
              fetch<Methods_66sjad['post']['resBody'], BasicHeaders, Methods_66sjad['post']['status']>(prefix, PATH97, POST, option).json(),
            /**
             * ### 概要
             * - 仕入情報のメーカー別で一覧をCSVファイルダウンロード受付する。
             * - ダウンロードのための、ダウンロードIDが返却される。
             * ### 処理仕様
             *
             * - 検索条件に合致するメーカー別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
             * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
             *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
             *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
             *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
             * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
             * - ダウンロードする場合のファイル名は「仕入情報_メーカー別_yyyyMMddHHmmssfff.csv」とする。
             *
             * - パラメータから一覧取得条件を作成する。
             * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
             * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
             * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
             * - 集計対象に請求を指定した場合、請求月で抽出を行う。
             * - 請求月の指定がない場合当月とする。
             * - 値引き価格表示ありの場合は、値引き後の価格とする。
             * - DBから結果を取得する。
             * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
             * - 上記の内容で処理を開始する。
             *
             * ### 並び順
             * - メーカーコード
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 権限のない集計単位の指定
             *
             * ### CSVカラム
             * 1. メーカー
             * 1. メーカーコード
             * 1. 数量
             * 1. サロン価格
             * @returns 正常処理
             */
            $post: (option: { body: Methods_66sjad['post']['reqBody'], config?: T | undefined }) =>
              fetch<Methods_66sjad['post']['resBody'], BasicHeaders, Methods_66sjad['post']['status']>(prefix, PATH97, POST, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH97}`,
          },
          stores: {
            download: {
              /**
               * ### 概要
               * - 仕入情報のメーカー別店舗別で一覧をCSVファイルダウンロード処理受付する。
               * - ダウンロードのための、ダウンロードIDが返却される。
               *
               * ### 処理仕様
               *
               * - 検索条件に合致するメーカ別店舗別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
               * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
               *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
               *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
               *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
               * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
               * - ダウンロードする場合のファイル名は「仕入情報_メーカ別店舗別_yyyyMMddHHmmssfff.csv」とする。
               *
               * - パラメータから一覧取得条件を作成する。
               * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
               * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
               * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
               * - 集計対象に請求を指定した場合、請求月で抽出を行う。
               * - 請求月の指定がない場合当月とする。
               * - 値引き価格表示ありの場合は、値引き後の価格とする。
               * - DBから結果を取得する。
               * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
               * - 上記の内容で処理を開始する。
               *
               * ### 並び順
               * - 店舗コード
               * - メーカーコード
               *
               * ### HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * - 403 権限のない集計単位の指定
               *
               * ### CSVカラム
               * 1. 店舗コード
               * 1. 店舗名
               * 1. メーカー名:金額(複数あり)
               * @returns 正常処理
               */
              post: (option: { body: Methods_xctigs['post']['reqBody'], config?: T | undefined }) =>
                fetch<Methods_xctigs['post']['resBody'], BasicHeaders, Methods_xctigs['post']['status']>(prefix, PATH99, POST, option).json(),
              /**
               * ### 概要
               * - 仕入情報のメーカー別店舗別で一覧をCSVファイルダウンロード処理受付する。
               * - ダウンロードのための、ダウンロードIDが返却される。
               *
               * ### 処理仕様
               *
               * - 検索条件に合致するメーカ別店舗別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
               * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
               *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
               *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
               *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
               * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
               * - ダウンロードする場合のファイル名は「仕入情報_メーカ別店舗別_yyyyMMddHHmmssfff.csv」とする。
               *
               * - パラメータから一覧取得条件を作成する。
               * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
               * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
               * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
               * - 集計対象に請求を指定した場合、請求月で抽出を行う。
               * - 請求月の指定がない場合当月とする。
               * - 値引き価格表示ありの場合は、値引き後の価格とする。
               * - DBから結果を取得する。
               * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
               * - 上記の内容で処理を開始する。
               *
               * ### 並び順
               * - 店舗コード
               * - メーカーコード
               *
               * ### HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * - 403 権限のない集計単位の指定
               *
               * ### CSVカラム
               * 1. 店舗コード
               * 1. 店舗名
               * 1. メーカー名:金額(複数あり)
               * @returns 正常処理
               */
              $post: (option: { body: Methods_xctigs['post']['reqBody'], config?: T | undefined }) =>
                fetch<Methods_xctigs['post']['resBody'], BasicHeaders, Methods_xctigs['post']['status']>(prefix, PATH99, POST, option).json().then(r => r.body),
              $path: () => `${prefix}${PATH99}`,
            },
            /**
             * ### 概要
             * 仕入情報のメーカー別店舗別で一覧を取得する。
             * ### 処理仕様
             * - パラメータから一覧取得条件を作成する。
             * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
             * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
             * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
             * - 集計対象に請求を指定した場合、請求月で抽出を行う。
             * - 請求月の指定がない場合当月とする。
             * - 値引き価格表示ありの場合は、値引き後の価格とする。
             * - DBから結果を取得する。
             * - 結果を返す。
             *
             * ### 並び順
             * - 店舗コード
             * - メーカーコード
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 権限のない集計単位の指定
             *
             * ### カラム
             * | No. | dataField | headerName | type |
             * |-----|-----------|------------|------|
             * | 1 | storeCode | 店舗コード | string |
             * | 2 | storeName | 店舗名 | string |
             * | 3 | price | メーカー名ごとに金額(複数あり) | integer |
             * @returns 正常処理
             */
            get: (option: { query: Methods_1nq89o3['get']['query'], config?: T | undefined }) =>
              fetch<Methods_1nq89o3['get']['resBody'], BasicHeaders, Methods_1nq89o3['get']['status']>(prefix, PATH98, GET, option).json(),
            /**
             * ### 概要
             * 仕入情報のメーカー別店舗別で一覧を取得する。
             * ### 処理仕様
             * - パラメータから一覧取得条件を作成する。
             * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
             * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
             * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
             * - 集計対象に請求を指定した場合、請求月で抽出を行う。
             * - 請求月の指定がない場合当月とする。
             * - 値引き価格表示ありの場合は、値引き後の価格とする。
             * - DBから結果を取得する。
             * - 結果を返す。
             *
             * ### 並び順
             * - 店舗コード
             * - メーカーコード
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 権限のない集計単位の指定
             *
             * ### カラム
             * | No. | dataField | headerName | type |
             * |-----|-----------|------------|------|
             * | 1 | storeCode | 店舗コード | string |
             * | 2 | storeName | 店舗名 | string |
             * | 3 | price | メーカー名ごとに金額(複数あり) | integer |
             * @returns 正常処理
             */
            $get: (option: { query: Methods_1nq89o3['get']['query'], config?: T | undefined }) =>
              fetch<Methods_1nq89o3['get']['resBody'], BasicHeaders, Methods_1nq89o3['get']['status']>(prefix, PATH98, GET, option).json().then(r => r.body),
            $path: (option?: { method?: 'get' | undefined; query: Methods_1nq89o3['get']['query'] } | undefined) =>
              `${prefix}${PATH98}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
          },
          /**
           * ### 概要
           * 仕入情報のメーカー別で一覧を取得する。
           * ### 処理仕様
           *
           * - パラメータから一覧取得条件を作成する。
           * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
           * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
           * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
           * - 集計対象に請求を指定した場合、請求月で抽出を行う。
           * - 請求月の指定がない場合当月とする。
           * - DBから結果を取得する。
           * - 結果を返す。
           * - (追記)出荷数量で「０」の場合、「欠品」として表示する。
           *
           * ### 並び順
           * - メーカーコード
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * - 403 権限のない集計単位の指定
           *
           * ### カラム
           * | No. | dataField | headerName | type |
           * |-----|-----------|------------|------|
           * | 1 | makerName | メーカー | string |
           * | 2 | makerCode | メーカーコード | string |
           * | 3 | orderQuantity | 受注数量 | integer |
           * | 4 | quantity | 出荷数量 | string |
           * | 5 | salonPrice | サロン価格 | integer |
           * @returns 正常処理
           */
          get: (option: { query: Methods_h25ix8['get']['query'], config?: T | undefined }) =>
            fetch<Methods_h25ix8['get']['resBody'], BasicHeaders, Methods_h25ix8['get']['status']>(prefix, PATH96, GET, option).json(),
          /**
           * ### 概要
           * 仕入情報のメーカー別で一覧を取得する。
           * ### 処理仕様
           *
           * - パラメータから一覧取得条件を作成する。
           * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
           * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
           * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
           * - 集計対象に請求を指定した場合、請求月で抽出を行う。
           * - 請求月の指定がない場合当月とする。
           * - DBから結果を取得する。
           * - 結果を返す。
           * - (追記)出荷数量で「０」の場合、「欠品」として表示する。
           *
           * ### 並び順
           * - メーカーコード
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * - 403 権限のない集計単位の指定
           *
           * ### カラム
           * | No. | dataField | headerName | type |
           * |-----|-----------|------------|------|
           * | 1 | makerName | メーカー | string |
           * | 2 | makerCode | メーカーコード | string |
           * | 3 | orderQuantity | 受注数量 | integer |
           * | 4 | quantity | 出荷数量 | string |
           * | 5 | salonPrice | サロン価格 | integer |
           * @returns 正常処理
           */
          $get: (option: { query: Methods_h25ix8['get']['query'], config?: T | undefined }) =>
            fetch<Methods_h25ix8['get']['resBody'], BasicHeaders, Methods_h25ix8['get']['status']>(prefix, PATH96, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_h25ix8['get']['query'] } | undefined) =>
            `${prefix}${PATH96}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
        stores: {
          download: {
            /**
             * ### 概要
             * - 仕入情報の店舗別で一覧をCSVファイルダウンロード受付する。
             * - ダウンロードのための、ダウンロードIDが返却される。
             *
             * ### 処理仕様
             *
             * - 検索条件に合致する店舗別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
             * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
             *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
             *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
             *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
             * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
             * - ダウンロードする場合のファイル名は「仕入情報_店舗別_yyyyMMddHHmmssfff.csv」とする。
             *
             * - パラメータから一覧取得条件を作成する。
             * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
             * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
             * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
             * - 集計対象に請求を指定した場合、請求月で抽出を行う。
             * - 請求月の指定がない場合当月とする。
             * - DBから結果を取得する。
             * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
             * - 上記の内容で処理を開始する。
             *
             * ### 並び順
             * - 店舗コード
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 権限のない集計単位の指定
             *
             * ### CSVカラム
             * 1. 店舗コード
             * 1. 店舗名
             * 1. 数量
             * 1. サロン価格
             * @returns 正常処理
             */
            post: (option: { body: Methods_a4c4pk['post']['reqBody'], config?: T | undefined }) =>
              fetch<Methods_a4c4pk['post']['resBody'], BasicHeaders, Methods_a4c4pk['post']['status']>(prefix, PATH101, POST, option).json(),
            /**
             * ### 概要
             * - 仕入情報の店舗別で一覧をCSVファイルダウンロード受付する。
             * - ダウンロードのための、ダウンロードIDが返却される。
             *
             * ### 処理仕様
             *
             * - 検索条件に合致する店舗別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
             * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
             *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
             *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
             *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
             * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
             * - ダウンロードする場合のファイル名は「仕入情報_店舗別_yyyyMMddHHmmssfff.csv」とする。
             *
             * - パラメータから一覧取得条件を作成する。
             * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
             * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
             * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
             * - 集計対象に請求を指定した場合、請求月で抽出を行う。
             * - 請求月の指定がない場合当月とする。
             * - DBから結果を取得する。
             * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
             * - 上記の内容で処理を開始する。
             *
             * ### 並び順
             * - 店舗コード
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 権限のない集計単位の指定
             *
             * ### CSVカラム
             * 1. 店舗コード
             * 1. 店舗名
             * 1. 数量
             * 1. サロン価格
             * @returns 正常処理
             */
            $post: (option: { body: Methods_a4c4pk['post']['reqBody'], config?: T | undefined }) =>
              fetch<Methods_a4c4pk['post']['resBody'], BasicHeaders, Methods_a4c4pk['post']['status']>(prefix, PATH101, POST, option).json().then(r => r.body),
            $path: () => `${prefix}${PATH101}`,
          },
          makers: {
            sales_types: {
              download: {
                /**
                 * ### 概要
                 * - 仕入情報の店舗別メーカー別売上種別別で金額一覧をCSVファイルダウンロード処理受付する。
                 * - ダウンロードのための、ダウンロードIDが返却される。
                 * ### 処理仕様
                 *
                 * - 検索条件に合致する店舗別メーカー別売上種別別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
                 * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
                 *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
                 *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
                 *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
                 * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
                 * - ダウンロードする場合のファイル名は「仕入情報_店舗別メーカー別売上種別別_yyyyMMddHHmmssfff.csv」とする。
                 *
                 * - パラメータから一覧取得条件を作成する。
                 * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                 * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                 * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                 * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                 * - 請求月の指定がない場合当月とする。
                 * - 値引き価格表示ありの場合は、値引き後の価格とする。
                 * - DBから結果を取得する。
                 * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
                 * - 上記の内容で処理を開始する。
                 *
                 * ### 並び順
                 * - 店舗コード
                 * - メーカーコード
                 * - 売上種別コード
                 *
                 * ### HTTPレスポンス
                 * - 200 正常
                 * - 400 パラメータ不正
                 * - 401 未ログイン
                 * - 403 権限のない集計単位の指定
                 *
                 * ### CSVカラム
                 * 1. 店舗コード
                 * 1. 店舗名
                 * 1. メーカー名(複数あり)
                 * 1. 売上種別(複数あり)
                 * @returns 正常処理
                 */
                post: (option: { body: Methods_1lstq9j['post']['reqBody'], config?: T | undefined }) =>
                  fetch<Methods_1lstq9j['post']['resBody'], BasicHeaders, Methods_1lstq9j['post']['status']>(prefix, PATH103, POST, option).json(),
                /**
                 * ### 概要
                 * - 仕入情報の店舗別メーカー別売上種別別で金額一覧をCSVファイルダウンロード処理受付する。
                 * - ダウンロードのための、ダウンロードIDが返却される。
                 * ### 処理仕様
                 *
                 * - 検索条件に合致する店舗別メーカー別売上種別別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
                 * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
                 *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
                 *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
                 *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
                 * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
                 * - ダウンロードする場合のファイル名は「仕入情報_店舗別メーカー別売上種別別_yyyyMMddHHmmssfff.csv」とする。
                 *
                 * - パラメータから一覧取得条件を作成する。
                 * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
                 * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
                 * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
                 * - 集計対象に請求を指定した場合、請求月で抽出を行う。
                 * - 請求月の指定がない場合当月とする。
                 * - 値引き価格表示ありの場合は、値引き後の価格とする。
                 * - DBから結果を取得する。
                 * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
                 * - 上記の内容で処理を開始する。
                 *
                 * ### 並び順
                 * - 店舗コード
                 * - メーカーコード
                 * - 売上種別コード
                 *
                 * ### HTTPレスポンス
                 * - 200 正常
                 * - 400 パラメータ不正
                 * - 401 未ログイン
                 * - 403 権限のない集計単位の指定
                 *
                 * ### CSVカラム
                 * 1. 店舗コード
                 * 1. 店舗名
                 * 1. メーカー名(複数あり)
                 * 1. 売上種別(複数あり)
                 * @returns 正常処理
                 */
                $post: (option: { body: Methods_1lstq9j['post']['reqBody'], config?: T | undefined }) =>
                  fetch<Methods_1lstq9j['post']['resBody'], BasicHeaders, Methods_1lstq9j['post']['status']>(prefix, PATH103, POST, option).json().then(r => r.body),
                $path: () => `${prefix}${PATH103}`,
              },
              /**
               * ### 概要
               * 仕入情報の店舗別メーカー別売上種別別で一覧を取得する。
               * ### 処理仕様
               * - パラメータから一覧取得条件を作成する。
               * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
               * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
               * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
               * - 集計対象に請求を指定した場合、請求月で抽出を行う。
               * - 請求月の指定がない場合当月とする。
               * - 値引き価格表示ありの場合は、値引き後の価格とする。
               * - DBから結果を取得する。
               * - 結果を返す。
               *
               * ### 並び順
               * - 店舗コード
               * - メーカーコード
               * - 売上種別コード
               *
               * ### HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * - 403 権限のない集計単位の指定
               *
               * ### カラム
               * | No. | dataField | headerName | type |
               * |-----|-----------|------------|------|
               * | 1 | storeCode | 店舗コード | string |
               * | 2 | storeName | 店舗名 | string |
               * | 3 | makerName | メーカー名(複数あり) | string |
               * | 4 | price | 売上種別ごとの金額(複数あり) | integer |
               * @returns 正常処理
               */
              get: (option: { query: Methods_xe55em['get']['query'], config?: T | undefined }) =>
                fetch<Methods_xe55em['get']['resBody'], BasicHeaders, Methods_xe55em['get']['status']>(prefix, PATH102, GET, option).json(),
              /**
               * ### 概要
               * 仕入情報の店舗別メーカー別売上種別別で一覧を取得する。
               * ### 処理仕様
               * - パラメータから一覧取得条件を作成する。
               * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
               * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
               * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
               * - 集計対象に請求を指定した場合、請求月で抽出を行う。
               * - 請求月の指定がない場合当月とする。
               * - 値引き価格表示ありの場合は、値引き後の価格とする。
               * - DBから結果を取得する。
               * - 結果を返す。
               *
               * ### 並び順
               * - 店舗コード
               * - メーカーコード
               * - 売上種別コード
               *
               * ### HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * - 403 権限のない集計単位の指定
               *
               * ### カラム
               * | No. | dataField | headerName | type |
               * |-----|-----------|------------|------|
               * | 1 | storeCode | 店舗コード | string |
               * | 2 | storeName | 店舗名 | string |
               * | 3 | makerName | メーカー名(複数あり) | string |
               * | 4 | price | 売上種別ごとの金額(複数あり) | integer |
               * @returns 正常処理
               */
              $get: (option: { query: Methods_xe55em['get']['query'], config?: T | undefined }) =>
                fetch<Methods_xe55em['get']['resBody'], BasicHeaders, Methods_xe55em['get']['status']>(prefix, PATH102, GET, option).json().then(r => r.body),
              $path: (option?: { method?: 'get' | undefined; query: Methods_xe55em['get']['query'] } | undefined) =>
                `${prefix}${PATH102}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
            },
          },
          sales_types: {
            download: {
              /**
               * ### 概要
               * - 仕入情報の店舗別売上種別別で一覧をCSVファイルダウンロード処理受付する。
               * - ダウンロードのための、ダウンロードIDが返却される。
               *
               * ### 処理仕様
               *
               * - 検索条件に合致する店舗別売上種別別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
               * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
               *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
               *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
               *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
               * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
               * - ダウンロードする場合のファイル名は「仕入情報_店舗別売上種別別_yyyyMMddHHmmssfff.csv」とする。
               *
               * - パラメータから一覧取得条件を作成する。
               * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
               * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
               * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
               * - 集計対象に請求を指定した場合、請求月で抽出を行う。
               * - 請求月の指定がない場合当月とする。
               * - 値引き価格表示ありの場合は、値引き後の価格とする。
               * - DBから結果を取得する。
               * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
               * - 上記の内容で処理を開始する。
               * ### 並び順
               * - 店舗コード
               * - 売上種別コード
               *
               * ### HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * - 403 権限のない集計単位の指定
               *
               * ### CSVカラム
               * 1. 店舗コード
               * 1. 店舗名
               * 1. 売上種別(複数あり)
               * @returns 正常処理
               */
              post: (option: { body: Methods_199u3kd['post']['reqBody'], config?: T | undefined }) =>
                fetch<Methods_199u3kd['post']['resBody'], BasicHeaders, Methods_199u3kd['post']['status']>(prefix, PATH105, POST, option).json(),
              /**
               * ### 概要
               * - 仕入情報の店舗別売上種別別で一覧をCSVファイルダウンロード処理受付する。
               * - ダウンロードのための、ダウンロードIDが返却される。
               *
               * ### 処理仕様
               *
               * - 検索条件に合致する店舗別売上種別別結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
               * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
               *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
               *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
               *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
               * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
               * - ダウンロードする場合のファイル名は「仕入情報_店舗別売上種別別_yyyyMMddHHmmssfff.csv」とする。
               *
               * - パラメータから一覧取得条件を作成する。
               * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
               * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
               * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
               * - 集計対象に請求を指定した場合、請求月で抽出を行う。
               * - 請求月の指定がない場合当月とする。
               * - 値引き価格表示ありの場合は、値引き後の価格とする。
               * - DBから結果を取得する。
               * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
               * - 上記の内容で処理を開始する。
               * ### 並び順
               * - 店舗コード
               * - 売上種別コード
               *
               * ### HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * - 403 権限のない集計単位の指定
               *
               * ### CSVカラム
               * 1. 店舗コード
               * 1. 店舗名
               * 1. 売上種別(複数あり)
               * @returns 正常処理
               */
              $post: (option: { body: Methods_199u3kd['post']['reqBody'], config?: T | undefined }) =>
                fetch<Methods_199u3kd['post']['resBody'], BasicHeaders, Methods_199u3kd['post']['status']>(prefix, PATH105, POST, option).json().then(r => r.body),
              $path: () => `${prefix}${PATH105}`,
            },
            /**
             * ### 概要
             * 仕入情報の店舗別売上種別別で一覧を取得する。
             * ### 処理仕様
             * - パラメータから一覧取得条件を作成する。
             * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
             * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
             * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
             * - 集計対象に請求を指定した場合、請求月で抽出を行う。
             * - 請求月の指定がない場合当月とする。
             * - 値引き価格表示ありの場合は、値引き後の価格とする。
             * - DBから結果を取得する。
             * - 結果を返す。
             *
             * ### 並び順
             * - 店舗コード
             * - 売上種別コード
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 権限のない集計単位の指定
             *
             * ### カラム
             * | No. | dataField | headerName | type |
             * |-----|-----------|------------|------|
             * | 1 | storeCode | 店舗コード | string |
             * | 2 | storeName | 店舗名 | string |
             * | 3 | price | 売上種別ごとの金額(複数あり) | integer |
             * @returns 正常処理
             */
            get: (option: { query: Methods_j5lgc4['get']['query'], config?: T | undefined }) =>
              fetch<Methods_j5lgc4['get']['resBody'], BasicHeaders, Methods_j5lgc4['get']['status']>(prefix, PATH104, GET, option).json(),
            /**
             * ### 概要
             * 仕入情報の店舗別売上種別別で一覧を取得する。
             * ### 処理仕様
             * - パラメータから一覧取得条件を作成する。
             * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
             * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
             * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
             * - 集計対象に請求を指定した場合、請求月で抽出を行う。
             * - 請求月の指定がない場合当月とする。
             * - 値引き価格表示ありの場合は、値引き後の価格とする。
             * - DBから結果を取得する。
             * - 結果を返す。
             *
             * ### 並び順
             * - 店舗コード
             * - 売上種別コード
             *
             * ### HTTPレスポンス
             * - 200 正常
             * - 400 パラメータ不正
             * - 401 未ログイン
             * - 403 権限のない集計単位の指定
             *
             * ### カラム
             * | No. | dataField | headerName | type |
             * |-----|-----------|------------|------|
             * | 1 | storeCode | 店舗コード | string |
             * | 2 | storeName | 店舗名 | string |
             * | 3 | price | 売上種別ごとの金額(複数あり) | integer |
             * @returns 正常処理
             */
            $get: (option: { query: Methods_j5lgc4['get']['query'], config?: T | undefined }) =>
              fetch<Methods_j5lgc4['get']['resBody'], BasicHeaders, Methods_j5lgc4['get']['status']>(prefix, PATH104, GET, option).json().then(r => r.body),
            $path: (option?: { method?: 'get' | undefined; query: Methods_j5lgc4['get']['query'] } | undefined) =>
              `${prefix}${PATH104}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
          },
          /**
           * ### 概要
           * 仕入情報の店舗別で一覧を取得する。
           * ### 処理仕様
           * - パラメータから一覧取得条件を作成する。
           * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
           * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
           * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
           * - 集計対象に請求を指定した場合、請求月で抽出を行う。
           * - 請求月の指定がない場合当月とする。
           * - 値引き価格表示ありの場合は、値引き後の価格とする。
           * - DBから結果を取得する。
           * - 結果を返す。
           * - (追記)出荷数量で「０」の場合、「欠品」として表示する。
           *
           * ### 並び順
           * - 店舗コード
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * - 403 権限のない集計単位の指定
           *
           * ### カラム
           * | No. | dataField | headerName | type |
           * |-----|-----------|------------|------|
           * | 1 | storeCode | 店舗コード | string |
           * | 2 | storeName | 店舗名 | string |
           * | 3 | orderQuantity | 受注数量 | integer |
           * | 4 | quantity | 出荷数量 | string |
           * | 5 | salonPrice | サロン価格 | integer |
           * @returns 正常処理
           */
          get: (option: { query: Methods_1xfuhbr['get']['query'], config?: T | undefined }) =>
            fetch<Methods_1xfuhbr['get']['resBody'], BasicHeaders, Methods_1xfuhbr['get']['status']>(prefix, PATH100, GET, option).json(),
          /**
           * ### 概要
           * 仕入情報の店舗別で一覧を取得する。
           * ### 処理仕様
           * - パラメータから一覧取得条件を作成する。
           * - 集計単位でユーザに対して対応していない集計単位を指定した場合は400を返す。
           * - 店舗コードの指定がない場合、すべて対象の店舗が検索される。
           * - 集計対象に注文を指定した場合、注文日、または、出荷日が必須で抽出を行う。
           * - 集計対象に請求を指定した場合、請求月で抽出を行う。
           * - 請求月の指定がない場合当月とする。
           * - 値引き価格表示ありの場合は、値引き後の価格とする。
           * - DBから結果を取得する。
           * - 結果を返す。
           * - (追記)出荷数量で「０」の場合、「欠品」として表示する。
           *
           * ### 並び順
           * - 店舗コード
           *
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * - 403 権限のない集計単位の指定
           *
           * ### カラム
           * | No. | dataField | headerName | type |
           * |-----|-----------|------------|------|
           * | 1 | storeCode | 店舗コード | string |
           * | 2 | storeName | 店舗名 | string |
           * | 3 | orderQuantity | 受注数量 | integer |
           * | 4 | quantity | 出荷数量 | string |
           * | 5 | salonPrice | サロン価格 | integer |
           * @returns 正常処理
           */
          $get: (option: { query: Methods_1xfuhbr['get']['query'], config?: T | undefined }) =>
            fetch<Methods_1xfuhbr['get']['resBody'], BasicHeaders, Methods_1xfuhbr['get']['status']>(prefix, PATH100, GET, option).json().then(r => r.body),
          $path: (option?: { method?: 'get' | undefined; query: Methods_1xfuhbr['get']['query'] } | undefined) =>
            `${prefix}${PATH100}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
        },
      },
      receipts: {
        _receiptId: (val2: string) => {
          const prefix2 = `${PATH106}/${val2}`;

          return {
            download: {
              /**
               * ### 仕様
               * - 指定された領収書をダウンロードします。
               * - ダウンロード可能な領収書のみダウンロードできます。
               *
               * ### HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * - 404 存在しない領収書IDの場合
               * @returns 正常処理
               */
              get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1tr9p2q['get']['resBody'], BasicHeaders, Methods_1tr9p2q['get']['status']>(prefix, `${prefix2}${PATH28}`, GET, option).blob(),
              /**
               * ### 仕様
               * - 指定された領収書をダウンロードします。
               * - ダウンロード可能な領収書のみダウンロードできます。
               *
               * ### HTTPレスポンス
               * - 200 正常
               * - 400 パラメータ不正
               * - 401 未ログイン
               * - 404 存在しない領収書IDの場合
               * @returns 正常処理
               */
              $get: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1tr9p2q['get']['resBody'], BasicHeaders, Methods_1tr9p2q['get']['status']>(prefix, `${prefix2}${PATH28}`, GET, option).blob().then(r => r.body),
              $path: () => `${prefix}${prefix2}${PATH28}`,
            },
          };
        },
      },
      receive_email: {
        /**
         * ログインユーザメール受信取得
         * @returns 正常処理
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_1uncd14['get']['resBody'], BasicHeaders, Methods_1uncd14['get']['status']>(prefix, PATH107, GET, option).json(),
        /**
         * ログインユーザメール受信取得
         * @returns 正常処理
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_1uncd14['get']['resBody'], BasicHeaders, Methods_1uncd14['get']['status']>(prefix, PATH107, GET, option).json().then(r => r.body),
        /**
         * ユーザメール受信設定更新
         * @returns 正常処理
         */
        put: (option: { body: Methods_1uncd14['put']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_1uncd14['put']['resBody'], BasicHeaders, Methods_1uncd14['put']['status']>(prefix, PATH107, PUT, option).json(),
        /**
         * ユーザメール受信設定更新
         * @returns 正常処理
         */
        $put: (option: { body: Methods_1uncd14['put']['reqBody'], config?: T | undefined }) =>
          fetch<Methods_1uncd14['put']['resBody'], BasicHeaders, Methods_1uncd14['put']['status']>(prefix, PATH107, PUT, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH107}`,
      },
      sales_details: {
        download: {
          /**
           * ### 概要
           * - 売上明細の一覧を取得しCSVをダウンロード処理受付する。
           * - 検索結果が0件の場合、ヘッダのみを返却する。
           * - ダウンロードのための、ダウンロードIDが返却される。
           * ### 処理仕様
           *
           * - 検索条件に合致する売上明細結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
           * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
           *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
           *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
           *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
           * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
           * - ダウンロードする場合のファイル名は「仕入情報_売上明細_yyyyMMddHHmmssfff.csv」とする。
           *
           * - パラメータから検索条件を作成する。
           * - 指定された集計単位の店舗コードを対象に検索する。店舗コードが指定されている場合、指定された店舗コードで検索する。
           * - 集計対象に注文を指定した場合、注文日、または、出荷日で抽出する。注文日、出荷日の指定がない場合、当月分の注文日を指定する。
           * - 商品コードは前方一致で絞り込みを行う。
           * - 集計対象に請求を指定した場合、請求月で抽出を行する。請求月の指定がない場合、当月の請求月を指定する。
           * - DBから売上明細情報を取得する。
           * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
           * - 結果を返す。
           * ### 並び順
           * 1. 受注日の降順
           * 1. 売上番号
           * 1. 売上行番号
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * - 403 権限のない集計単位の指定
           * ### CSVカラム
           * 1. 受注日
           * 1. 出荷日
           * 1. 売上番号
           * 1. 売上行番号
           * 1. 店舗コード
           * 1. 店舗名
           * 1. 売上種別
           * 1. メーカー
           * 1. 商品コード
           * 1. 商品名
           * 1. JANコード
           * 1. カテゴリ
           * 1. 数量
           * 1. 単価
           * 1. 金額
           * 1. 備考
           * 1. サロン価格
           * 1. メーカー希望小売価格
           * 1. 取り込み番号
           * @returns 正常処理
           */
          post: (option: { body: Methods_2ztxoo['post']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_2ztxoo['post']['resBody'], BasicHeaders, Methods_2ztxoo['post']['status']>(prefix, PATH109, POST, option).json(),
          /**
           * ### 概要
           * - 売上明細の一覧を取得しCSVをダウンロード処理受付する。
           * - 検索結果が0件の場合、ヘッダのみを返却する。
           * - ダウンロードのための、ダウンロードIDが返却される。
           * ### 処理仕様
           *
           * - 検索条件に合致する売上明細結果を抽出し、抽出結果をCSVファイルとしてS3に保存する。
           * - ただし、大量データの処理を複数同時に行うことでDBへの負荷が大きくなることを避けるため、以下のように処理を行う。
           *     - リクエストを受け付けた後、バリデーションエラーがない場合には、ダウンロードIDを発番し、即座にAPIのレスポンスとして返す。
           *     - ダウンロードIDの単位でリクエストをキューに格納し、キューから取り出して行う処理の同時実行数はシステム全体で1とする。
           *     - キューから取り出した後は、リクエスト時の検索条件に合致するデータを抽出し、抽出結果をCSVファイルとしてS3に保存する。
           * - 処理終了の確認、及びファイルのダウンロードは、仕入情報CSVダウンロードAPIにて行う。
           * - ダウンロードする場合のファイル名は「仕入情報_売上明細_yyyyMMddHHmmssfff.csv」とする。
           *
           * - パラメータから検索条件を作成する。
           * - 指定された集計単位の店舗コードを対象に検索する。店舗コードが指定されている場合、指定された店舗コードで検索する。
           * - 集計対象に注文を指定した場合、注文日、または、出荷日で抽出する。注文日、出荷日の指定がない場合、当月分の注文日を指定する。
           * - 商品コードは前方一致で絞り込みを行う。
           * - 集計対象に請求を指定した場合、請求月で抽出を行する。請求月の指定がない場合、当月の請求月を指定する。
           * - DBから売上明細情報を取得する。
           * - UTF-8 BOM形式CSVに整形しbase64でエンコードする。
           * - 結果を返す。
           * ### 並び順
           * 1. 受注日の降順
           * 1. 売上番号
           * 1. 売上行番号
           * ### HTTPレスポンス
           * - 200 正常
           * - 400 パラメータ不正
           * - 401 未ログイン
           * - 403 権限のない集計単位の指定
           * ### CSVカラム
           * 1. 受注日
           * 1. 出荷日
           * 1. 売上番号
           * 1. 売上行番号
           * 1. 店舗コード
           * 1. 店舗名
           * 1. 売上種別
           * 1. メーカー
           * 1. 商品コード
           * 1. 商品名
           * 1. JANコード
           * 1. カテゴリ
           * 1. 数量
           * 1. 単価
           * 1. 金額
           * 1. 備考
           * 1. サロン価格
           * 1. メーカー希望小売価格
           * 1. 取り込み番号
           * @returns 正常処理
           */
          $post: (option: { body: Methods_2ztxoo['post']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_2ztxoo['post']['resBody'], BasicHeaders, Methods_2ztxoo['post']['status']>(prefix, PATH109, POST, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH109}`,
        },
        /**
         * ### 概要
         * - 売上明細の一覧を取得する。
         * ### 処理仕様
         * - パラメータから検索条件を作成する。
         * - 指定された集計単位の店舗コードを対象に検索する。店舗コードが指定されている場合、指定された店舗コードで検索する。
         * - 集計対象に注文を指定した場合、注文日、または、出荷日で抽出する。注文日、出荷日の指定がない場合、当月分の注文日を指定する。
         * - 商品コードは前方一致で絞り込みを行う。
         * - 集計対象に請求を指定した場合、請求月で抽出を行する。請求月の指定がない場合、当月の請求月を指定する。
         * - DBから明細情報を取得し返却する。
         * - (追記)出荷数量で「０」の場合、「欠品」として表示する。
         * ### 並び順
         * 1. 受注日の降順
         * 1. 売上番号
         * 1. 売上行番号
         * ### HTTPレスポンス
         * - 200 正常
         * - 400 パラメータ不正
         * - 401 未ログイン
         * - 403 権限のない集計単位の指定
         *
         * ### カラム
         * | No. | dataField | headerName | type |
         * |-----|-----------|------------|------|
         * | 1 | orderDate | 受注日 | string |
         * | 2 | shippingDate | 出荷日 | string |
         * | 3 | salesNo | 売上番号 | string |
         * | 4 | salesRowNo | 売上行番号 | string |
         * | 5 | storeCode | 店舗コード | string |
         * | 6 | storeName | 店舗名 | string |
         * | 7 | salesType | 売上種別 | string |
         * | 8 | makerName | メーカー | string |
         * | 9 | itemCode | 商品コード | string |
         * | 10 | itemName | 商品名 | string |
         * | 11 | janCode | JANコード | string |
         * | 12 | categoryName | カテゴリ | string |
         * | 13 | orderQuantity | 受注数量 | integer |
         * | 14 | quantity | 出荷数量 | string |
         * | 15 | discountPrice| 単価 | integer |
         * | 16 | totalPrice | 金額 | integer |
         * | 17 | note | 備考 | string |
         * | 18 | salonPrice | サロン価格 | integer |
         * | 19 | retailPrice | メーカー希望小売価格 | integer |
         * | 20 | importNo | 取り込み番号 | string |
         * @returns 正常処理
         */
        get: (option: { query: Methods_1425bc7['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1425bc7['get']['resBody'], BasicHeaders, Methods_1425bc7['get']['status']>(prefix, PATH108, GET, option).json(),
        /**
         * ### 概要
         * - 売上明細の一覧を取得する。
         * ### 処理仕様
         * - パラメータから検索条件を作成する。
         * - 指定された集計単位の店舗コードを対象に検索する。店舗コードが指定されている場合、指定された店舗コードで検索する。
         * - 集計対象に注文を指定した場合、注文日、または、出荷日で抽出する。注文日、出荷日の指定がない場合、当月分の注文日を指定する。
         * - 商品コードは前方一致で絞り込みを行う。
         * - 集計対象に請求を指定した場合、請求月で抽出を行する。請求月の指定がない場合、当月の請求月を指定する。
         * - DBから明細情報を取得し返却する。
         * - (追記)出荷数量で「０」の場合、「欠品」として表示する。
         * ### 並び順
         * 1. 受注日の降順
         * 1. 売上番号
         * 1. 売上行番号
         * ### HTTPレスポンス
         * - 200 正常
         * - 400 パラメータ不正
         * - 401 未ログイン
         * - 403 権限のない集計単位の指定
         *
         * ### カラム
         * | No. | dataField | headerName | type |
         * |-----|-----------|------------|------|
         * | 1 | orderDate | 受注日 | string |
         * | 2 | shippingDate | 出荷日 | string |
         * | 3 | salesNo | 売上番号 | string |
         * | 4 | salesRowNo | 売上行番号 | string |
         * | 5 | storeCode | 店舗コード | string |
         * | 6 | storeName | 店舗名 | string |
         * | 7 | salesType | 売上種別 | string |
         * | 8 | makerName | メーカー | string |
         * | 9 | itemCode | 商品コード | string |
         * | 10 | itemName | 商品名 | string |
         * | 11 | janCode | JANコード | string |
         * | 12 | categoryName | カテゴリ | string |
         * | 13 | orderQuantity | 受注数量 | integer |
         * | 14 | quantity | 出荷数量 | string |
         * | 15 | discountPrice| 単価 | integer |
         * | 16 | totalPrice | 金額 | integer |
         * | 17 | note | 備考 | string |
         * | 18 | salonPrice | サロン価格 | integer |
         * | 19 | retailPrice | メーカー希望小売価格 | integer |
         * | 20 | importNo | 取り込み番号 | string |
         * @returns 正常処理
         */
        $get: (option: { query: Methods_1425bc7['get']['query'], config?: T | undefined }) =>
          fetch<Methods_1425bc7['get']['resBody'], BasicHeaders, Methods_1425bc7['get']['status']>(prefix, PATH108, GET, option).json().then(r => r.body),
        $path: (option?: { method?: 'get' | undefined; query: Methods_1425bc7['get']['query'] } | undefined) =>
          `${prefix}${PATH108}${option && option.query ? `?${dataToURLString(option.query)}` : ''}`,
      },
      sales_types: {
        /**
         * 売上種別一覧を取得します。
         * 取得結果の並び順は、売上種別コードの昇順になります。
         * @returns 正常処理
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_1w4idik['get']['resBody'], BasicHeaders, Methods_1w4idik['get']['status']>(prefix, PATH110, GET, option).json(),
        /**
         * 売上種別一覧を取得します。
         * 取得結果の並び順は、売上種別コードの昇順になります。
         * @returns 正常処理
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_1w4idik['get']['resBody'], BasicHeaders, Methods_1w4idik['get']['status']>(prefix, PATH110, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH110}`,
      },
      stores: {
        me: {
          /**
           * ログイン中の店舗情報を取得します。
           * @returns 正常処理
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_4ippvp['get']['resBody'], BasicHeaders, Methods_4ippvp['get']['status']>(prefix, PATH112, GET, option).json(),
          /**
           * ログイン中の店舗情報を取得します。
           * @returns 正常処理
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_4ippvp['get']['resBody'], BasicHeaders, Methods_4ippvp['get']['status']>(prefix, PATH112, GET, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH112}`,
        },
        /**
         * 店舗情報一覧取得
         * 店舗コードで昇順
         * @returns 正常処理
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_11il3rq['get']['resBody'], BasicHeaders, Methods_11il3rq['get']['status']>(prefix, PATH111, GET, option).json(),
        /**
         * 店舗情報一覧取得
         * 店舗コードで昇順
         * @returns 正常処理
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_11il3rq['get']['resBody'], BasicHeaders, Methods_11il3rq['get']['status']>(prefix, PATH111, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH111}`,
      },
      stores_for_invoice: {
        /**
         * ### 概要
         * ログインユーザーの選択可能な請求先店舗を取得する。
         *
         * ### 処理仕様
         *
         * - ログインユーザの所属店舗を確認する。
         * - 入金親の場合、紐づく請求先の店舗情報を取得する。
         * - 請求先店舗の場合、自店舗の店舗情報を取得する。
         * - 結果を返す。
         *
         * ### 店舗並び順
         * - 店舗名の昇順
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 401 未ログイン
         * @returns 正常処理
         */
        get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_u24rgi['get']['resBody'], BasicHeaders, Methods_u24rgi['get']['status']>(prefix, PATH113, GET, option).json(),
        /**
         * ### 概要
         * ログインユーザーの選択可能な請求先店舗を取得する。
         *
         * ### 処理仕様
         *
         * - ログインユーザの所属店舗を確認する。
         * - 入金親の場合、紐づく請求先の店舗情報を取得する。
         * - 請求先店舗の場合、自店舗の店舗情報を取得する。
         * - 結果を返す。
         *
         * ### 店舗並び順
         * - 店舗名の昇順
         *
         * ### HTTPレスポンス
         * - 200 正常
         * - 401 未ログイン
         * @returns 正常処理
         */
        $get: (option?: { config?: T | undefined } | undefined) =>
          fetch<Methods_u24rgi['get']['resBody'], BasicHeaders, Methods_u24rgi['get']['status']>(prefix, PATH113, GET, option).json().then(r => r.body),
        $path: () => `${prefix}${PATH113}`,
      },
      tests: {
        cart: {
          delivery_date: {
            one_day_ago: {
              /**
               * このAPIはテスト用です。<br/>
               * ご希望納品日が最短納品日より過去の場合でもエラーにならないように<br/>
               * ログインユーザーのご希望納品日をAPI実行日の前日(1日前)に更新します。<br/>
               * カート用にご希望納品日の設定が出来ます。<br/>
               * 処理成功時は、設定したカート情報を返却します。<br/>
               * <br/>
               * このAPIで設定したカートは10分で揮発します。<br/>
               * <br/>
               * 以下のレスポンスはHTTPステータスのみの返却となります。<br/>
               *
               * <ul>
               * <li>401：認証に失敗した場合。</li>
               * </ul>
               * @returns 正常処理
               */
              put: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1rsisys['put']['resBody'], BasicHeaders, Methods_1rsisys['put']['status']>(prefix, PATH114, PUT, option).json(),
              /**
               * このAPIはテスト用です。<br/>
               * ご希望納品日が最短納品日より過去の場合でもエラーにならないように<br/>
               * ログインユーザーのご希望納品日をAPI実行日の前日(1日前)に更新します。<br/>
               * カート用にご希望納品日の設定が出来ます。<br/>
               * 処理成功時は、設定したカート情報を返却します。<br/>
               * <br/>
               * このAPIで設定したカートは10分で揮発します。<br/>
               * <br/>
               * 以下のレスポンスはHTTPステータスのみの返却となります。<br/>
               *
               * <ul>
               * <li>401：認証に失敗した場合。</li>
               * </ul>
               * @returns 正常処理
               */
              $put: (option?: { config?: T | undefined } | undefined) =>
                fetch<Methods_1rsisys['put']['resBody'], BasicHeaders, Methods_1rsisys['put']['status']>(prefix, PATH114, PUT, option).json().then(r => r.body),
              $path: () => `${prefix}${PATH114}`,
            },
          },
        },
      },
      user: {
        language: {
          /**
           * ### 仕様
           * - ユーザーの優先言語設定を更新します。
           * - 言語コードはISO 639-1形式（en, ja）で指定する必要があります。
           * - レスポンスメッセージはユーザーの新しく設定された優先言語に従って表示されます。
           *
           * ### 言語選択ロジック
           * システムは以下の優先順位で言語を決定します：
           * 1. **ユーザーデータベース設定**（最優先）
           *    - データベースに言語設定がある場合はその言語を使用
           * 2. **Accept-Languageヘッダー**（中優先）
           *    - データベースに設定がない場合、Accept-Languageヘッダーを確認
           *    - ヘッダーにサポート言語（enまたはja）が含まれる場合はその言語を使用
           * 3. **デフォルト設定**（最低優先）
           *    - ヘッダーが存在しない、空、またはサポートされていない言語の場合は日本語（ja）をデフォルトとして使用
           *
           * ### HTTPレスポンス
           * - 200 正常 - 言語設定が更新された
           * - 400 パラメータ不正 - サポートされていない言語コードが指定された
           * - 401 未ログイン
           * @returns 正常処理
           */
          put: (option: { body: Methods_2zofny['put']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_2zofny['put']['resBody'], BasicHeaders, Methods_2zofny['put']['status']>(prefix, PATH115, PUT, option).json(),
          /**
           * ### 仕様
           * - ユーザーの優先言語設定を更新します。
           * - 言語コードはISO 639-1形式（en, ja）で指定する必要があります。
           * - レスポンスメッセージはユーザーの新しく設定された優先言語に従って表示されます。
           *
           * ### 言語選択ロジック
           * システムは以下の優先順位で言語を決定します：
           * 1. **ユーザーデータベース設定**（最優先）
           *    - データベースに言語設定がある場合はその言語を使用
           * 2. **Accept-Languageヘッダー**（中優先）
           *    - データベースに設定がない場合、Accept-Languageヘッダーを確認
           *    - ヘッダーにサポート言語（enまたはja）が含まれる場合はその言語を使用
           * 3. **デフォルト設定**（最低優先）
           *    - ヘッダーが存在しない、空、またはサポートされていない言語の場合は日本語（ja）をデフォルトとして使用
           *
           * ### HTTPレスポンス
           * - 200 正常 - 言語設定が更新された
           * - 400 パラメータ不正 - サポートされていない言語コードが指定された
           * - 401 未ログイン
           * @returns 正常処理
           */
          $put: (option: { body: Methods_2zofny['put']['reqBody'], config?: T | undefined }) =>
            fetch<Methods_2zofny['put']['resBody'], BasicHeaders, Methods_2zofny['put']['status']>(prefix, PATH115, PUT, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH115}`,
        },
        me: {
          /**
           * ユーザ情報を取得します。レスポンスには優先言語設定（preferredLanguage）が含まれており、
           * これはユーザーインターフェースの言語とシステムメッセージの表示言語を決定します。
           * @returns 正常処理
           */
          get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_z5ns5m['get']['resBody'], BasicHeaders, Methods_z5ns5m['get']['status']>(prefix, PATH116, GET, option).json(),
          /**
           * ユーザ情報を取得します。レスポンスには優先言語設定（preferredLanguage）が含まれており、
           * これはユーザーインターフェースの言語とシステムメッセージの表示言語を決定します。
           * @returns 正常処理
           */
          $get: (option?: { config?: T | undefined } | undefined) =>
            fetch<Methods_z5ns5m['get']['resBody'], BasicHeaders, Methods_z5ns5m['get']['status']>(prefix, PATH116, GET, option).json().then(r => r.body),
          $path: () => `${prefix}${PATH116}`,
        },
      },
    },
  };
};

export type ApiInstance = ReturnType<typeof api>;
export default api;
